<template>
    <OrderModifyDiv>
        <OrderUpClientArea>
            <OrderUpTitleArea>
                <RentalTitle>대여정보</RentalTitle>
            </OrderUpTitleArea>

            <!-- !수급자 정보 테이블-->
            <OrderUpClientTable>
                <thead></thead>
                <tbody>
                    <!-- * 회수 정보 -->
                    <tr v-if="isReturned && returnInfo">
                        <OrderModifyClientTableTd>회수일자</OrderModifyClientTableTd>
                        <td>
                            <Datepicker :value="parsedReturnDate" placeholder="회수일자" readonly disabled
                                style="width: 162px; height: 35px;" :class="{ 'blurred': isTestUser }" :lang="ko" />
                        </td>
                        <OrderModifyClientTableTd>회수사유</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientInputTxtW150 type="text" :value="returnInfo.returnReason" readonly
                                :class="{ 'blurred': isTestUser }" />
                        </td>
                    </tr>
                    <tr>
                        <OrderModifyClientTableTd>주문일자</OrderModifyClientTableTd>
                        <td>
                            <Datepicker v-model:value="orderDate" placeholder="주문일자" style="width:162px;height:35px;"
                                readonly disabled :class="{ 'blurred': isTestUser }" :lang="ko" />
                        </td>
                        <OrderModifyClientTableTd>CMS 출금상태</OrderModifyClientTableTd>
                    </tr>
                    <tr>
                        <OrderModifyClientTableTd>수급자성함</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.name" readonly
                                :class="{ 'blurred': isTestUser }" />
                        </td>
                        <OrderModifyClientTableTd>인정번호</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientInputTxtW150 type="text" placeholder="요양인정번호 10자리"
                                v-model="client_data_obj.number" readonly :class="{ 'blurred': isTestUser }" />
                        </td>
                    </tr>
                    <tr v-if="hasRentalProduct">
                        <OrderModifyClientTableTd>대여시작일</OrderModifyClientTableTd>
                        <td>
                            <Datepicker v-model:value="client_data_obj.rental_start" placeholder="대여시작일"
                                style="width:162px;height:35px;color:#333;" :class="{ 'blurred': isTestUser }"
                                :lang="ko" />
                        </td>
                        <OrderModifyClientTableTd>대여종료일</OrderModifyClientTableTd>
                        <td>
                            <Datepicker v-model:value="client_data_obj.rental_end" placeholder="대여종료일"
                                style="width:162px;height:35px;color:#333;" :class="{ 'blurred': isTestUser }"
                                :lang="ko" />
                        </td>
                    </tr>
                    <tr v-if="hasOxygenGenerator">
                        <OrderModifyClientTableTd>산소치료<br />처방시작일</OrderModifyClientTableTd>
                        <td>
                            <Datepicker v-model:value="client_data_obj.oxygen_start" placeholder="처방시작일"
                                style="width:162px; height:35px;" :class="{ 'blurred': isTestUser }" :lang="ko" />
                        </td>
                        <OrderModifyClientTableTd>산소치료<br />처방종료일</OrderModifyClientTableTd>
                        <td>
                            <Datepicker v-model:value="client_data_obj.oxygen_end" placeholder="처방종료일"
                                style="width:162px; height:35px;" :class="{ 'blurred': isTestUser }" :lang="ko" />
                        </td>
                    </tr>
                    <tr v-if="hasDiabetesProduct">
                        <OrderModifyClientTableTd>당뇨소모성재료<br />처방시작일</OrderModifyClientTableTd>
                        <td>
                            <Datepicker v-model:value="client_data_obj.diabetes_start" placeholder="처방시작일"
                                style="width:162px; height:35px;" :class="{ 'blurred': isTestUser }" :lang="ko" />
                        </td>
                        <OrderModifyClientTableTd>당뇨소모성재료<br />처방종료일</OrderModifyClientTableTd>
                        <td>
                            <Datepicker v-model:value="client_data_obj.diabetes_end" placeholder="처방종료일"
                                style="width:162px; height:35px;" :class="{ 'blurred': isTestUser }" :lang="ko" />
                        </td>
                    </tr>
                    <tr>
                        <OrderModifyClientTableTd>주소1<br />(배송주소)</OrderModifyClientTableTd>
                        <td>
                            <orderUpClientAddressBtn @click="openDaumPostcode(1)" disabled>주소 검색
                            </orderUpClientAddressBtn>
                            <OrderUpClientInputTxtW150 v-model="postcode_obj.postcode1" type="text" placeholder="우편번호"
                                readonly :class="{ 'blurred': isTestUser }" /><br>
                        </td>
                        <td colspan="2">
                            <OrderUpClientInputTxtW260 v-model="postcode_obj.address1" type="text" placeholder="주소"
                                readonly :class="{ 'blurred': isTestUser }" />
                            <OrderUpClientInputTxtW260 v-model="postcode_obj.detailAddress1" type="text"
                                placeholder="상세주소" readonly :class="{ 'blurred': isTestUser }" />
                        </td>
                    </tr>
                    <tr>
                        <OrderModifyClientTableTd>주소2</OrderModifyClientTableTd>
                        <td>
                            <orderUpClientAddressBtn @click="openDaumPostcode(2)" disabled>주소 검색
                            </orderUpClientAddressBtn>
                            <OrderUpClientInputTxtW150 v-model="postcode_obj.postcode2" type="text" placeholder="우편번호"
                                readonly :class="{ 'blurred': isTestUser }" /><br>
                        </td>
                        <td colspan="2">
                            <OrderUpClientInputTxtW260 v-model="postcode_obj.address2" type="text" placeholder="주소"
                                readonly :class="{ 'blurred': isTestUser }" />
                            <OrderUpClientInputTxtW260 v-model="postcode_obj.detailAddress2" type="text"
                                placeholder="상세주소" readonly :class="{ 'blurred': isTestUser }" />
                        </td>
                    </tr>
                    <tr>
                        <OrderModifyClientTableTd>보호자성함</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.guardname" readonly
                                :class="{ 'blurred': isTestUser }" />
                        </td>
                        <OrderModifyClientTableTd>수급자관계</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.guardtarget" readonly
                                :class="{ 'blurred': isTestUser }" />
                        </td>
                    </tr>
                    <tr>
                        <OrderModifyClientTableTd>연락처1</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.phone1" readonly
                                :class="{ 'blurred': isTestUser }" />
                        </td>
                        <OrderModifyClientTableTd>연락처2</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.phone2" readonly
                                :class="{ 'blurred': isTestUser }" />
                        </td>
                    </tr>
                    <tr>
                        <OrderModifyClientTableTd>센터명</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.centername" readonly
                                :class="{ 'blurred': isTestUser }" />
                        </td>
                        <OrderModifyClientTableTd>담당자</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientSelectW162 v-model="client_data_obj.manager" disabled
                                :class="{ 'blurred': isTestUser }">
                                <option v-for="managerItem in manager" :key="managerItem.name" :value="managerItem.name"
                                    :selected="managerItem.name === client_data_obj.manager">{{
                                        managerItem.name }}</option>
                            </OrderUpClientSelectW162>
                        </td>
                    </tr>
                    <tr>
                        <OrderModifyClientTableTd>배송방법</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientSelectW162 v-model="deliveryMethod">
                                <option value="1">내방</option>
                                <option value="2">물류 (기관배송)</option>
                                <option value="3">택배</option>
                                <option value="4">소독업체</option>
                                <option value="5">공급업체</option>
                            </OrderUpClientSelectW162>
                        </td>
                        <OrderModifyClientTableTd>배송상태</OrderModifyClientTableTd>
                        <td>
                            <OrderUpClientSelectW162 v-model="deliveryStatus">
                                <option value="1">배송완료</option>
                                <option value="2">배송대기</option>
                                <option value="3">회수중</option>
                                <option value="4">회수완료</option>
                                <option value="5">배송중</option>
                            </OrderUpClientSelectW162>
                        </td>
                    </tr>
                    <OrderUpClientTableTr>
                        <OrderModifyClientTableTd>배송요청일/시</OrderModifyClientTableTd>
                        <td>
                            <Datepicker v-model:value="delivery_date" placeholder="배송요청일시"
                                style="width:162px; height:35px;" :lang="ko" /><br />
                            <OrderUpClientSelectW162 v-model="delivery_time">
                                <option value="0">오전</option>
                                <option value="1">오후</option>
                            </OrderUpClientSelectW162>
                        </td>
                    </OrderUpClientTableTr>
                </tbody>
            </OrderUpClientTable>

            <!-- ! 메모 영역 -->
            <MemoContainer>
                <MemoSection>
                    <MemoInputArea>
                        <MemoInput v-model="orderCommentAdd" @keyup.enter="commentAdd" placeholder="메모를 입력해주세요." />
                        <MemoButton @click="commentAdd">입력</MemoButton>
                    </MemoInputArea>
                </MemoSection>
                <MemoHistoryItem v-for="(comment, index) in orderComment" :key="index"
                    :class="{ 'memo-text-blur': isTestUser }">
                    <MemoHistoryHeader>
                        <UserInfo>
                            <span class="manager">{{ comment.manager }}</span>
                            <span class="date">{{ comment.updated_at }}</span>
                        </UserInfo>
                        <DeleteButton @click="deleteComment(comment.num)">
                            <Close />
                        </DeleteButton>
                    </MemoHistoryHeader>
                    <MemoHistoryContent>
                        <span>{{ comment.text }}</span>
                    </MemoHistoryContent>
                </MemoHistoryItem>
            </MemoContainer>
        </OrderUpClientArea>

        <!-- !중앙(주문서 | 품목) Area -->
        <OrderModifyCenterArea></OrderModifyCenterArea>

        <!-- !품목 주문서 Area -->
        <OrderModifyProductArea>

            <!-- ! 현재 대여 내역 테이블 영역 -->
            <OrderUpProductTableContainer>
                <!-- *헤더 -->
                <ProductLabel>
                    <CenterSide>
                        <CenterContent>현재 대여 내역</CenterContent>
                    </CenterSide>
                    <ButtonArea>
                        <ButtonGroupLeft>
                            <HeaderButton @click="selectAllProducts">전체선택
                            </HeaderButton>
                            <HeaderButton @click="deselectAllProducts">선택해제
                            </HeaderButton>
                        </ButtonGroupLeft>
                        <ButtonGroupCenter>
                            <HeaderButton @click="openVirtualAccountModal">가상계좌 발송({{ virtualAccountCount }})건
                            </HeaderButton>
                            <HeaderButton @click="openSmsSendModal">문자 발송
                            </HeaderButton>
                        </ButtonGroupCenter>
                    </ButtonArea>
                </ProductLabel>

                <!-- * 테이블 -->
                <OrderUpProductTable>
                    <thead>
                        <OrderUpProductTableTheadTr>
                            <th>선택</th>
                            <th>바코드</th>
                            <th>품목분류</th>
                            <th>품목명</th>
                            <th>대여가격</th>
                            <th>대여연장</th>
                            <th>복사</th>
                        </OrderUpProductTableTheadTr>
                    </thead>
                    <tbody>
                        <tr v-for="(product, index) in products_obj" :key="index">
                            <!-- *선택 -->
                            <td style="text-align: center;">
                                <input type="checkbox" :checked="product.selected || false"
                                    @change="toggleProductSelection(index)"
                                    style="width: 20px; height: 20px; cursor: pointer;" />
                            </td>
                            <!-- *바코드 -->
                            <td>
                                <OrderUpProductTableInputTxt type="text" :value="product.options?.bcode[0]"
                                    :placeholder="'바코드'" readonly
                                    style="background-color: #f5f5f5; color: #666; cursor: not-allowed;" />
                            </td>
                            <!-- *품목분류 -->
                            <td :title="`${product.hub_product_id ? product.name : product.name1 || product.name}`">
                                <!-- service_hub 제품인 경우 (hub_product_id가 있으면) -->
                                <template v-if="product.hub_product_id">
                                    <div v-if="product.code" style="font-size: 11px; color: #666;">
                                        {{ product.code }}
                                    </div>
                                    <div>{{ product.name || '품목명 없음' }}</div>
                                </template>
                                <!-- 일반 제품인 경우 (b_product_id가 있으면) -->
                                <template v-else-if="product.b_product_id">
                                    <div v-if="product.code" style="font-size: 11px; color: #666;">
                                        {{ product.code }}
                                    </div>
                                    <div>{{ product.name1 || '품목명 없음' }}</div>
                                </template>
                                <!-- 기타 경우 -->
                                <template v-else>
                                    <div v-if="product.code" style="font-size: 11px; color: #666;">
                                        {{ product.code }}
                                    </div>
                                    <div>{{ product.name || '품목명 없음' }}</div>
                                </template>
                            </td>
                            <!-- *품목명 -->
                            <td>{{ product.b_product_id > 999999 ? product.name3 : product.name2 }}</td>
                            <!-- *대여가격 -->
                            <td>{{ format.price(product.selected_target === '대여' ? product.setRentprice :
                                product.setBuyprice) }}원
                            </td>
                            <!-- * 대여연장 -->
                            <td>
                                <ExtendRentalContainer>
                                    <ExtendRentalInput type="number" :ref="`extendInput-${index}`"
                                        :data-extend-input="index" @click.stop min="1" value="" placeholder="일수" />
                                    <ExtendRentalIconButton @click.stop="handleExtendClick(index)" title="대여 종료일 연장">
                                        <TimerPlusOutline :size="25" :style="{ color: '#0f4c5c' }" />
                                    </ExtendRentalIconButton>
                                </ExtendRentalContainer>
                            </td>
                            <!-- * 복사 -->
                            <td>
                                <OrderCopyBtn @click.stop="copyOrderData">
                                    <ContentCopy />
                                </OrderCopyBtn>
                            </td>
                        </tr>
                    </tbody>
                </OrderUpProductTable>

                <!-- ! 주문합계 영역 -->
                <TotalSummaryContainer>
                    <SummaryRightContainer>
                        <TotalInfoItem>
                            <span>총 수량:</span>
                            <span>{{ totalQuantity }}개</span>
                        </TotalInfoItem>
                        <TotalInfoItem>
                            <span>총 합계:</span>
                            <span>{{ format.price(totalPrice) }}원</span>
                        </TotalInfoItem>
                    </SummaryRightContainer>
                </TotalSummaryContainer>
            </OrderUpProductTableContainer>

            <!-- ! 대여 이력 섹션 -->
            <RentalHistoryContainer v-if="rentalHistory.length > 0">
                <CenterSide>
                    <CenterContent>대여 이력</CenterContent>
                </CenterSide>

                <RentalHistoryList>
                    <RentalHistoryItem v-for="(period, index) in displayedRentalHistory" :key="period.periodNumber">
                        <RentalHistoryCard>
                            <RentalCardHeader>
                                <RentalCardContent>
                                    <PeriodBadge>{{ period.periodNumber }}회차</PeriodBadge>
                                    <InfoDivider />
                                    <PeriodInfo>
                                        <PeriodLabel>기간</PeriodLabel>
                                        <PeriodValue>{{ period.periodRange }}</PeriodValue>
                                    </PeriodInfo>
                                    <InfoDivider
                                        v-if="period.paymentType || period.paymentAmount || (period.memos && period.memos.length > 0)" />
                                    <PaymentInfoItem v-if="period.paymentType">
                                        <PaymentLabel>결제 수단</PaymentLabel>
                                        <PaymentValue>{{ period.paymentType }}</PaymentValue>
                                    </PaymentInfoItem>
                                    <InfoDivider
                                        v-if="period.paymentType && (period.paymentAmount || (period.memos && period.memos.length > 0))" />
                                    <PaymentInfoItem v-if="period.paymentAmount">
                                        <PaymentLabel>결제 금액</PaymentLabel>
                                        <PaymentAmount>{{ format.price(period.paymentAmount) }}원</PaymentAmount>
                                    </PaymentInfoItem>
                                    <InfoDivider
                                        v-if="period.memos && period.memos.length > 0 && (period.paymentType || period.paymentAmount)" />
                                    <PaymentStatusItem v-if="period.paymentStatus">
                                        <PaymentLabel>입금 처리</PaymentLabel>
                                        <!-- 편집 모드가 아닐 때: 클릭 가능한 배지 -->
                                        <PaymentStatusBadge v-if="editingPaymentStatusIndex !== index"
                                            :status="getPaymentStatusDisplay(period.paymentType, period.paymentStatus)"
                                            @click.stop="startPaymentStatusEdit(index, period.extensionHistory?.num)"
                                            style="cursor: pointer;" title="클릭하여 수정">
                                            {{ getPaymentStatusText(period.paymentType, period.paymentStatus) }}
                                        </PaymentStatusBadge>
                                        <!-- 편집 모드일 때: 상태 선택 버튼 그룹 -->
                                        <PaymentStatusSelector v-else>
                                            <PaymentStatusButton :active="period.paymentStatus === '대기'"
                                                @click.stop="updatePaymentStatus(period.extensionHistory?.num, '대기', index)">
                                                대기
                                            </PaymentStatusButton>
                                            <PaymentStatusButton :active="period.paymentStatus === '미납'"
                                                @click.stop="updatePaymentStatus(period.extensionHistory?.num, '미납', index)">
                                                미납
                                            </PaymentStatusButton>
                                            <PaymentStatusButton
                                                :active="period.paymentStatus === '납부' || period.paymentStatus === '입금'"
                                                @click.stop="updatePaymentStatus(period.extensionHistory?.num, '납부', index)">
                                                납부
                                            </PaymentStatusButton>
                                        </PaymentStatusSelector>
                                    </PaymentStatusItem>
                                    <InfoDivider
                                        v-if="period.memos && period.memos.length > 0 && (period.paymentType || period.paymentAmount || period.paymentStatus)" />
                                    <MemoSection v-if="period.memos && period.memos.length > 0">
                                        <RentalMemoItem v-for="(memo, memoIndex) in period.memos" :key="memoIndex">
                                            <HistoryMemoInput v-if="editingMemoIndex === memo.historyIndex"
                                                v-model="editingMemoValue"
                                                @blur="handleMemoBlur(memo.historyId, memo.historyIndex)"
                                                @keyup.enter="handleMemoEnter" @keydown.esc="cancelMemoEdit"
                                                placeholder="메모를 입력하세요" autofocus />
                                            <RentalMemoText v-else
                                                @click.stop="startMemoEdit(memo.memo || '', memo.historyIndex)"
                                                title="클릭하여 수정">
                                                {{ memo.memo || '메모를 입력하세요' }}
                                            </RentalMemoText>
                                        </RentalMemoItem>
                                    </MemoSection>
                                </RentalCardContent>
                                <RentalCardRight>
                                    <DeleteButtonWrapper v-if="period.extensionHistory || period.periodNumber === 1"
                                        @click="handleDeleteRentalHistory(period)">
                                        <Close :size="18" />
                                    </DeleteButtonWrapper>
                                </RentalCardRight>
                            </RentalCardHeader>
                        </RentalHistoryCard>
                    </RentalHistoryItem>
                </RentalHistoryList>

                <!-- 더 보기/접기 버튼 -->
                <ToggleHistoryButton v-if="hasMoreRentalHistory" @click="showAllRentalHistory = !showAllRentalHistory">
                    {{ showAllRentalHistory ? '접기' : `더 보기 (${groupedRentalHistory.length - 3}개)` }}
                </ToggleHistoryButton>

                <!-- 통계 섹션 -->
                <RentalHistoryStats>
                    <StatsContent>
                        <StatsCardItem>
                            <StatsCard>
                                <StatsCardHeader>
                                    <StatsTitle>통계</StatsTitle>
                                    <StatsDivider />
                                    <StatsInfoItem>
                                        <StatsLabel>결제 구분</StatsLabel>
                                        <StatsValue>
                                            {{ Object.keys(paymentStatsByMethod).join(', ') }}
                                        </StatsValue>
                                    </StatsInfoItem>
                                    <StatsDivider />
                                    <StatsInfoItem>
                                        <StatsLabel>총 납입 금액</StatsLabel>
                                        <StatsValue>{{ format.price(totalPaidAmount) }}원</StatsValue>
                                    </StatsInfoItem>
                                    <StatsDivider />
                                    <StatsInfoItem>
                                        <StatsLabel>총 미납금</StatsLabel>
                                        <StatsUnpaidAmount>{{ format.price(totalUnpaidAmount) }}원</StatsUnpaidAmount>
                                    </StatsInfoItem>
                                </StatsCardHeader>
                            </StatsCard>
                        </StatsCardItem>
                    </StatsContent>
                </RentalHistoryStats>
            </RentalHistoryContainer>

            <!-- ! 파일 등록정보 영역 -->
            <PasteFocusableSection
                v-if="(rentalTypes.hasOxygenGenerator || rentalTypes.hasDiabetesProduct || rentalTypes.hasAssistanceProduct) && !isLoadingClaimInfo"
                @paste="handleFilePaste" tabindex="0" @focus="handleDocumentSectionFocus"
                @blur="handleDocumentSectionBlur" :class="{ 'paste-focus': isPasteFocused }" ref="claimSection">
                <DocumentHeader>
                    <DocumentTitle>청구 정보</DocumentTitle>
                    <div style="display: flex; align-items: center;">
                        <FileUploadButton @click="triggerFileInput">
                            <FileUpload />파일등록
                        </FileUploadButton>
                        <RequiredDocsButton @click="showRequiredDocumentsModalData">
                            <TextBoxCheckOutline />필수 서류 목록
                        </RequiredDocsButton>
                        <ClaimServiceBtn @click="showModal_obj.contract_up = true">
                            <Printer />청구 서류 출력
                        </ClaimServiceBtn>
                    </div>
                    <PasteHintWrapper>
                        <PasteHintHoverBox>
                            <ClipboardIconWrapper>
                                <ClipboardIcon :size="20" :style="{ paddingTop: '3px' }" />
                            </ClipboardIconWrapper>
                            Ctrl+V로 파일 붙여넣기 가능
                        </PasteHintHoverBox>

                        <PasteHintTooltip class="tooltip">
                            🔍 파일 등록정보 영역에 마우스를 클릭하고<br>CTRL + V를 눌러 이미지를 등록할 수 있습니다.
                        </PasteHintTooltip>
                    </PasteHintWrapper>
                    <input type="file" :id="fileInputId" ref="fileInput" @change="handleFileSelect" multiple
                        accept=".jpg,.jpeg,.png,.pdf" style="display: none" />
                </DocumentHeader>

                <!-- * 청구 등록 프로세스 - 컴팩트한 정부 스타일 -->
                <ClaimProcessContainer>
                    <ProcessStepsContainer>
                        <!-- 0단계: 청구 정보 입력 (324-336번 줄) -->
                        <ProcessStep>
                            <StepIconContainer :active="getStepStatus(0) === 'completed'"
                                :inProgress="getStepStatus(0) === 'in-progress'">
                                <CheckCircle :size="20"
                                    :color="getStepStatus(0) === 'completed' ? '#16a34a' : (getStepStatus(0) === 'in-progress' ? '#eab308' : '#94a3b8')" />
                            </StepIconContainer>
                            <StepTitle>0단계</StepTitle>
                            <StepButton :active="currentStep >= 0" @click="openClaimInfoInput">
                                청구 정보 입력
                            </StepButton>
                            <StepStatus :class="getStepStatus(0)">
                                {{ getStepStatusText(0) }}
                            </StepStatus>
                        </ProcessStep>

                        <!-- 1단계: 환자 등록 (339-351번 줄) -->
                        <ProcessStep>
                            <StepIconContainer :active="getStepStatus(1) === 'completed'"
                                :inProgress="getStepStatus(1) === 'in-progress'">
                                <CheckCircle :size="20"
                                    :color="getStepStatus(1) === 'completed' ? '#16a34a' : (getStepStatus(1) === 'in-progress' ? '#eab308' : '#94a3b8')" />
                            </StepIconContainer>
                            <StepTitle>1단계</StepTitle>
                            <StepButton :active="currentStep >= 1" @click="openPatientRegistration">
                                환자 등록
                            </StepButton>
                            <StepStatus :class="getStepStatus(1)">
                                {{ getStepStatusText(1) }}
                            </StepStatus>
                        </ProcessStep>

                        <!-- 2단계: 요양비청구위임내역등록 (354-366번 줄) -->
                        <ProcessStep>
                            <StepIconContainer :active="getStepStatus(2) === 'completed'"
                                :inProgress="getStepStatus(2) === 'in-progress'">
                                <CheckCircle :size="20"
                                    :color="getStepStatus(2) === 'completed' ? '#16a34a' : (getStepStatus(2) === 'in-progress' ? '#eab308' : '#94a3b8')" />
                            </StepIconContainer>
                            <StepTitle>2단계</StepTitle>
                            <StepButton :active="currentStep >= 2" @click="submitClaimList">
                                위임내역등록
                            </StepButton>
                            <StepStatus :class="getStepStatus(2)">
                                {{ getStepStatusText(2) }}
                            </StepStatus>
                        </ProcessStep>

                        <!-- 3단계: 청구 등록 (369-381번 줄) -->
                        <ProcessStep>
                            <StepIconContainer :active="getStepStatus(3) === 'completed'"
                                :inProgress="getStepStatus(3) === 'in-progress'">
                                <CheckCircle :size="20"
                                    :color="getStepStatus(3) === 'completed' ? '#16a34a' : (getStepStatus(3) === 'in-progress' ? '#eab308' : '#94a3b8')" />
                            </StepIconContainer>
                            <StepTitle>3단계</StepTitle>
                            <StepButton :active="currentStep >= 3" @click="submitClaim">
                                청구등록
                            </StepButton>
                            <StepStatus :class="getStepStatus(3)">
                                {{ getStepStatusText(3) }}
                            </StepStatus>
                        </ProcessStep>
                    </ProcessStepsContainer>
                </ClaimProcessContainer>

                <!-- 파일 목록 테이블 -->
                <Table v-if="documents">
                    <thead>
                        <tr>
                            <TableHeader width="10%" align="center">
                                <input type="checkbox" :checked="selectAll" @change="toggleSelectAll"
                                    style="width: 20px; height: 20px; cursor: pointer;" />
                            </TableHeader>
                            <TableHeader width="20%" align="center">등록일자</TableHeader>
                            <TableHeader width="50%" align="left">파일</TableHeader>
                            <TableHeader width="20%" align="center">삭제</TableHeader>
                        </tr>
                    </thead>
                    <tbody>
                        <TableRow v-for="(doc, index) in documents" :key="index">
                            <TableCell width="10%" align="center">
                                <input type="checkbox" v-model="doc.selected" @change="handleSelection"
                                    style="width: 20px; height: 20px; cursor: pointer;" />
                            </TableCell>
                            <TableCell width="20%" align="center">{{ formatDate(doc.registeredDate) }}</TableCell>
                            <TableCell width="50%" align="left">
                                <ImageContainer>
                                    <!-- 이미지 파일인 경우 -->
                                    <Thumbnail v-if="isImageFile(doc.fileName)" :src="doc.url" :alt="doc.fileName"
                                        @click="openPreview(doc)" @error="handleImageError" />

                                    <!-- PDF 파일인 경우 -->
                                    <div v-else-if="isPdfFile(doc.fileName)" class="pdf-file-icon"
                                        @click="openPreview(doc)"
                                        style="width: 45px; height: 45px; background: #f44336; color: white; display: flex; align-items: center; justify-content: center; border-radius: 8px; cursor: pointer; font-size: 12px; font-weight: bold;">
                                        PDF
                                    </div>

                                    <!-- 기타 파일인 경우 -->
                                    <div v-else class="file-icon" @click="openPreview(doc)"
                                        style="width: 45px; height: 45px; background: #9e9e9e; color: white; display: flex; align-items: center; justify-content: center; border-radius: 8px; cursor: pointer; font-size: 12px; font-weight: bold;">
                                        FILE
                                    </div>

                                    <span>{{ doc.fileName }}</span>
                                </ImageContainer>
                            </TableCell>
                            <TableCell width="20%" align="center">
                                <DeleteButton @click="removeDocument(index)">
                                    <Delete :size="25" />
                                </DeleteButton>
                            </TableCell>
                        </TableRow>
                        <tr v-if="!documents.length">
                            <EmptyMessage colspan="4">
                                등록된 파일이 없습니다.
                            </EmptyMessage>
                        </tr>
                    </tbody>
                </Table>

                <PreviewModal v-if="selectedPreviewImage" @click="closePreview">
                    <!-- PDF 파일인 경우 더 큰 PreviewContent 사용 -->
                    <PreviewContentPdf v-if="selectedPreviewImage.fileType === 'pdf'" @click.stop>
                        <ClosePreviewButton @click="closePreview">×</ClosePreviewButton>
                        <PdfPreviewContainer>
                            <PdfPreviewHeader>
                                <h3>{{ selectedPreviewImage.fileName }}</h3>
                            </PdfPreviewHeader>
                            <PdfIframe :src="selectedPreviewImage.url" @error="handlePdfError">
                                <p>PDF를 표시할 수 없습니다. <a :href="selectedPreviewImage.url" target="_blank">여기를 클릭하여 새 탭에서
                                        열기</a></p>
                            </PdfIframe>
                        </PdfPreviewContainer>
                    </PreviewContentPdf>

                    <!-- 이미지 파일인 경우 기존 PreviewContent 사용 -->
                    <PreviewContent v-else @click.stop>
                        <ClosePreviewButton @click="closePreview">×</ClosePreviewButton>

                        <PreviewImage v-if="selectedPreviewImage.fileType === 'image'" :src="selectedPreviewImage.url"
                            :alt="selectedPreviewImage.fileName" />

                        <!-- 기타 파일인 경우 -->
                        <div v-else style="text-align: center; padding: 40px;">
                            <div style="font-size: 48px; color: #9e9e9e; margin-bottom: 20px;"></div>
                            <h3>{{ selectedPreviewImage.fileName }}</h3>
                            <p>이 파일은 미리보기를 지원하지 않습니다.</p>
                        </div>
                    </PreviewContent>
                </PreviewModal>
            </PasteFocusableSection>

            <ClaimLoadingMessage
                v-else-if="(rentalTypes.hasOxygenGenerator || rentalTypes.hasDiabetesProduct || rentalTypes.hasAssistanceProduct) && isLoadingClaimInfo">
                <ClaimLoadingSpinner />
                <ClaimLoadingText>청구 정보를 불러오는 중입니다</ClaimLoadingText>
            </ClaimLoadingMessage>
        </OrderModifyProductArea>
    </OrderModifyDiv>

    <!-- !주문서 Footer -->
    <RentalFooterArea>
        <OrderModifyServiceBtnArea>
            <OrderModifyServiceBtn @click="showModal_obj.doc_print = true">
                <Printer />&nbsp;&nbsp;&nbsp;계약서 출력
            </OrderModifyServiceBtn>
            <!-- <OrderModifyServiceBtn @click="handleAutoClaim">
                <TextBoxCheckOutline />&nbsp;&nbsp;&nbsp;공단청구
            </OrderModifyServiceBtn> -->
            <ModalPage v-model:show="showModal_obj.doc_print" :width="modal_width.doc_print"
                :height="modal_height.doc_print">
                <DocPrints :pageUrls="pageUrls" :products_obj="products_obj" :client_data_obj="client_data_obj"
                    :postcode_obj="postcode_obj" />
            </ModalPage>
        </OrderModifyServiceBtnArea>

        <FooterButtonArea>
            <template v-if="client_data_obj.rental_status === 2">
                <RentalSubmitBtn @click="handleStopRentalCancel">
                    <Restore />&nbsp;&nbsp;대여중지취소
                </RentalSubmitBtn>
            </template>
            <template v-else>
                <RentalSubmitBtn @click="handleStopRental">
                    <StopCircleOutline />&nbsp;&nbsp;대여중지
                </RentalSubmitBtn>
            </template>
            <RentalSubmitBtn v-if="!isReturned" @click="handleReturnRental">
                <TruckDeliveryOutline :size="30" />&nbsp;&nbsp;회수등록
            </RentalSubmitBtn>
            <RentalSubmitBtn v-else @click="handleCancelReturn">
                <Restore :size="30" />&nbsp;&nbsp;회수등록취소
            </RentalSubmitBtn>
            <RentalSubmitBtn @click="handleModifyOrder">
                <AccountEdit />&nbsp;&nbsp;수정하기
            </RentalSubmitBtn>
        </FooterButtonArea>
    </RentalFooterArea>

    <!-- ! 가상계좌 모달 -->
    <ModalPage v-model:show="showModal_obj.virtual_up" :width="modal_width.virtual_up"
        :height="modal_height.virtual_up">
        <VirtualAccountModal :products="getSelectedStoreProducts()" :orderData="client_data_obj" :orderId="orderId"
            @update:accountCount="updateVirtualAccountCount" @virtual-account-sent="handleVirtualAccountSent" />
    </ModalPage>

    <!-- ! 공단지사 선택 모달 -->
    <ModalPage v-model:show="showModal_obj.branch_selection" :width="modal_width.branch_selection"
        :height="modal_height.branch_selection">
        <BranchModal :orderId="orderId" :orderData="client_data_obj" :claimType="getCurrentClaimType()"
            :initialPatientInfo="getPatientInfo()" :selectedFiles="getSelectedFiles()" :products="products_obj"
            @branch-changed="handleBranchChanged" @patient-registered="handlePatientRegistered"
            @close="showModal_obj.branch_selection = false" />
    </ModalPage>

    <!-- !청구 정보 입력 모달 -->
    <ModalPage v-model:show="showClaimInfoModal" :width="modal_width.claim_info" :height="modal_height.claim_info">
        <OxygenClaimInfoModal v-if="showClaimInfoModal && orderData && getCurrentClaimType() === 'oxygen'"
            :orderId="orderId" :orderData="orderData" :claimType="'oxygen'"
            :products="(orderData && orderData.products) || products_obj || []" :rentalTypes="rentalTypes"
            :additionalData="getAdditionalClaimData()" @claim-info-saved="onClaimInfoSaved"
            @close="closeClaimInfoModal" />
    </ModalPage>

    <!-- ! 필수 서류 목록 모달 -->
    <ModalPage v-model:show="showRequiredDocumentsModal" :width="modal_width.required_documents"
        :height="modal_height.required_documents">
        <RequiredDocumentsModal :claimType="getCurrentClaimType()" @close="showRequiredDocumentsModal = false" />
    </ModalPage>

    <!-- !청구 서류 출력 모달 -->
    <ModalPage v-model:show="showModal_obj.contract_up" :width="modal_width.contract_up"
        :height="modal_height.contract_up">
        <ContractModal :contractData="contractDataForModal()" :products="productsForContract()"
            @close="showModal_obj.contract_up = false" @register-pdf="handlePDFRegistration"
            @register-all-pdf="handleAllPDFRegistration" />
    </ModalPage>
    <!-- ! 문자 발송 모달 -->
    <SmsSendModal v-if="showModal_obj.sms_up" :width="modal_width.sms_up" :height="modal_height.sms_up"
        :recipient="selectedCustomer" @close="showModal_obj.sms_up = false" />
</template>

<script>
import { ref, reactive, toRaw } from 'vue';
import * as injectGlobal from '@/assets/styles/global/public.js';
import * as OrderRentalPage from '@/assets/styles/rental/modal/OrderRentalCss.js';

import ModalPage from '@/components/layout/ModalPage.vue';
import DocPrints from '@/components/order/modal/DocPrintsModal.vue';
import VirtualAccountModal from '@/components/order/modal/VirtualAccountModal.vue';
// import DocumentUploadModal from '@/components/Rental/modal/OxygenClaimModal.vue';
import ClaimModal from '@/components/layout/ClaimModal.vue';
import OxygenClaimInfoModal from '@/components/order/modal/OxygenClaimInfoModal.vue';
import BranchModal from '@/components/order/modal/BranchModal.vue';
import RequiredDocumentsModal from '@/components/claim/modal/RequiredDocumentsModal.vue';
import ContractModal from '@/components/order/modal/ContractModal.vue';
import SmsSendModal from '@/components/Manage/modal/SmsSendModal.vue';

import Datepicker from 'vue-datepicker-next';
import Printer from 'vue-material-design-icons/Printer.vue';
import Close from 'vue-material-design-icons/Close.vue';
import TextBoxCheckOutline from 'vue-material-design-icons/TextBoxCheckOutline.vue';
import Restore from 'vue-material-design-icons/Restore.vue';
import StopCircleOutline from 'vue-material-design-icons/StopCircleOutline.vue';
import AccountEdit from 'vue-material-design-icons/AccountEdit.vue';
import FileUpload from 'vue-material-design-icons/FileUpload.vue';
import Delete from 'vue-material-design-icons/Delete.vue';
import ContentCopy from 'vue-material-design-icons/ContentCopy.vue';
import TruckDeliveryOutline from 'vue-material-design-icons/TruckDeliveryOutline.vue';
import CheckCircle from 'vue-material-design-icons/CheckCircle.vue';
import ClipboardIcon from 'vue-material-design-icons/ClipboardText.vue';
import TimerPlusOutline from 'vue-material-design-icons/TimerPlusOutline.vue';

import * as pdfjsLib from 'pdfjs-dist';

export default {
    name: 'OrderModifyPage',

    inject: ['globalMessageSystem'],

    emits: [
        'order-updated',
        'close-modal',
        'close-return-modal',
        'close-as-modal',
        'return-registered',
        'return-cancelled',
        'imagesUploaded',
        'progress-update',
        'close',
        'rental-status-updated'
    ],

    components: {
        ...injectGlobal,
        ...OrderRentalPage,
        ModalPage,
        Printer, Close, TextBoxCheckOutline, StopCircleOutline, AccountEdit, Restore, FileUpload, Delete, ContentCopy, TruckDeliveryOutline, CheckCircle, ClipboardIcon, TimerPlusOutline,
        Datepicker,
        DocPrints,
        VirtualAccountModal,
        // DocumentUploadModal,
        ClaimModal,
        OxygenClaimInfoModal,
        BranchModal,
        RequiredDocumentsModal,
        ContractModal,
        SmsSendModal
    },

    props: {
        orderId: {
            type: [String, Number],
            required: true
        },
        products: {
            type: Array,
            default: () => []
        },
        orderData: {
            type: Object,
            default: () => ({})
        }
    },

    setup() {
        pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
        // const orderData = ref(null);
        const orderCommentAdd = ref('');
        const products_obj = ref([]);
        const color_obj = reactive({});
        const client_data_obj = reactive({
            name: '',
            number: '',
            regident: '',
            address: '',
            guardname: '',
            guardtarget: '',
            manager: '',
            rental_start: null,
            rental_end: null,
            rental_status: 0,
            oxygen_start: null,
            oxygen_end: null,
            diabetes_start: null,
            diabetes_end: null
        });
        const showModal_obj = reactive({
            client_up: ref(false),
            product_up: ref(false),
            doc_print: ref(false),
            virtual_up: ref(false),
            assistance_up: ref(false),
            diabetes_up: ref(false),
            claim_type: ref(false),
            claim_up: ref(false),
            branch_selection: ref(false),
            required_documents: ref(false),
            contract_up: ref(false),
            sms_up: ref(false)
        });
        const modal_width = {
            client_up: '65%',
            product_up: '85%',
            doc_print: '60%',
            virtual_up: '75%',
            claim_up: '80%',
            assistance_up: '40%',
            diabetes_up: '40%',
            claim_info: '80%',
            branch_selection: '50%',
            required_documents: '30%',
            contract_up: '40%',
            sms_up: '50%'
        };
        const modal_height = {
            client_up: '80%',
            product_up: '80%',
            doc_print: '80%',
            virtual_up: '80%',
            claim_up: '80%',
            assistance_up: '55%',
            diabetes_up: '55%',
            claim_info: '80%',
            branch_selection: '70%',
            required_documents: '70%',
            contract_up: '85%',
            sms_up: '80%'
        };
        const postcode_obj = reactive({
            postcode1: '',
            address1: '',
            detailAddress1: '',
            postcode2: '',
            address2: '',
            detailAddress2: '',
        });
        const delivery_date = ref(null);
        const delivery_time = '0';
        const deliveryMethod = ref("1");
        const deliveryStatus = ref("0");

        // 공단청구 모달 크기 관리
        const currentClaimModalSize = reactive({
            width: modal_width.claim_up,
            height: modal_height.claim_up
        });

        // 공단청구 모달 크기 업데이트
        const updateClaimModalSize = ({ width, height }) => {
            currentClaimModalSize.width = width;
            currentClaimModalSize.height = height;
        };

        const ko = {
            formatLocale: {
                months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
                weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
                weekdaysMin: ['일', '월', '화', '수', '목', '금', '토'],
                firstDayOfWeek: 0,
                firstWeekContainsDate: 1,
                meridiem: (h) => (h < 12 ? '오전' : '오후'),
                meridiemParse: /오전|오후/,
                isPM: (input) => input === '오후'
            },
            yearFormat: 'YYYY년',
            monthFormat: 'MMM',
            monthBeforeYear: false
        };

        return {
            // orderData,
            showModal_obj,
            modal_width,
            modal_height,
            postcode_obj,
            client_data_obj,
            products_obj,
            color_obj,
            delivery_date,
            delivery_time,
            deliveryMethod,
            deliveryStatus,
            orderCommentAdd,
            currentClaimModalSize,
            updateClaimModalSize,
            ko
        };
    },

    data() {
        return {
            isPasteFocused: false,
            salesPerson: '없음',
            orderDate: null,
            selectedDeliveryMemo: '',
            orderStatus: 0,
            virtualAccountCount: 0,
            format: {
                price: (price) => {
                    return new Intl.NumberFormat('ko-KR', {
                        style: 'decimal',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    }).format(price);
                },
                date: (dateString) => {
                    const date = new Date(dateString);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                }
            },
            pageUrls: [`${window.location.origin}/btransactionfileNew.html`], // 계약서 출력 주소
            orderComment: [],
            imageFiles: [],
            manager: [],
            rentalHistory: [], // 대여 이력 목록
            editingMemoIndex: null, // 현재 수정 중인 메모 인덱스
            editingPaymentStatusIndex: null, // 현재 수정 중인 결제 상태 인덱스
            showAllRentalHistory: false, // 대여 이력 전체 표시 여부
            editingMemoValue: '', // 수정 중인 메모 값
            isSavingMemo: false, // 메모 저장 중 플래그
            editingPaymentNumberIndex: null, // 현재 수정 중인 결제번호 인덱스
            editingPaymentNumberValue: '', // 수정 중인 결제번호 값
            isSavingPaymentNumber: false, // 결제번호 저장 중 플래그
            returnPopupInstance: null,
            asPopupInstance: null,
            // 모달 상태 관리를 위한 속성 추가
            showUploadModal: false,
            showExtractedDataModal: false,
            showClaimInfoModal: false,
            showRequiredDocumentsModal: false,
            showContractModal: false,
            uploadedFiles: [],
            uploadedDocuments: [],
            extractedData: {},
            paymentMethod: '',
            isInitializingPaymentMethod: false, // 결제방식 초기화 중 플래그
            // 파일 등록 관련
            images: [],
            selectedFileNames: '',
            fileInputId: `file-input-${Date.now()}`,
            selectedImages: [],
            selectedPreviewImage: null,
            documents: null,
            fileSelectAll: false,
            isReturned: false, // 회수 등록 여부 확인
            returnInfo: null, // 회수 정보 저장
            // 주문서 타입 확인
            rentalTypes: {
                hasRentalProduct: false,
                hasOxygenGenerator: false,
                hasDiabetesProduct: false,
                hasAssistanceProduct: false
            },
            claimStatus: {
                hasClaimData: false,
                currentStep: 0,
                currentStepText: '',
                isCompleted: false
            },
            selectAll: false,
            isLoadingClaimInfo: true,
            virtualAccountHistory: [],
            selectedCustomer: {
                name: '',
                phone: '',
                phone1: '',
                phone2: '',
                companykey: this.$globalState?.company_key || ''
            },
        };
    },
    computed: {
        isTestUser() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                return userInfo && userInfo.id === 'test';
            } catch (error) {
                return false;
            }
        },

        parsedReturnDate() {
            return this.returnInfo?.returnDate ? new Date(this.returnInfo.returnDate) : null;
        },
        totalPrice() {
            return this.products_obj.reduce((total, product) => {
                const price = product.selected_target === '대여' ? product.rentprice : product.buyprice;
                return total + (price * product.quantity);
            }, 0);
        },
        totalQuantity() {
            return this.products_obj.reduce((total, product) => {
                return total + product.quantity;
            }, 0);
        },
        hasRentalProduct() {
            return this.products_obj.some(product =>
                product.target === '대여' ||
                product.selected_target === '대여' ||
                product.target === '구입 또는 대여'
            );
        },
        hasOxygenGenerator() {
            return this.products_obj.some(product => {
                // 주문 상세 데이터 구조 확인
                const isOxygenInOrder = product.name1 === "산소발생기";

                // products 로그 데이터 구조 확인
                const isOxygenInProduct =
                    (product.options &&
                        product.b_product_id > 999999 &&
                        (product.name1 === "산소발생기" || product.name === "산소발생기"));

                return isOxygenInOrder || isOxygenInProduct;
            });
        },
        hasDiabetesProduct() {
            return this.products_obj.some(product =>
                product.name1 === "당뇨용품" ||
                product.name === "당뇨용품" ||
                product.name0 === "당뇨용품(E)" ||
                (product.name && product.name.includes("당뇨용품"))
            );
        },
        hasAssistanceProduct() {
            return this.products_obj.some(product =>
                ['보장구', '의지', '보조기', '수동휠체어', '욕창예방 매트리스', '지팡이', '자세변환용구',
                    '보행보조복지용구', '보청기', '성인용보행기'].includes(product.name || product.name0)
            );
        },

        groupedRentalHistory() {
            if (!this.rentalHistory || this.rentalHistory.length === 0) {
                return [];
            }

            const grouped = [];

            // 대여 시작일과 종료일
            const rentalStart = this.client_data_obj.rental_start
                ? new Date(this.client_data_obj.rental_start)
                : null;
            const rentalEnd = this.client_data_obj.rental_end
                ? new Date(this.client_data_obj.rental_end)
                : null;

            // 연장 이력들을 날짜순으로 정렬
            const extensionHistories = this.rentalHistory
                .filter(h => h.type === '연장')
                .sort((a, b) => new Date(a.date || a.created_at) - new Date(b.date || b.created_at));

            // 결제 이력들을 날짜순으로 정렬 (type이 '결제'인 경우)
            const paymentHistories = this.rentalHistory
                .filter(h => h.type === '결제')
                .sort((a, b) => new Date(a.date || a.created_at) - new Date(b.date || b.created_at));

            let currentPeriod = 1;
            let periodStartDate = rentalStart;
            let periodEndDate = rentalStart;

            // 첫 회차: 초기 대여 기간 (연장 전)
            if (rentalStart && rentalEnd) {
                // 첫 연장 이력이 있으면 그 날짜까지, 없으면 종료일까지
                const firstExtension = extensionHistories[0];
                const firstPeriodEnd = firstExtension
                    ? new Date(firstExtension.date || firstExtension.created_at)
                    : rentalEnd;

                // 첫 회차의 결제 정보 찾기 (type이 '결제'인 이력 중에서)
                const firstPayment = paymentHistories.find(p => {
                    const paymentDate = new Date(p.date || p.created_at);
                    return paymentDate >= rentalStart && (!firstExtension || paymentDate < firstPeriodEnd);
                });

                // 첫 회차의 메모들 수집 (연장 이력이 아닌 것들 중에서)
                const firstMemos = this.rentalHistory
                    .filter(h => {
                        const hDate = new Date(h.date || h.created_at);
                        const hIndex = this.rentalHistory.findIndex(rh => rh.num === h.num);
                        // 편집 중인 메모는 항상 포함
                        const isEditing = this.editingMemoIndex === hIndex;
                        return h.type !== '연장' &&
                            hDate >= rentalStart &&
                            (!firstExtension || hDate < firstPeriodEnd) &&
                            (isEditing || (h.memo && h.memo.trim() !== ''));
                    })
                    .map(h => ({
                        type: h.type,
                        memo: h.memo,
                        historyId: h.num,
                        historyIndex: this.rentalHistory.findIndex(rh => rh.num === h.num)
                    }));

                // 첫 회차의 결제 정보
                let firstPaymentType = firstPayment?.payment_type || null;
                let firstPaymentAmount = firstPayment?.payment_amount ? parseInt(firstPayment.payment_amount) : null;
                let firstPaymentStatus = firstPayment?.payment_status || null;

                // 가상계좌인 경우 실제 입금 여부 확인하여 동기화
                if (firstPaymentType === '가상계좌' && this.virtualAccountHistory && this.virtualAccountHistory.length > 0) {
                    const matchedAccount = this.virtualAccountHistory.find(account => {
                        const accountAmount = parseInt(account.PAYITEMAMT) || 0;
                        const paymentDateOnly = new Date(firstPayment.date || firstPayment.created_at);
                        paymentDateOnly.setHours(0, 0, 0, 0);
                        const accountDateOnly = new Date(account.RCPSTARTDT || account.CREATED_AT);
                        accountDateOnly.setHours(0, 0, 0, 0);

                        const daysDiff = Math.abs((accountDateOnly - paymentDateOnly) / (1000 * 60 * 60 * 24));
                        return accountAmount === firstPaymentAmount && daysDiff <= 7;
                    });

                    if (matchedAccount) {
                        if (matchedAccount.RESULTCD === null) {
                            firstPaymentStatus = '대기';
                        } else if (matchedAccount.RESULTCD !== 'D000') {
                            firstPaymentStatus = '대기';
                        } else if (matchedAccount.REGDT !== null) {
                            firstPaymentStatus = '납부';
                        } else {
                            firstPaymentStatus = '미납';
                        }
                    }
                }

                if (firstMemos.length > 0 || firstPayment || !firstExtension) {
                    grouped.push({
                        periodNumber: currentPeriod,
                        periodRange: this.formatPeriodRange(rentalStart, firstPeriodEnd),
                        paymentType: firstPaymentType,
                        paymentAmount: firstPaymentAmount,
                        paymentStatus: firstPaymentStatus,
                        memos: firstMemos,
                        extensionHistory: null
                    });
                    currentPeriod++;
                }

                periodStartDate = firstPeriodEnd;
                periodEndDate = firstPeriodEnd;
            }

            // 각 연장마다 회차 생성
            extensionHistories.forEach((extension, index) => {
                const extensionDate = new Date(extension.date || extension.created_at);

                // 연장 일수 계산 (메모에서 추출 또는 계산)
                let extensionDays = 30; // 기본값
                if (extension.memo) {
                    const dayMatch = extension.memo.match(/(\d+)일/);
                    if (dayMatch) {
                        extensionDays = parseInt(dayMatch[1]);
                    } else {
                        // 1개월(30일) 패턴 찾기
                        const monthMatch = extension.memo.match(/1개월/);
                        if (monthMatch) {
                            extensionDays = 30;
                        }
                    }
                }

                // 이전 종료일을 시작일로 사용
                if (!periodEndDate) {
                    periodEndDate = extensionDate;
                }

                // 새로운 종료일 계산
                const newEndDate = new Date(periodEndDate);
                newEndDate.setDate(newEndDate.getDate() + extensionDays);

                // 결제 정보: 연장 이력 자체에 결제 정보가 있으면 우선 사용, 없으면 별도 결제 이력 찾기
                let paymentType = null;
                let paymentAmount = null;
                let paymentStatus = null;

                // 1순위: 연장 이력 자체에 결제 정보가 있는 경우
                if (extension.payment_type && extension.payment_amount) {
                    paymentType = extension.payment_type;
                    paymentAmount = parseInt(extension.payment_amount) || 0;
                    paymentStatus = extension.payment_status || null;

                    // 가상계좌인 경우: DB에 저장된 값이 있고 '대기'가 아닌 경우(사용자가 수동 수정) 가상계좌 목록 확인 건너뛰기
                    if (paymentType === '가상계좌' && this.virtualAccountHistory && this.virtualAccountHistory.length > 0) {
                        // DB에 저장된 값이 있고 '대기'가 아닌 경우 가상계좌 목록 확인 건너뛰기
                        if (paymentStatus && paymentStatus !== '대기') {
                            // 사용자가 수동으로 수정한 값이 있으면 그대로 사용
                            // 가상계좌 목록 확인 안 함
                        } else {
                            // DB 값이 없거나 '대기'인 경우에만 가상계좌 목록 확인
                            const matchedAccount = this.virtualAccountHistory.find(account => {
                                const accountAmount = parseInt(account.PAYITEMAMT) || 0;
                                const accountDate = new Date(account.RCPSTARTDT || account.CREATED_AT);
                                const extensionDateOnly = new Date(extensionDate);
                                extensionDateOnly.setHours(0, 0, 0, 0);
                                const accountDateOnly = new Date(accountDate);
                                accountDateOnly.setHours(0, 0, 0, 0);

                                // 금액이 일치하고 날짜가 가까운 경우 (7일 이내)
                                const daysDiff = Math.abs((accountDateOnly - extensionDateOnly) / (1000 * 60 * 60 * 24));
                                return accountAmount === paymentAmount && daysDiff <= 7;
                            });

                            if (matchedAccount) {
                                // 가상계좌 상태에 따라 payment_status 업데이트
                                if (matchedAccount.RESULTCD === null) {
                                    paymentStatus = '대기'; // 등록대기
                                } else if (matchedAccount.RESULTCD !== 'D000') {
                                    paymentStatus = '대기'; // 등록실패도 대기로 처리
                                } else if (matchedAccount.REGDT !== null) {
                                    paymentStatus = '납부'; // 납부 완료
                                } else {
                                    paymentStatus = '미납'; // 납부 미완료
                                }
                            } else {
                                // 매칭되는 가상계좌가 없으면 DB 값 유지 (없으면 '대기')
                                paymentStatus = paymentStatus || '대기';
                            }
                        }
                    } else if (paymentType === '가상계좌') {
                        // 가상계좌 목록이 없거나 로드되지 않은 경우 DB 값 유지
                        paymentStatus = paymentStatus || '대기';
                    }
                } else {
                    // 2순위: 별도 결제 이력 찾기 (연장 날짜와 가장 가까운 결제)
                    const relatedPayment = paymentHistories.find(p => {
                        const paymentDate = new Date(p.date || p.created_at);
                        return paymentDate >= extensionDate && paymentDate <= newEndDate;
                    });

                    if (relatedPayment) {
                        paymentType = relatedPayment.payment_type;
                        paymentAmount = relatedPayment.payment_amount ? parseInt(relatedPayment.payment_amount) : null;
                        paymentStatus = relatedPayment.payment_status || null;

                        // 가상계좌인 경우 실제 입금 여부 확인하여 동기화
                        if (paymentType === '가상계좌' && this.virtualAccountHistory && this.virtualAccountHistory.length > 0) {
                            const matchedAccount = this.virtualAccountHistory.find(account => {
                                const accountAmount = parseInt(account.PAYITEMAMT) || 0;
                                const paymentDateOnly = new Date(relatedPayment.date || relatedPayment.created_at);
                                paymentDateOnly.setHours(0, 0, 0, 0);
                                const accountDateOnly = new Date(account.RCPSTARTDT || account.CREATED_AT);
                                accountDateOnly.setHours(0, 0, 0, 0);

                                const daysDiff = Math.abs((accountDateOnly - paymentDateOnly) / (1000 * 60 * 60 * 24));
                                return accountAmount === paymentAmount && daysDiff <= 7;
                            });

                            if (matchedAccount) {
                                if (matchedAccount.RESULTCD === null) {
                                    paymentStatus = '대기';
                                } else if (matchedAccount.RESULTCD !== 'D000') {
                                    paymentStatus = '대기';
                                } else if (matchedAccount.REGDT !== null) {
                                    paymentStatus = '납부';
                                } else {
                                    paymentStatus = '미납';
                                }
                            }
                        }
                    } else {
                        // 3순위: 연장 날짜와 ±7일 이내의 가장 가까운 결제
                        const closestPayment = paymentHistories
                            .filter(p => {
                                const paymentDate = new Date(p.date || p.created_at);
                                const diffDays = Math.abs((paymentDate - extensionDate) / (1000 * 60 * 60 * 24));
                                return diffDays <= 7;
                            })
                            .sort((a, b) => {
                                const dateA = new Date(a.date || a.created_at);
                                const dateB = new Date(b.date || b.created_at);
                                const diffA = Math.abs(dateA - extensionDate);
                                const diffB = Math.abs(dateB - extensionDate);
                                return diffA - diffB;
                            })[0];

                        if (closestPayment) {
                            paymentType = closestPayment.payment_type;
                            paymentAmount = closestPayment.payment_amount ? parseInt(closestPayment.payment_amount) : null;
                            paymentStatus = closestPayment.payment_status || null;

                            // 가상계좌인 경우 실제 입금 여부 확인하여 동기화
                            if (paymentType === '가상계좌' && this.virtualAccountHistory && this.virtualAccountHistory.length > 0) {
                                const matchedAccount = this.virtualAccountHistory.find(account => {
                                    const accountAmount = parseInt(account.PAYITEMAMT) || 0;
                                    const paymentDateOnly = new Date(closestPayment.date || closestPayment.created_at);
                                    paymentDateOnly.setHours(0, 0, 0, 0);
                                    const accountDateOnly = new Date(account.RCPSTARTDT || account.CREATED_AT);
                                    accountDateOnly.setHours(0, 0, 0, 0);

                                    const daysDiff = Math.abs((accountDateOnly - paymentDateOnly) / (1000 * 60 * 60 * 24));
                                    return accountAmount === paymentAmount && daysDiff <= 7;
                                });

                                if (matchedAccount) {
                                    if (matchedAccount.RESULTCD === null) {
                                        paymentStatus = '대기';
                                    } else if (matchedAccount.RESULTCD !== 'D000') {
                                        paymentStatus = '대기';
                                    } else if (matchedAccount.REGDT !== null) {
                                        paymentStatus = '납부';
                                    } else {
                                        paymentStatus = '미납';
                                    }
                                }
                            }
                        }
                    }
                }

                // 해당 회차의 메모: 해당 연장 이력의 메모만 표시
                const memos = [];
                const extensionIndex = this.rentalHistory.findIndex(rh => rh.num === extension.num);
                const isEditing = this.editingMemoIndex === extensionIndex;
                // 편집 중인 메모는 항상 포함, 아니면 메모가 있는 경우만 포함
                if (isEditing || (extension.memo && extension.memo.trim() !== '')) {
                    memos.push({
                        type: extension.type,
                        memo: extension.memo,
                        historyId: extension.num,
                        historyIndex: extensionIndex
                    });
                }

                grouped.push({
                    periodNumber: currentPeriod,
                    periodRange: this.formatPeriodRange(periodStartDate || extensionDate, newEndDate),
                    paymentType: paymentType,
                    paymentAmount: paymentAmount,
                    paymentStatus: paymentStatus,
                    memos: memos,
                    extensionHistory: extension
                });

                // 다음 회차를 위한 시작일/종료일 업데이트
                periodStartDate = extensionDate;
                periodEndDate = newEndDate;
                currentPeriod++;
            });

            return grouped;
        },

        // 결제 수단별 통계
        paymentStatsByMethod() {
            const stats = {};
            // type이 '결제'인 이력
            this.rentalHistory
                .filter(h => h.type === '결제' && h.payment_type && h.payment_amount)
                .forEach(h => {
                    const method = h.payment_type;
                    const amount = parseInt(h.payment_amount) || 0;
                    stats[method] = (stats[method] || 0) + amount;
                });

            // type이 '연장'이지만 결제 정보가 있는 이력도 포함
            this.rentalHistory
                .filter(h => h.type === '연장' && h.payment_type && h.payment_amount)
                .forEach(h => {
                    const method = h.payment_type;
                    const amount = parseInt(h.payment_amount) || 0;
                    stats[method] = (stats[method] || 0) + amount;
                });

            return stats;
        },

        // 총 납입 금액 (완료된 결제만)
        totalPaidAmount() {
            let total = 0;

            // type이 '결제' 또는 '연장'이고 결제 정보가 있는 이력
            // '완료' 또는 '납부' 상태인 경우만 포함 (가상계좌의 '납부' 상태 포함)
            total += this.rentalHistory
                .filter(h => {
                    if (!h.payment_amount) return false;
                    // '완료' 또는 '납부' 상태인 경우만 포함
                    const isPaid = h.payment_status === '완료' || h.payment_status === '납부';
                    return isPaid && (h.type === '결제' || h.type === '연장');
                })
                .reduce((sum, h) => sum + (parseInt(h.payment_amount) || 0), 0);

            return total;
        },

        // 총 미납금 (품목의 대여 가격 - 결제 금액)
        totalUnpaidAmount() {
            // 1. 품목의 총 대여 가격 계산
            const totalRentalPrice = this.products_obj.reduce((total, product) => {
                // 대여 품목만 계산
                const isRental = product.selected_target === '대여' ||
                    product.target === '대여' ||
                    product.target === '구입 또는 대여';

                if (isRental) {
                    // setRentprice가 있으면 사용, 없으면 rentprice * quantity
                    const price = product.setRentprice || (product.rentprice * (product.quantity || 1));
                    return total + (price || 0);
                }
                return total;
            }, 0);

            // 2. 총 결제 금액 (완료된 결제만)
            const paidAmount = this.totalPaidAmount;

            // 3. 총 미납금 = 총 대여 가격 - 총 결제 금액
            const unpaidAmount = totalRentalPrice - paidAmount;

            // 4. 음수가 되지 않도록 0보다 작으면 0 반환
            return unpaidAmount > 0 ? unpaidAmount : 0;
        },

        // 표시할 대여 이력 (처음 3개 또는 전체)
        displayedRentalHistory() {
            if (!this.groupedRentalHistory || this.groupedRentalHistory.length === 0) {
                return [];
            }

            if (this.showAllRentalHistory) {
                return this.groupedRentalHistory;
            }

            return this.groupedRentalHistory.slice(0, 3);
        },

        // 더 많은 이력이 있는지 확인
        hasMoreRentalHistory() {
            return this.groupedRentalHistory && this.groupedRentalHistory.length > 3;
        },
    },

    methods: {
        // 입금 처리 수정 시작
        startPaymentStatusEdit(index, historyId) {
            if (!historyId) {
                // extensionHistory가 없는 경우 (첫 회차) 해당 결제 이력 찾기
                const period = this.groupedRentalHistory[index];
                if (period && period.paymentType) {
                    // 결제 이력에서 찾기
                    const paymentHistory = this.rentalHistory.find(h =>
                        h.type === '결제' &&
                        h.payment_type === period.paymentType &&
                        h.payment_amount === period.paymentAmount?.toString()
                    );
                    if (paymentHistory) {
                        this.editingPaymentStatusIndex = index;
                        return;
                    }
                }
                this.$swal.fire({
                    icon: 'warning',
                    title: '알림',
                    text: '입금 처리를 수정할 수 있는 이력이 없습니다.'
                });
                return;
            }
            this.editingPaymentStatusIndex = index;
        },

        // 입금 처리 업데이트
        async updatePaymentStatus(historyId, newStatus, index) {
            try {
                const statusToSave = newStatus === '입금' ? '납부' : newStatus;

                const response = await this.$axios.put(
                    `${this.$apiUrls.hanqmedi}/updateRentalHistoryPaymentStatus/${historyId}`,
                    { payment_status: statusToSave },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if (response.data.success) {
                    await this.fetchRentalHistory();
                    this.editingPaymentStatusIndex = null;

                } else {
                    throw new Error(response.data.message || '입금 처리 업데이트에 실패했습니다.');
                }
            } catch (error) {
                console.error('입금 처리 업데이트 실패:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: '오류',
                    text: error.response?.data?.message || '입금 처리 업데이트에 실패했습니다.'
                });
            }
        },

        getPaymentStatusText(paymentType, paymentStatus) {
            if (!paymentStatus) return '';

            // 가상계좌인 경우
            if (paymentType === '가상계좌') {
                // '대기', '미납', '납부'는 그대로 표시
                if (paymentStatus === '대기' || paymentStatus === '미납' || paymentStatus === '납부') {
                    return paymentStatus;
                }
                // 기존 '완료', '미완료' 값도 처리 (하위 호환성)
                if (paymentStatus === '완료') {
                    return '납부';
                } else if (paymentStatus === '미완료') {
                    return '미납';
                }
                // 기본값은 '대기'
                return '대기';
            }

            // 다른 결제 수단의 경우 기존 상태 그대로 표시
            return paymentStatus;
        },

        // 결제 상태 배지 타입 반환
        getPaymentStatusDisplay(paymentType, paymentStatus) {
            if (!paymentStatus) return 'default';

            if (paymentStatus === '납부') {
                return 'paid';
            } else if (paymentStatus === '미납') {
                return 'unpaid';
            } else if (paymentStatus === '대기') {
                return 'pending';
            }

            return 'default';
        },

        // 가상계좌 발송 성공 시 대여 이력 저장
        async handleVirtualAccountSent(data) {
            try {
                // 가상계좌 발송 직후에는 아직 입금되지 않았으므로 '대기' 상태로 저장
                await this.saveRentalHistory(
                    '연장', // 연장 타입으로 저장 (가상계좌 발송도 연장 건으로 처리)
                    data.paymentType, // '가상계좌'
                    null,
                    data.paymentAmount, // 입금금액
                    '대기', // 가상계좌 발송 직후는 '대기' 상태
                    `가상계좌 발송: ${data.vano} (${data.bank})`
                );

                // 가상계좌 목록 새로고침 (실제 입금 여부 확인을 위해)
                await this.fetchVirtualAccountHistory();

                // 대여 이력 목록 새로고침
                await this.fetchRentalHistory();
            } catch (error) {
                console.error('가상계좌 발송 이력 저장 실패:', error);
            }
        },

        // 전체 선택
        selectAllProducts() {
            this.products_obj.forEach(product => product.selected = true);
        },

        // 선택 해제
        deselectAllProducts() {
            this.products_obj.forEach(product => product.selected = false);
        },

        // 메모 수정 시작
        startMemoEdit(memo, index) {
            this.editingMemoIndex = index;
            this.editingMemoValue = memo || '';
            this.isSavingMemo = false;
        },

        // 메모 수정 취소
        cancelMemoEdit() {
            this.editingMemoIndex = null;
            this.editingMemoValue = '';
            this.isSavingMemo = false;
        },

        // Enter 키 처리
        handleMemoEnter(event) {
            event.preventDefault();
            event.stopPropagation();
            const index = this.editingMemoIndex;
            const historyId = this.rentalHistory[index]?.num;
            if (historyId) {
                this.saveMemo(historyId, index);
            }
        },

        // Blur 이벤트 처리 (Enter 키로 저장한 경우 무시)
        handleMemoBlur(historyId, index) {
            // 저장 중이거나 이미 저장된 경우 무시
            if (this.isSavingMemo || this.editingMemoIndex === null) {
                return;
            }
            // 약간의 지연을 주어 Enter 키 이벤트가 먼저 처리되도록
            setTimeout(() => {
                if (this.editingMemoIndex === index && !this.isSavingMemo) {
                    this.saveMemo(historyId, index);
                }
            }, 150);
        },

        // 거래상태 변경 처리
        async handlePaymentStatusChange(historyId, index, isChecked) {
            try {
                const paymentStatus = isChecked ? '납부' : '미납';

                const response = await this.$axios.put(
                    `${this.$apiUrls.hanqmedi}/updateRentalHistoryPaymentStatus/${historyId}`,
                    { payment_status: paymentStatus },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if (response.data.success) {
                    // 로컬 상태 업데이트
                    this.rentalHistory[index].payment_status = paymentStatus;
                } else {
                    throw new Error(response.data.message || '거래상태 저장에 실패했습니다.');
                }
            } catch (error) {
                console.error('거래상태 저장 실패:', error);
                await this.$swal.fire({
                    icon: 'error',
                    title: '저장 실패',
                    text: error.response?.data?.message || error.message || '거래상태 저장 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
            }
        },

        // 메모 저장
        async saveMemo(historyId, index) {
            // 이미 저장 중이면 중복 저장 방지
            if (this.isSavingMemo) {
                return;
            }

            try {
                this.isSavingMemo = true;

                // 입력값 정리 (빈 문자열은 null로 변환, 공백만 있는 경우도 처리)
                const trimmedMemo = this.editingMemoValue?.trim() || '';
                const memoToSave = trimmedMemo === '' ? null : trimmedMemo;

                // 입력값이 변경되지 않았으면 취소만
                const currentMemo = this.rentalHistory[index].memo || null;
                if (currentMemo === memoToSave) {
                    this.cancelMemoEdit();
                    return;
                }

                const response = await this.$axios.put(
                    `${this.$apiUrls.hanqmedi}/updateRentalHistoryMemo/${historyId}`,
                    { memo: memoToSave },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if (response.data.success) {
                    // 로컬 상태 업데이트
                    this.rentalHistory[index].memo = memoToSave;

                    // 메모가 null이고 더 이상 표시할 필요가 없으면 섹션 숨김
                    if (!memoToSave && this.rentalHistory[index].memo === null) {
                        // 메모가 없으면 HistoryInfo가 v-if로 숨겨짐
                    }

                    this.cancelMemoEdit();
                } else {
                    throw new Error(response.data.message || '메모 저장에 실패했습니다.');
                }
            } catch (error) {
                console.error('메모 저장 실패:', error);
                await this.$swal.fire({
                    icon: 'error',
                    title: '저장 실패',
                    text: error.response?.data?.message || error.message || '메모 저장 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
                this.isSavingMemo = false;
            }
        },

        // 결제번호 수정 시작
        startPaymentNumberEdit(paymentNumber, index) {
            this.editingPaymentNumberIndex = index;
            this.editingPaymentNumberValue = paymentNumber || '0';
            this.isSavingPaymentNumber = false;
        },

        // 결제번호 수정 취소
        cancelPaymentNumberEdit() {
            this.editingPaymentNumberIndex = null;
            this.editingPaymentNumberValue = '';
            this.isSavingPaymentNumber = false;
        },

        // Enter 키 처리 (결제번호)
        handlePaymentNumberEnter(event) {
            event.preventDefault();
            event.stopPropagation();
            const index = this.editingPaymentNumberIndex;
            const historyId = this.rentalHistory[index]?.num;
            if (historyId) {
                this.savePaymentNumber(historyId, index);
            }
        },

        // Blur 이벤트 처리 (결제번호, Enter 키로 저장한 경우 무시)
        handlePaymentNumberBlur(historyId, index) {
            // 저장 중이거나 이미 저장된 경우 무시
            if (this.isSavingPaymentNumber || this.editingPaymentNumberIndex === null) {
                return;
            }
            // 약간의 지연을 주어 Enter 키 이벤트가 먼저 처리되도록
            setTimeout(() => {
                if (this.editingPaymentNumberIndex === index && !this.isSavingPaymentNumber) {
                    this.savePaymentNumber(historyId, index);
                }
            }, 150);
        },

        // 결제번호 저장
        async savePaymentNumber(historyId, index) {
            // 이미 저장 중이면 중복 저장 방지
            if (this.isSavingPaymentNumber) {
                return;
            }

            try {
                this.isSavingPaymentNumber = true;

                // 입력값 정리 (빈 문자열은 '0'으로 변환)
                const trimmedPaymentNumber = this.editingPaymentNumberValue?.trim() || '';
                const paymentNumberToSave = trimmedPaymentNumber === '' ? '0' : trimmedPaymentNumber;

                // 입력값이 변경되지 않았으면 취소만
                const currentPaymentNumber = this.rentalHistory[index].payment_number || '0';
                if (currentPaymentNumber === paymentNumberToSave) {
                    this.cancelPaymentNumberEdit();
                    return;
                }

                const response = await this.$axios.put(
                    `${this.$apiUrls.hanqmedi}/updateRentalHistoryPaymentNumber/${historyId}`,
                    { payment_number: paymentNumberToSave },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if (response.data.success) {
                    // 로컬 상태 업데이트
                    this.rentalHistory[index].payment_number = paymentNumberToSave;
                    this.cancelPaymentNumberEdit();
                } else {
                    throw new Error(response.data.message || '결제번호 저장에 실패했습니다.');
                }
            } catch (error) {
                console.error('결제번호 저장 실패:', error);
                await this.$swal.fire({
                    icon: 'error',
                    title: '저장 실패',
                    text: error.response?.data?.message || error.message || '결제번호 저장 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
                this.isSavingPaymentNumber = false;
            }
        },

        // 대여 이력 삭제 핸들러
        async handleDeleteRentalHistory(period) {
            if (period.extensionHistory) {
                // 연장 이력이 있는 경우
                const index = this.rentalHistory.findIndex(rh => rh.num === period.extensionHistory.num);
                if (index !== -1) {
                    await this.deleteRentalHistory(period.extensionHistory.num, index);
                }
            } else if (period.periodNumber === 1) {
                // 첫 회차인 경우 - 첫 회차에 해당하는 모든 이력 찾기
                const rentalStart = this.client_data_obj.rental_start
                    ? new Date(this.client_data_obj.rental_start)
                    : null;
                const extensionHistories = this.rentalHistory
                    .filter(h => h.type === '연장')
                    .sort((a, b) => new Date(a.date || a.created_at) - new Date(b.date || b.created_at));
                const firstExtension = extensionHistories[0];
                const firstPeriodEnd = firstExtension
                    ? new Date(firstExtension.date || firstExtension.created_at)
                    : (this.client_data_obj.rental_end ? new Date(this.client_data_obj.rental_end) : null);

                // 첫 회차에 해당하는 모든 이력 찾기
                const firstPeriodHistories = this.rentalHistory.filter(h => {
                    const hDate = new Date(h.date || h.created_at);
                    return hDate >= rentalStart && (!firstExtension || hDate < firstPeriodEnd);
                });

                if (firstPeriodHistories.length > 0) {
                    // 가장 최근 이력부터 삭제
                    const sortedHistories = firstPeriodHistories.sort((a, b) => {
                        const dateA = new Date(a.date || a.created_at);
                        const dateB = new Date(b.date || b.created_at);
                        return dateB - dateA;
                    });

                    const historyToDelete = sortedHistories[0];
                    const index = this.rentalHistory.findIndex(rh => rh.num === historyToDelete.num);
                    if (index !== -1) {
                        await this.deleteRentalHistory(historyToDelete.num, index);
                    }
                }
            }
        },

        // 대여 이력 삭제
        async deleteRentalHistory(historyId, index) {
            try {
                const result = await this.$swal.fire({
                    icon: 'warning',
                    title: '삭제 확인',
                    text: '해당 대여 이력을 삭제하시겠습니까?',
                    showCancelButton: true,
                    confirmButtonText: '삭제',
                    cancelButtonText: '취소',
                    confirmButtonColor: '#d33',
                    reverseButtons: true
                });

                if (!result.isConfirmed) return;

                const response = await this.$axios.delete(
                    `${this.$apiUrls.hanqmedi}/deleteRentalHistory/${historyId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if (response.data.success) {
                    // 로컬 상태에서 제거
                    this.rentalHistory.splice(index, 1);

                    // 삭제 후 결제구분 재설정
                    if (this.rentalHistory.length > 0) {
                        const latestPaymentHistory = this.rentalHistory
                            .filter(history => history.type === '결제' && history.payment_type)
                            .sort((a, b) => {
                                const dateA = new Date(a.date || a.created_at);
                                const dateB = new Date(b.date || b.created_at);
                                return dateB - dateA;
                            })[0];

                        if (latestPaymentHistory && latestPaymentHistory.payment_type) {
                            this.isInitializingPaymentMethod = true;
                            this.paymentMethod = latestPaymentHistory.payment_type;
                            this.$nextTick(() => {
                                this.isInitializingPaymentMethod = false;
                            });
                        } else {
                            // 결제 이력이 없으면 초기화
                            this.isInitializingPaymentMethod = true;
                            this.paymentMethod = '';
                            this.$nextTick(() => {
                                this.isInitializingPaymentMethod = false;
                            });
                        }
                    } else {
                        // 이력이 모두 없으면 결제구분 초기화
                        this.isInitializingPaymentMethod = true;
                        this.paymentMethod = '';
                        this.$nextTick(() => {
                            this.isInitializingPaymentMethod = false;
                        });
                    }

                    await this.$swal.fire({
                        icon: 'success',
                        title: '삭제 완료',
                        text: '대여 이력이 성공적으로 삭제되었습니다.',
                        confirmButtonText: '확인',
                        timer: 2000,
                        showConfirmButton: false
                    });
                } else {
                    throw new Error(response.data.message || '삭제에 실패했습니다.');
                }
            } catch (error) {
                console.error('대여 이력 삭제 실패:', error);
                await this.$swal.fire({
                    icon: 'error',
                    title: '삭제 실패',
                    text: error.response?.data?.message || error.message || '대여 이력 삭제 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
            }
        },

        // 대여 이력 타입을 배지 타입으로 변환
        getHistoryType(type) {
            const typeMap = {
                '회수': 'return',
                '회수취소': 'return-cancel',
                '연장': 'extend',
                '결제': 'payment',
                '중지': 'stop',
                '중지취소': 'stop_cancel',
                '기타': 'etc'
            };
            return typeMap[type] || 'etc';
        },

        // 대여 이력 조회
        async fetchRentalHistory() {
            try {
                const response = await this.$axios.get(
                    `${this.$apiUrls.hanqmedi}/getRentalHistory/${this.orderId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if (response.data.success) {
                    this.rentalHistory = response.data.data || [];

                    // 가장 최근의 결제 이력에서 payment_type 조회
                    const latestPaymentHistory = this.rentalHistory
                        .filter(history => history.type === '결제' && history.payment_type)
                        .sort((a, b) => {
                            // 날짜 기준으로 내림차순 정렬 (가장 최근이 먼저)
                            const dateA = new Date(a.date || a.created_at);
                            const dateB = new Date(b.date || b.created_at);
                            return dateB - dateA;
                        })[0];

                    // 가장 최근 결제 이력이 있고 payment_type이 있으면 설정
                    if (latestPaymentHistory && latestPaymentHistory.payment_type) {
                        this.isInitializingPaymentMethod = true; // 초기화 중 플래그 설정
                        this.paymentMethod = latestPaymentHistory.payment_type;
                        // nextTick을 사용하여 watch가 실행되기 전에 플래그를 해제
                        this.$nextTick(() => {
                            this.isInitializingPaymentMethod = false;
                        });
                    }
                }

            } catch (error) {
                console.error('대여 이력 조회 실패:', error);
                this.rentalHistory = [];
            }
        },

        // 대여 이력 저장
        async saveRentalHistory(type, paymentType = null, paymentNumber = null, paymentAmount = null, paymentStatus = null, memo = null) {
            try {
                // 결제 타입이 아니고 메모가 없거나 빈 값인 경우 기본 메모 설정
                if (type !== '결제' && (!memo || memo.trim() === '')) {
                    memo = '필요한 내용으로 메모를 수정해주세요.';
                }

                const response = await this.$axios.post(
                    `${this.$apiUrls.hanqmedi}/saveRentalHistory`,
                    {
                        orderId: this.orderId,
                        rentalId: this.client_data_obj.rental_id || null,
                        type,
                        paymentType,
                        paymentNumber,
                        paymentAmount,
                        paymentStatus,
                        memo,
                        date: new Date().toISOString()
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if (response.data.success) {
                    // 이력 저장 후 목록 새로고침
                    await this.fetchRentalHistory();
                }
            } catch (error) {
                console.error('대여 이력 저장 실패:', error);
            }
        },

        // 계약서용 계약 데이터 (원시 데이터만 전달)
        contractDataForModal() {
            return {
                companykey: this.$globalState.company_key,
                contractDate: new Date(),
                companyName: this.$globalState.company,
                companyAddress: this.$globalState.company_address,
                companyContact: this.$globalState.company_phone,
                companyBnum: this.$globalState.company_bnum,
                companyCeoName: this.$globalState.company_ceo_name,
                customerName: this.client_data_obj.name,
                customerAddress: this.getFullAddress(),
                customerContact: this.client_data_obj.phone1,
                customerIdNumber: this.client_data_obj.number,
                guardName: this.client_data_obj.guardname,
                guardTarget: this.client_data_obj.guardtarget,
                bank_name: this.$globalState.bank_name,
                bank_number: this.$globalState.bank_number,
                bank_username: this.$globalState.bank_username,
                orderId: this.orderId
            };
        },

        getFullAddress() {
            const address1 = this.postcode_obj.address1 || '';
            const detailAddress1 = this.postcode_obj.detailAddress1 || '';

            if (address1 && detailAddress1) {
                return `${address1} ${detailAddress1}`;
            } else if (address1) {
                return address1;
            } else if (detailAddress1) {
                return detailAddress1;
            }

            return '';
        },

        // PDF 등록 처리 메서드 수정
        async handlePDFRegistration(pdfData) {
            try {
                // File 객체인지 확인
                if (!(pdfData.file instanceof File)) {
                    console.error('File 객체가 아닙니다:', pdfData.file);
                    await Swal.fire({
                        title: '오류',
                        text: '잘못된 파일 형식입니다.',
                        icon: 'error',
                        confirmButtonText: '확인'
                    });
                    return;
                }

                await this.addFileToClaim(pdfData.file);

            } catch (error) {
                console.error('PDF 등록 실패:', error);
                await Swal.fire({
                    title: '오류',
                    text: 'PDF 등록 중 오류가 발생했습니다.',
                    icon: 'error',
                    confirmButtonText: '확인'
                });
            }
        },

        // 전체 PDF 등록 처리도 수정
        async handleAllPDFRegistration(data) {
            try {
                // 각 PDF 파일을 순차적으로 등록
                for (const pdfData of data.pdfs) {
                    await this.addFileToClaim(pdfData.file, pdfData.fileName);
                }

            } catch (error) {
                console.error('전체 PDF 등록 실패:', error);

                Swal.fire({
                    title: '오류',
                    text: 'PDF 파일 등록 중 오류가 발생했습니다.',
                    icon: 'error',
                    confirmButtonText: '확인'
                });
            }
        },

        // 파일 추가 메서드 수정
        addFileToClaim(file, fileType = '') {
            const claimSection = this.$refs.claimSection;
            if (!claimSection) {
                console.error('청구 정보 섹션을 찾을 수 없습니다.');
                return;
            }

            const claimElement = claimSection.$el || claimSection;

            let fileInput = claimElement.querySelector('input[type="file"]');
            if (!fileInput) {
                fileInput = document.createElement('input');
                fileInput.type = 'file';
                fileInput.accept = '.pdf';
                fileInput.style.display = 'none';
                claimElement.appendChild(fileInput);
            }

            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            fileInput.files = dataTransfer.files;

            const changeEvent = new Event('change', { bubbles: true });
            fileInput.dispatchEvent(changeEvent);
        },

        // 계약서용 제품 데이터 (원시 데이터만 전달)
        productsForContract() {
            return this.products_obj.map(product => ({
                ...product, // 원시 제품 데이터 전체 전달
                // barcodes 필드 추가 (ContractModal이 기대하는 형식)
                barcodes: product.options?.bcode || product.barcodes || [''],
                rentalStart: this.client_data_obj.rental_start,
                rentalEnd: this.client_data_obj.rental_end,
                oxygenStart: this.client_data_obj.oxygen_start,
                oxygenEnd: this.client_data_obj.oxygen_end
            }));
        },

        showRequiredDocumentsModalData() {
            this.showRequiredDocumentsModal = true;
        },

        // 전체 선택/해제 토글 메서드
        toggleSelectAll() {
            this.selectAll = !this.selectAll;
            if (this.documents && Array.isArray(this.documents)) {
                this.documents.forEach(doc => {
                    doc.selected = this.selectAll;
                });
            }
        },

        // 개별 파일 선택 시 전체 선택 체크박스 상태 업데이트
        handleSelection() {
            if (this.documents && Array.isArray(this.documents)) {
                // 모든 문서가 선택되었는지 확인
                const allSelected = this.documents.length > 0 &&
                    this.documents.every(doc => doc.selected);
                this.selectAll = allSelected;
            }
        },

        // 공단 지사 변경 처리
        handleBranchChanged(branchData) {
            console.log('선택된 공단지사:', branchData);
        },

        // 환자 등록 완료 처리
        async handlePatientRegistered(registrationData) {
            console.log('환자 등록 완료:', registrationData);

            // 모달 닫기
            this.showModal_obj.branch_selection = false;

            // 청구 상태 다시 로드하여 1단계가 "완료"로 표시되도록 함
            await this.loadClaimStatus();

            // 주문 데이터 새로고침
            await this.fetchOrderData();

            console.log('환자 등록 완료 후 상태 업데이트 완료');
        },

        getCurrentClaimType() {
            // rentalTypes를 기반으로 청구 타입 결정
            if (this.rentalTypes.hasOxygenGenerator || this.orderId?.rental_type === 'o') {
                return 'oxygen';
            } else if (this.rentalTypes.hasDiabetesProduct || this.orderId?.rental_type === 'd') {
                return 'diabetes';
            } else if (this.rentalTypes.hasAssistanceProduct || this.orderId?.rental_type === 'a') {
                return 'assistance';
            }

            // 기본값으로 'oxygen' 반환
            return 'oxygen';
        },

        getSelectedFiles() {
            return this.documents ? this.documents.filter(doc => doc.selected) : [];
        },

        // 환자 정보 가져오기
        getPatientInfo() {
            return {
                name: this.client_data_obj.name || '',
                residentNum: this.client_data_obj.number || '',
                phone: this.client_data_obj.phone1 || '',
                startDate: this.client_data_obj.oxygen_start || this.client_data_obj.diabetes_start || '',
                endDate: this.client_data_obj.oxygen_end || this.client_data_obj.diabetes_end || ''
            };
        },

        async loadClaimStatus() {
            try {
                // 주문서 타입 먼저 판단
                const claimType = this.getCurrentClaimType();

                let response;
                const apiUrl = claimType === 'diabetes'
                    ? `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`
                    : `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`;

                if (claimType === 'diabetes') {
                    // 당뇨소모성재료 청구 정보 조회
                    response = await this.$axios.get(apiUrl);
                } else {
                    // 산소치료 청구 정보 조회 (기본값)
                    response = await this.$axios.get(apiUrl);
                }

                if (response.data && response.data.success && response.data.data.length > 0) {
                    const latestClaim = response.data.data[0]; // 가장 최근 청구 정보

                    if (claimType === 'diabetes') {
                        // 당뇨 청구 상태 설정 - status에 따라 단계 결정
                        let currentStep = 0;
                        let currentStepText = '청구정보저장';
                        let isCompleted = false;

                        // status에 따라 단계 설정
                        switch (latestClaim.status) {
                            case '청구정보저장':
                                currentStep = 0;
                                currentStepText = '청구정보저장';
                                isCompleted = true;
                                break;
                            case '환자등록':
                                currentStep = 1;
                                currentStepText = '환자등록';
                                isCompleted = true;
                                break;
                            case '위임내역등록':
                                currentStep = 2;
                                currentStepText = '위임내역등록';
                                isCompleted = true;
                                break;
                            case '청구등록':
                                currentStep = 3;
                                currentStepText = '청구등록';
                                isCompleted = true;
                                break;
                            case '청구완료':
                                currentStep = 4;
                                currentStepText = '청구완료';
                                isCompleted = true;
                                break;
                            case '완료':
                                currentStep = 4;
                                currentStepText = '청구완료';
                                isCompleted = true;
                                break;
                            default:
                                currentStep = 0;
                                currentStepText = '청구정보저장';
                                isCompleted = false;
                        }

                        this.claimStatus = {
                            hasClaimData: true,
                            currentStep: currentStep,
                            currentStepText: currentStepText,
                            isCompleted: isCompleted
                        };

                    } else {
                        // 산소 청구 상태 설정 - status에 따라 단계 결정
                        let currentStep = 0;
                        let currentStepText = '청구정보저장';
                        let isCompleted = false;

                        // status에 따라 단계 설정 (산소도 동일한 로직 적용)
                        switch (latestClaim.status) {
                            case '청구정보저장':
                                currentStep = 0;
                                currentStepText = '청구정보저장';
                                isCompleted = true;
                                break;
                            case '환자등록':
                                currentStep = 1;
                                currentStepText = '환자등록';
                                isCompleted = true;
                                break;
                            case '위임내역등록':
                                currentStep = 2;
                                currentStepText = '위임내역등록';
                                isCompleted = true;
                                break;
                            case '청구등록':
                                currentStep = 3;
                                currentStepText = '청구등록';
                                isCompleted = true;
                                break;
                            case '청구완료':
                                currentStep = 4;
                                currentStepText = '청구완료';
                                isCompleted = true;
                                break;
                            case '완료':
                                currentStep = 4;
                                currentStepText = '청구완료';
                                isCompleted = true;
                                break;
                            default:
                                // 기존 currentStep과 currentStepText 사용 (하위 호환성)
                                currentStep = latestClaim.currentStep || 0;
                                currentStepText = latestClaim.currentStepText || '청구정보저장';
                                isCompleted = latestClaim.currentStatus === 'completed';
                        }

                        this.claimStatus = {
                            hasClaimData: true,
                            currentStep: currentStep,
                            currentStepText: currentStepText,
                            isCompleted: isCompleted
                        };
                    }
                } else {
                    // 청구 정보가 없는 경우
                    this.claimStatus = {
                        hasClaimData: false,
                        currentStep: 0,
                        currentStepText: '청구정보저장',
                        isCompleted: false
                    };
                }
            } catch (error) {
                this.claimStatus = {
                    hasClaimData: false,
                    currentStep: 0,
                    currentStepText: '청구정보저장',
                    isCompleted: false
                };
            }
        },

        // 청구 계산용 선택된 품목 데이터 가져오기
        getSelectedProductsForClaim() {
            try {
                if (!this.products_obj || !Array.isArray(this.products_obj)) {
                    console.warn('products_obj가 정의되지 않았거나 배열이 아닙니다.');
                    return [];
                }

                return this.products_obj
                    .filter(product => product && product.selected)
                    .map(product => ({
                        id: product.id,
                        name: product.name3,
                        price: product.buyprice,
                        quantity: product.quantity,
                        type: product.type,
                        pieces_per_box: product.pieces_per_box,
                        piece_quantity: product.piece_quantity,
                        all_quantity: product.all_quantity,
                        isDiabetes: this.rentalTypes?.hasDiabetesProduct || false,
                        isOxygen: this.rentalTypes?.hasOxygenGenerator || false,
                        isAssistance: this.rentalTypes?.hasAssistanceProduct || false
                    }));
            } catch (error) {
                console.error('선택된 품목 데이터 가져오기 중 오류:', error);
                return [];
            }
        },

        // 추가 청구 데이터 가져오기
        getAdditionalClaimData() {
            const additionalData = {
                // 주문 기본 정보
                orderInfo: {
                    orderId: this.orderId,
                    orderDate: this.orderDate,
                    salesPerson: this.salesPerson,
                    deliveryMemo: this.selectedDeliveryMemo,
                    returnStatus: this.returnStatus,
                    virtualAccountHistory: this.virtualAccountHistory || []
                },

                // 수급자 상세 정보
                clientDetails: {
                    name: this.client_data_obj.name || '',
                    number: this.client_data_obj.number || '',
                    resident: this.client_data_obj.regident || '',
                    phone1: this.client_data_obj.phone1 || '',
                    phone2: this.client_data_obj.phone2 || '',
                    guardname: this.client_data_obj.guardname || '',
                    guardtarget: this.client_data_obj.guardtarget || '',
                    centername: this.client_data_obj.centername || '',
                    manager: this.client_data_obj.manager || '',
                    oxygen_type: this.client_data_obj.oxygen_type || '',
                    rental_start: this.client_data_obj.rental_start || '',
                    rental_end: this.client_data_obj.rental_end || '',
                    oxygen_start: this.client_data_obj.oxygen_start || '',
                    oxygen_end: this.client_data_obj.oxygen_end || ''
                },

                // 주소 정보
                addressInfo: {
                    postcode1: this.postcode_obj.postcode1 || '',
                    address1: this.postcode_obj.address1 || '',
                    detailAddress1: this.postcode_obj.detailAddress1 || '',
                    postcode2: this.postcode_obj.postcode2 || '',
                    address2: this.postcode_obj.address2 || '',
                    detailAddress2: this.postcode_obj.detailAddress2 || ''
                },

                // 품목 정보
                productInfo: {
                    products: this.products_obj || [],
                    selectedProducts: this.getSelectedProductsForClaim(),
                    totalProducts: this.products_obj?.length || 0,
                    rentalTypes: this.rentalTypes || []
                },

                // 청구 관련 정보
                claimInfo: {
                    claimType: this.getCurrentClaimType(),
                    isAsOrder: this.isAsOrder,
                    isReturnOrder: this.isReturnOrder,
                    currentStep: this.currentStep,
                },

                // 가상계좌 정보
                virtualAccountInfo: {
                    virtualAccountCount: this.virtualAccountCount || 0,
                    virtualAccountHistory: this.virtualAccountHistory || []
                }
            };

            return additionalData;
        },

        formatDateForCrawling(dateString) {
            if (!dateString) return '';

            // Date 객체로 변환
            const date = new Date(dateString);

            // YYYYMMDD 형식으로 변환
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}${month}${day}`;
        },

        // 문서 발행 여부 확인
        async checkDocumentIssuance(orderId, claimType) {
            try {
                const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/checkDocumentIssuance`, {
                    params: {
                        orderId: orderId,
                        claimType: claimType
                    }
                });

                return response.data;
            } catch (error) {
                console.error('문서 발행 여부 확인 실패:', error);
                throw error;
            }
        },

        // 문서 발행 모달에서 발행 완료 후 청구 진행
        async onDocumentIssuanceComplete() {
            this.showDocumentIssuanceModal = false;

            if (this.pendingClaimData) {
                const { claimId, claimType } = this.pendingClaimData;
                this.pendingClaimData = null;

                // 청구 진행
                await this.proceedWithClaim(claimId, claimType);
            }
        },

        // 위임내역등록 시작 알림 메서드 추가
        showClaimStartNotification(claimId, step = '위임내역등록') {
            const claimType = this.getCurrentClaimType();
            const claimTypeText = claimType === 'oxygen' ? '산소치료' : '당뇨소모성재료';
            const patientName = this.client_data_obj.name || '고객';

            // 단계별 메시지 설정
            const stepMessages = {
                '청구정보입력': `${patientName}님의 ${claimTypeText} 청구정보입력이 시작되었습니다.`,
                '환자등록': `${patientName}님의 ${claimTypeText} 환자등록이 시작되었습니다.`,
                '위임내역등록': `${patientName}님의 ${claimTypeText} 위임내역등록이 시작되었습니다.`,
                '청구등록': `${patientName}님의 ${claimTypeText} 청구등록이 시작되었습니다.`
            };

            const toastMessage = stepMessages[step] || stepMessages['위임내역등록'];

            // Swal Toast 알림
            this.$swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'info',
                title: toastMessage,
                timer: 8000,
                timerProgressBar: true,
                showConfirmButton: false
            });

            // 헤더 알림 메시지에 추가
            if (this.globalMessageSystem) {
                const newMessage = {
                    id: Date.now(),
                    type: 'info',
                    title: `${claimTypeText} ${step} 시작`,
                    text: `${patientName}님의 ${step}이 시작되었습니다.`,
                    timestamp: new Date(),
                    isRead: false
                };

                this.globalMessageSystem.addMessage(newMessage);
            }
        },

        // 청구정보입력 시작 알림
        showClaimInfoStartNotification() {
            const claimId = this.uuidv4();
            this.showClaimStartNotification(claimId, '청구정보입력');
        },

        // 환자등록 시작 알림
        showPatientRegistrationStartNotification() {
            const claimId = this.uuidv4();
            this.showClaimStartNotification(claimId, '환자등록');
        },

        // 청구등록 시작 알림
        showClaimRegistrationStartNotification() {
            const claimId = this.uuidv4();
            this.showClaimStartNotification(claimId, '청구등록');
        },

        uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0;
                const v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        getCurrentClaimType() {
            // rentalTypes를 기반으로 청구 타입 결정
            if (this.rentalTypes.hasOxygenGenerator || this.orderId?.rental_type === 'o') {
                return 'oxygen';
            } else if (this.rentalTypes.hasDiabetesProduct || this.orderId?.rental_type === 'd') {
                return 'diabetes';
            } else if (this.rentalTypes.hasAssistanceProduct || this.orderId?.rental_type === 'a') {
                return 'assistance';
            }

            // 기본값으로 'oxygen' 반환
            return 'oxygen';
        },

        showRequiredDocumentsModalData() {
            this.showRequiredDocumentsModal = true;
        },

        // 청구 정보 입력 모달 열기
        openClaimInfoInput() {
            this.showClaimInfoModal = true;
        },

        // 청구 정보 입력 모달 닫기
        closeClaimInfoModal() {
            this.showClaimInfoModal = false;
        },

        // 1단계: 환자 등록 모달 열기
        async openPatientRegistration() {
            // 선택된 파일 개수 확인
            const selectedFiles = this.documents ? this.documents.filter(doc => doc.selected) : [];

            if (selectedFiles.length < 3) {
                this.$swal.fire({
                    title: '파일 선택 필요',
                    html: `
                        <div style="text-align: left;">
                        <p style="margin-bottom: 15px; font-weight: 500;">환자 등록을 위해 다음 3개 파일을 모두 선택해주세요.</p>
                        <ul style="margin: 0; padding-left: 20px;">
                            <li style="margin-bottom: 5px;">처방전</li>
                            <li style="margin-bottom: 5px;">급여대상자 등록신청서</li>
                            <li style="margin-bottom: 5px;">위임인 신분증</li>
                        </ul>
                        <p style="margin-top: 15px; color: #6b7280; font-size: 15px;">
                            현재 선택된 파일: <strong>${selectedFiles.length}개</strong>
                        </p>
                        </div>
                    `,
                    icon: 'warning',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#3b82f6'
                });
                return;
            }

            // BranchComponent 모달 열기
            this.showModal_obj.branch_selection = true;
        },

        // 2단계: 요양비청구위임내역등록 모달 열기
        async submitClaimList() {
            if (!this.client_data_obj.name || !this.client_data_obj.number || !this.client_data_obj.phone1) {
                this.$swal.fire({
                    icon: 'warning',
                    title: '필수 정보 누락',
                    text: '성명, 주민번호, 연락처는 필수 입력 사항입니다.',
                    confirmButtonText: '확인'
                });
                return;
            }

            const selectedFiles = this.documents ? this.documents.filter(doc => doc.selected) : [];
            if (selectedFiles.length < 2) {
                this.$swal.fire({
                    icon: 'warning',
                    title: '필수 서류 누락',
                    html: `
                <div style="text-align: left;">
                    <p style="margin-bottom: 15px; font-weight: 500;">위임내역등록을 위해 다음 2개 파일을 모두 선택해주세요.</p>
                    <ul style="margin: 0; padding-left: 20px;">
                        <li style="margin-bottom: 5px;">요양비 지급청구 위임장</li>
                        <li style="margin-bottom: 5px;">신분증</li>
                    </ul>
                    <p style="margin-top: 15px; color: #6b7280; font-size: 15px;">
                        현재 선택된 파일: <strong>${selectedFiles.length}개</strong>
                    </p>
                </div>
            `,
                    icon: 'warning',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#3b82f6'
                });
                return;
            }

            // 진행 상태 설정
            this.isSubmitting = true;

            // 고유 claim_id 생성
            const claimId = this.uuidv4();
            this.claimId = claimId;

            // 위임내역등록 시작 알림 추가
            this.showClaimStartNotification(claimId);

            try {
                // === test 계정인 경우 시뮬레이션 모드 ===
                if (this.isTestUser) {
                    await this.simulateClaimProcess(claimId);
                    return;
                }

                // === 실제 청구 처리 ===
                let savedFiles = [];
                if (selectedFiles && selectedFiles.length > 0) {
                    const fileData = await Promise.all(
                        selectedFiles.map(async (doc) => {
                            try {
                                // 파일 데이터를 가져오는 로직
                                const response = await fetch(doc.url);
                                const arrayBuffer = await response.arrayBuffer();
                                const uint8Array = new Uint8Array(arrayBuffer);
                                return {
                                    name: doc.fileName,
                                    data: Array.from(uint8Array),
                                    size: doc.size || 0,
                                    type: doc.type || 'application/octet-stream',
                                    documentType: doc.documentType || 'unknown'
                                };
                            } catch (error) {
                                console.warn('파일 처리 실패:', doc.fileName, error);
                                return null;
                            }
                        })
                    );

                    // null 값 제거
                    const validFileData = fileData.filter(file => file !== null);

                    // 일렉트론 환경에서만 파일 저장
                    if (window.electronAPI && window.electronAPI.saveCrawlingFiles && validFileData.length > 0) {
                        const saveResult = await window.electronAPI.saveCrawlingFiles({
                            files: validFileData,
                            claimId: claimId
                        });

                        if (saveResult.success) {
                            savedFiles = saveResult.files;
                        }
                    }
                }

                // === DB에서 청구 정보 가져오기 ===
                let claimDataFromDB = null;
                const claimType = this.getCurrentClaimType();

                try {
                    if (claimType === 'diabetes') {
                        // 당뇨소모성재료 청구 데이터 조회
                        const diabetesResponse = await this.$axios.get(
                            `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            }
                        );

                        if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
                            claimDataFromDB = diabetesResponse.data.data[0];
                            console.log('당뇨소모성재료 청구 데이터 조회 완료:', claimDataFromDB);
                        } else {
                            throw new Error('당뇨소모성재료 청구 데이터를 찾을 수 없습니다.');
                        }
                    } else if (claimType === 'oxygen') {
                        // 산소치료 청구 데이터 조회
                        const oxygenResponse = await this.$axios.get(
                            `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            }
                        );

                        if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
                            claimDataFromDB = oxygenResponse.data.data[0];
                            console.log('산소치료 청구 데이터 조회 완료:', claimDataFromDB);
                        } else {
                            throw new Error('산소치료 청구 데이터를 찾을 수 없습니다.');
                        }
                    }
                } catch (dbError) {
                    console.error('DB에서 청구 데이터 조회 실패:', dbError);
                    throw new Error('청구 데이터를 가져올 수 없습니다. 먼저 청구 정보를 입력해주세요.');
                }

                // 크롤링 데이터 준비 (DB에서 가져온 정보 사용)
                const claimData = {
                    claimId: claimId,
                    type: claimType === 'oxygen' ? 'oxygen-claim-list' : 'diabetes-claim-list',
                    certificateName: claimDataFromDB.certificate_id || '',
                    cert_password: claimDataFromDB.certificate_pw || '',
                    client_info: {
                        name: claimDataFromDB.name,
                        resident_num: claimDataFromDB.number,
                        phone: claimDataFromDB.phone,
                        ...(claimType === 'oxygen' && (() => {
                            const receiptType = claimDataFromDB.receipt_type;
                            const hasHomeData = claimDataFromDB.home_oxygen_number && claimDataFromDB.home_start_date;
                            const hasMobileData = claimDataFromDB.mobile_oxygen_number && claimDataFromDB.mobile_start_date;

                            if (receiptType === '동시접수') {
                                return {
                                    homeOxygen: true,
                                    mobileOxygen: true,
                                    simultaneousOxygen: true
                                };
                            }

                            return {
                                homeOxygen: receiptType === '가정용' || hasHomeData,
                                mobileOxygen: receiptType === '휴대용' || hasMobileData,
                                simultaneousOxygen: false
                            };
                        })())
                    },
                    rental_info: {
                        order_id: this.orderId,
                        company_key: this.$globalState.company_key
                    },
                    products: (this.products_obj || []).map(product => ({
                        id: product.id,
                        name: product.name,
                        quantity: product.quantity,
                    })),
                    files: savedFiles.map(file => file.path || file.name)
                };

                console.log(' 크롤링 데이터 준비 완료:', claimData);

                let crawlingResult;

                // 일렉트론 환경에서만 크롤링 실행
                if (window.electronAPI && window.electronAPI.startCrawling) {
                    // 객체를 JSON으로 직렬화하여 전달
                    const serializedClaimData = JSON.parse(JSON.stringify(claimData));
                    crawlingResult = await window.electronAPI.startCrawling(serializedClaimData);
                } else {
                    // 웹 환경에서는 에러 처리
                    throw new Error('일렉트론 환경에서만 크롤링을 실행할 수 있습니다.');
                }

                console.log(' 크롤링 결과:', crawlingResult);

                // 크롤링 결과 검증
                if (!crawlingResult) {
                    throw new Error('크롤링 결과를 받을 수 없습니다.');
                }

                if (!crawlingResult.success) {
                    throw new Error(crawlingResult.error || '크롤링 처리 실패');
                }

                try {
                    if (claimType === 'diabetes') {
                        // 당뇨소모성재료 청구 데이터 ID 조회 후 상태 업데이트
                        const diabetesResponse = await this.$axios.get(
                            `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            }
                        );

                        if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
                            const diabetesDataId = diabetesResponse.data.data[0].num;
                            await this.$axios.put(
                                `${this.$apiUrls.hanqmedi}/diabetesClaimStatus/${diabetesDataId}`,
                                { status: '위임내역등록' },
                                {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    }
                                }
                            );
                            console.log('당뇨소모성재료 상태 업데이트 완료');
                        } else {
                            throw new Error('당뇨소모성재료 청구 데이터를 찾을 수 없습니다.');
                        }
                    } else if (claimType === 'oxygen') {
                        // 산소치료 청구 데이터 ID 조회 후 상태 업데이트
                        const oxygenResponse = await this.$axios.get(
                            `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            }
                        );

                        if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
                            const oxygenDataId = oxygenResponse.data.data[0].num;
                            await this.$axios.put(
                                `${this.$apiUrls.hanqmedi}/oxygenClaimStatus/${oxygenDataId}`,
                                { status: '위임내역등록' },
                                {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    }
                                }
                            );
                            console.log('산소치료 상태 업데이트 완료');
                        } else {
                            throw new Error('산소치료 청구 데이터를 찾을 수 없습니다.');
                        }
                    }

                    // 상태 업데이트 후 청구 상태 다시 로드
                    await this.loadClaimStatus();

                } catch (statusUpdateError) {
                    console.warn('청구 상태 업데이트 실패, 하지만 크롤링은 성공했으므로 계속 진행합니다:', statusUpdateError.message);
                }

                setTimeout(() => {
                    this.$swal.fire({
                        title: '청구 처리 완료',
                        text: '청구 처리가 완료되었습니다.',
                        icon: 'success',
                        confirmButtonText: '확인'
                    });
                }, 500);

                // 성공 시 상태 업데이트
                this.currentStep = 3;

                // 크롤링 성공 시에만 다음 청구 자동 생성
                if (claimType === 'oxygen') {
                    // 현재 청구 데이터를 가져와서 다음 청구 생성
                    try {
                        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`);
                        if (response.data && response.data.success && response.data.data.length > 0) {
                            const latestClaim = response.data.data[response.data.data.length - 1];
                            await this.createNextOxygenClaim(latestClaim);
                        }
                    } catch (error) {
                        console.error('다음 청구 생성 중 오류:', error);
                    }
                }

            } catch (error) {
                console.error('청구 처리 실패:', error);

                // 사용자 취소 에러인지 확인
                if (error.message && error.message.includes('사용자의 요청으로 크롬창이 닫혔습니다')) {

                    this.$swal.fire({
                        icon: 'info',
                        title: '크롤링 취소됨',
                        text: '사용자의 요청으로 크롤링이 취소되었습니다.',
                        confirmButtonText: '확인'
                    });
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: '청구등록 실패',
                        text: '청구등록 중 에러가 발생하여 실패하였습니다.',
                        confirmButtonText: '확인'
                    });
                }
            } finally {
                this.isSubmitting = false;
            }
        },

        // 3단계: 청구 등록 (수정)
        async submitClaim() {
            // 진행 상태 설정
            this.isSubmitting = true;

            // 고유 claim_id 생성
            const claimId = this.uuidv4();
            this.claimId = claimId;

            // 청구 시작 알림
            this.showClaimRegistrationStartNotification();

            try {
                // === test 계정인 경우 시뮬레이션 모드 ===
                if (this.isTestUser) {
                    await this.simulateClaimProcess(claimId);
                    return;
                }

                // === 실제 청구 처리 ===
                const claimType = this.getCurrentClaimType();

                const documentInfo = await this.checkDocumentIssuance(this.orderId, claimType);
                console.log('📋 문서 발행 정보:', documentInfo);

                if (!documentInfo.success) {
                    throw new Error(documentInfo.message || '문서 발행 여부 확인에 실패했습니다.');
                }

                // 문서가 모두 발행된 경우 바로 청구 진행
                if (documentInfo.hasTaxInvoice && documentInfo.hasCashReceipt) {
                    console.log('✅ 모든 문서가 이미 발행됨, 청구 진행');
                    await this.proceedWithClaim(claimId, claimType);
                    return;
                }

                // 문서 발행이 필요한 경우 모달 표시
                console.log('📋 문서 발행이 필요함, 모달 표시');
                this.documentIssuanceInfo = {
                    hasTaxInvoice: documentInfo.hasTaxInvoice,
                    hasCashReceipt: documentInfo.hasCashReceipt,
                    mgtKey: documentInfo.mgtKey,
                    mgtKey2: documentInfo.mgtKey2
                };

                this.pendingClaimData = { claimId, claimType };
                this.showDocumentIssuanceModal = true;
                this.isSubmitting = false;

            } catch (error) {
                console.error('❌ 청구 처리 실패:', error);
                this.isSubmitting = false;

                // ✅ 크롤링 서버 연결 에러인 경우 (이미 구체적으로 처리됨)
                if (error.message && error.message.includes('ECONNREFUSED')) {
                    this.$swal.fire({
                        icon: 'error',
                        title: '크롤링 서버 연결 실패',
                        text: '크롤링 서버에 연결할 수 없습니다. 서버가 실행 중인지 확인해주세요.',
                        confirmButtonText: '확인'
                    });
                } else if (error.message && error.message.includes('자동 로그인 실패')) {
                    this.$swal.fire({
                        icon: 'error',
                        title: '로그인 실패',
                        text: '자동 로그인에 실패했습니다. 수동으로 로그인 후 다시 시도해주세요.',
                        confirmButtonText: '확인'
                    });
                } else {
                    // ✅ getKoreanErrorMessage로 변환된 에러 메시지 사용
                    const errorMessage = error.message || '처리 중 예상치 못한 오류가 발생했습니다.';

                    this.$swal.fire({
                        icon: 'error',
                        title: '청구등록 실패',
                        text: errorMessage,
                        confirmButtonText: '확인'
                    });
                }
            }
        },

        // 문서 발행 완료 후 실제 청구 진행
        async proceedWithClaim(claimId, claimType) {
            try {
                this.isSubmitting = true;

                // 파일 처리
                let savedFiles = [];

                // 선택된 파일 확인 (documents 배열에서 선택된 파일들)
                const selectedFiles = this.documents ? this.documents.filter(doc => doc.selected) : [];

                if (selectedFiles && selectedFiles.length > 0) {
                    const fileData = await Promise.all(
                        selectedFiles.map(async (doc) => {
                            try {
                                // 파일 데이터를 가져오는 로직
                                const response = await fetch(doc.url);
                                const arrayBuffer = await response.arrayBuffer();
                                const uint8Array = new Uint8Array(arrayBuffer);
                                return {
                                    name: doc.fileName,
                                    data: Array.from(uint8Array),
                                    size: doc.size || 0,
                                    type: doc.type || 'application/octet-stream',
                                    documentType: doc.documentType || 'unknown'
                                };
                            } catch (error) {
                                console.warn('파일 처리 실패:', doc.fileName, error);
                                return null;
                            }
                        })
                    );

                    // null 값 제거
                    const validFileData = fileData.filter(file => file !== null);

                    // 일렉트론 환경에서만 파일 저장
                    if (window.electronAPI && window.electronAPI.saveCrawlingFiles && validFileData.length > 0) {
                        const saveResult = await window.electronAPI.saveCrawlingFiles({
                            files: validFileData,
                            claimId: claimId
                        });

                        if (saveResult.success) {
                            savedFiles = saveResult.files;
                        }
                    }
                }

                // === DB에서 청구 정보 가져오기 ===
                let claimDataFromDB = null;

                try {
                    if (claimType === 'diabetes') {
                        const diabetesResponse = await this.$axios.get(
                            `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            }
                        );

                        if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
                            claimDataFromDB = diabetesResponse.data.data[0];
                        } else {
                            throw new Error('당뇨소모성재료 청구 데이터를 찾을 수 없습니다.');
                        }
                    } else if (claimType === 'oxygen') {
                        const oxygenResponse = await this.$axios.get(
                            `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            }
                        );

                        if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
                            claimDataFromDB = oxygenResponse.data.data[0];
                        } else {
                            throw new Error('산소치료 청구 데이터를 찾을 수 없습니다.');
                        }
                    }
                } catch (dbError) {
                    console.error('❌ DB에서 청구 데이터 조회 실패:', dbError);
                    throw new Error('청구 데이터를 가져올 수 없습니다. 먼저 청구 정보를 입력해주세요.');
                }

                // 크롤링 데이터 준비 (DB에서 가져온 정보 사용)
                const claimData = {
                    claimId: claimId,
                    type: claimType === 'oxygen' ? 'oxygen-claim' : 'diabetes-claim',
                    certificateName: claimDataFromDB.certificate_id || '',
                    cert_password: claimDataFromDB.certificate_pw || '',
                    client_info: {
                        name: claimDataFromDB.name,
                        resident_num1: claimDataFromDB.number ? claimDataFromDB.number.substring(0, 6) : '',
                        resident_num2: claimDataFromDB.number ? claimDataFromDB.number.substring(6) : '',
                        phone: claimDataFromDB.phone,
                        // 산소발생기 관련 정보는 산소 청구일 때만 포함
                        ...(claimType === 'oxygen' && {
                            homeOxygen: this.client_data_obj.oxygen_type?.includes('가정용') || false,
                            mobileOxygen: this.client_data_obj.oxygen_type?.includes('휴대용') || false,
                            simultaneousOxygen: this.client_data_obj.oxygen_type === '가정용/휴대용',
                            oxygenDate: this.formatDateForCrawling(claimDataFromDB.oxygen_date) || '',
                            oxygenSdate: this.formatDateForCrawling(claimDataFromDB.start_date) || this.formatDateForCrawling(this.client_data_obj.oxygen_start) || this.getCurrentDate(),
                            oxygenEdate: this.formatDateForCrawling(claimDataFromDB.end_date) || this.formatDateForCrawling(this.client_data_obj.oxygen_end) || this.getCurrentDate(),
                            useHomeStartDate: this.formatDateForCrawling(claimDataFromDB.home_start_date) || '',
                            useHomeEndDate: this.formatDateForCrawling(claimDataFromDB.home_end_date) || '',
                            useMobileStartDate: this.formatDateForCrawling(claimDataFromDB.mobile_start_date) || '',
                            useMobileEndDate: this.formatDateForCrawling(claimDataFromDB.mobile_end_date) || '',
                            homeBillingCount: claimDataFromDB.home_count || '',
                            mobileBillingCount: claimDataFromDB.mobile_count || '',
                            oxygenHomeGenerator: claimDataFromDB.home_oxygen_number || '',
                            oxygenMobileGenerator: claimDataFromDB.mobile_oxygen_number || '',
                            cashReceipt: claimDataFromDB.cash_receipt || '',
                            cashReceiptDate: this.formatDateForCrawling(claimDataFromDB.cash_receipt_date) || '',
                            cashReceiptAmount: claimDataFromDB.cash_receipt_amount || '',
                            taxInvoice: claimDataFromDB.tax_invoice || '',
                            taxInvoiceDate: this.formatDateForCrawling(claimDataFromDB.tax_invoice_date) || '',
                            taxInvoiceAmount: claimDataFromDB.tax_invoice_amount || '',
                            doctorLicense: claimDataFromDB.doctor_number || '',
                            specialistLicense: claimDataFromDB.specialist_number || '',
                            diseaseCode: claimDataFromDB.disease_code || '',
                            diseaseName: claimDataFromDB.disease_name || '',
                            bloodGasItem1: (claimDataFromDB.gas_item1 === 1 || claimDataFromDB.gas_item1 === '1' || claimDataFromDB.gas_item1 === true) ? true : false,
                            bloodGasItem2: (claimDataFromDB.gas_item2 === 1 || claimDataFromDB.gas_item2 === '1' || claimDataFromDB.gas_item2 === true) ? true : false,
                            bloodGasItem3: (claimDataFromDB.gas_item3 === 1 || claimDataFromDB.gas_item3 === '1' || claimDataFromDB.gas_item3 === true) ? true : false,
                            bloodGasItem4: (claimDataFromDB.gas_item4 === 1 || claimDataFromDB.gas_item4 === '1' || claimDataFromDB.gas_item4 === true) ? true : false,
                            bloodGasItem5: (claimDataFromDB.gas_item5 === 1 || claimDataFromDB.gas_item5 === '1' || claimDataFromDB.gas_item5 === true) ? true : false,
                            bloodGasItem6: (claimDataFromDB.gas_item6 === 1 || claimDataFromDB.gas_item6 === '1' || claimDataFromDB.gas_item6 === true) ? true : false,
                            bloodGasItem7: (claimDataFromDB.gas_item7 === 1 || claimDataFromDB.gas_item7 === '1' || claimDataFromDB.gas_item7 === true) ? true : false,
                            oxygenSaturationItem1: (claimDataFromDB.oxygen_item1 === 1 || claimDataFromDB.oxygen_item1 === '1' || claimDataFromDB.oxygen_item1 === true) ? true : false,
                            oxygenSaturationItem2: (claimDataFromDB.oxygen_item2 === 1 || claimDataFromDB.oxygen_item2 === '1' || claimDataFromDB.oxygen_item2 === true) ? true : false,
                            oxygenSaturationItem3: (claimDataFromDB.oxygen_item3 === 1 || claimDataFromDB.oxygen_item3 === '1' || claimDataFromDB.oxygen_item3 === true) ? true : false,
                            oxygenSaturationItem4: (claimDataFromDB.oxygen_item4 === 1 || claimDataFromDB.oxygen_item4 === '1' || claimDataFromDB.oxygen_item4 === true) ? true : false,
                            oxygenSaturationItem5: (claimDataFromDB.oxygen_item5 === 1 || claimDataFromDB.oxygen_item5 === '1' || claimDataFromDB.oxygen_item5 === true) ? true : false,
                            issuanceType: claimDataFromDB.issuance_type || '최초'
                        })
                    },
                    rental_info: {
                        order_id: this.orderId,
                        company_key: this.$globalState.company_key
                    },
                    products: (this.products_obj || []).map(product => ({
                        id: product.id,
                        name: product.name,
                        quantity: product.quantity,
                    })),
                    files: savedFiles.map(file => file.path || file.name),
                };

                let crawlingResult;

                // 일렉트론 환경에서만 크롤링 실행
                if (window.electronAPI && window.electronAPI.startCrawling) {
                    const serializedClaimData = JSON.parse(JSON.stringify(claimData));
                    crawlingResult = await window.electronAPI.startCrawling(serializedClaimData);
                } else {
                    throw new Error('일렉트론 환경에서만 크롤링을 실행할 수 있습니다.');
                }

                // 크롤링 결과 검증
                if (!crawlingResult) {
                    throw new Error('크롤링 결과를 받을 수 없습니다.');
                }

                if (!crawlingResult.success) {
                    throw new Error(crawlingResult.error || '크롤링 처리 실패');
                }

                try {
                    if (claimType === 'diabetes') {
                        const diabetesResponse = await this.$axios.get(
                            `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            }
                        );

                        if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
                            const diabetesDataId = diabetesResponse.data.data[0].num;
                            await this.$axios.put(
                                `${this.$apiUrls.hanqmedi}/diabetesClaimStatus/${diabetesDataId}`,
                                { status: '청구등록' },
                                {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    }
                                }
                            );
                        } else {
                            throw new Error('당뇨소모성재료 청구 데이터를 찾을 수 없습니다.');
                        }
                    } else if (claimType === 'oxygen') {
                        const oxygenResponse = await this.$axios.get(
                            `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            }
                        );

                        if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
                            const oxygenDataId = oxygenResponse.data.data[0].num;
                            await this.$axios.put(
                                `${this.$apiUrls.hanqmedi}/oxygenClaimStatus/${oxygenDataId}`,
                                { status: '청구등록' },
                                {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    }
                                }
                            );
                        } else {
                            throw new Error('산소치료 청구 데이터를 찾을 수 없습니다.');
                        }
                    }

                    // 상태 업데이트 후 청구 상태 다시 로드
                    await this.loadClaimStatus();

                } catch (statusUpdateError) {
                    console.warn('청구 상태 업데이트 실패, 하지만 크롤링은 성공했으므로 계속 진행합니다:', statusUpdateError.message);
                }

                setTimeout(() => {
                    this.$swal.fire({
                        title: '청구 처리 완료',
                        text: '청구 처리가 완료되었습니다.',
                        icon: 'success',
                        confirmButtonText: '확인'
                    });
                }, 500);

                // 성공 시 상태 업데이트
                this.currentStep = 3;

            } catch (error) {
                console.error('❌ 청구 처리 실패:', error);

                // 사용자 취소 에러인지 확인
                if (error.message && error.message.includes('사용자의 요청으로 크롬창이 닫혔습니다')) {
                    this.$swal.fire({
                        icon: 'info',
                        title: '크롤링 취소됨',
                        text: '사용자의 요청으로 크롤링이 취소되었습니다.',
                        confirmButtonText: '확인'
                    });
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: '청구등록 실패',
                        text: error.message || '청구등록 중 에러가 발생하여 실패하였습니다.',
                        confirmButtonText: '확인'
                    });
                }
            } finally {
                this.isSubmitting = false;
            }
        },

        isImageFile(fileName) {
            const imageExtensions = ['jpg', 'jpeg', 'png'];
            const extension = fileName.split('.').pop().toLowerCase();
            return imageExtensions.includes(extension);
        },

        isPdfFile(fileName) {
            const extension = fileName.split('.').pop().toLowerCase();
            return extension === 'pdf';
        },

        // 현재 단계 계산
        currentStep() {
            return this.claimStatus.currentStep || 0;
        },

        // 단계 상태 클래스 가져오기
        getStepStatus(step) {
            if (!this.claimStatus.hasClaimData) {
                const result = step === 0 ? 'in-progress' : 'pending';
                return result;
            }

            // DB에서 조회한 실제 상태에 따라 판단
            const currentStatus = this.claimStatus.currentStepText;
            const currentStep = this.claimStatus.currentStep;

            // 각 단계별 완료 조건을 명확히 정의
            switch (step) {
                case 0: // 청구정보저장
                    const result0 = currentStatus === '청구정보저장' ||
                        currentStatus === '환자등록' ||
                        currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료' ? 'completed' : 'pending';
                    return result0;

                case 1: // 환자등록
                    if (currentStatus === '환자등록' ||
                        currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return 'completed';
                    } else if (currentStatus === '청구정보저장') {
                        return 'in-progress';
                    } else {
                        return 'pending';
                    }

                case 2: // 위임내역등록
                    if (currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return 'completed';
                    } else if (currentStatus === '환자등록') {
                        return 'in-progress';
                    } else {
                        return 'pending';
                    }

                case 3: // 청구등록
                    if (currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return 'completed';
                    } else if (currentStatus === '위임내역등록') {
                        return 'in-progress';
                    } else {
                        return 'pending';
                    }

                default:
                    return 'pending';
            }
        },

        getStepStatusText(step) {
            if (!this.claimStatus.hasClaimData) {
                const result = step === 0 ? '진행중' : '대기중';
                return result;
            }

            // DB에서 조회한 실제 상태에 따라 판단
            const currentStatus = this.claimStatus.currentStepText;
            const currentStep = this.claimStatus.currentStep;

            // 각 단계별 완료 조건을 명확히 정의
            switch (step) {
                case 0: // 청구정보저장
                    const result0 = currentStatus === '청구정보저장' ||
                        currentStatus === '환자등록' ||
                        currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료' ? '완료' : '대기중';
                    return result0;

                case 1: // 환자등록
                    if (currentStatus === '환자등록' ||
                        currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return '완료';
                    } else if (currentStatus === '청구정보저장') {
                        return '진행중';
                    } else {
                        return '대기중';
                    }

                case 2: // 위임내역등록
                    if (currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return '완료';
                    } else if (currentStatus === '환자등록') {
                        return '진행중';
                    } else {
                        return '대기중';
                    }

                case 3: // 청구등록
                    if (currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return '완료';
                    } else if (currentStatus === '위임내역등록') {
                        return '진행중';
                    } else {
                        return '대기중';
                    }

                default:
                    return '대기중';
            }
        },

        getStepStatusText(step) {
            if (!this.claimStatus.hasClaimData) {
                return step === 0 ? '진행중' : '대기중';
            }

            // DB에서 조회한 실제 상태에 따라 판단
            const currentStatus = this.claimStatus.currentStepText;

            // 각 단계별 완료 조건을 명확히 정의
            switch (step) {
                case 0: // 청구정보저장
                    return currentStatus === '청구정보저장' ||
                        currentStatus === '환자등록' ||
                        currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료' ? '완료' : '대기중';

                case 1: // 환자등록
                    // 환자등록이 완료된 경우
                    if (currentStatus === '환자등록' ||
                        currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return '완료';
                    }
                    // 환자등록이 진행중인 경우
                    else if (currentStatus === '청구정보저장') {
                        return '진행중';
                    }
                    // 그 외의 경우
                    else {
                        return '대기중';
                    }

                case 2: // 위임내역등록
                    // 위임내역등록이 완료된 경우
                    if (currentStatus === '위임내역등록' ||
                        currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return '완료';
                    }
                    // 위임내역등록이 진행중인 경우
                    else if (currentStatus === '환자등록') {
                        return '진행중';
                    }
                    // 그 외의 경우
                    else {
                        return '대기중';
                    }

                case 3: // 청구등록
                    // 청구등록이 완료된 경우
                    if (currentStatus === '청구등록' ||
                        currentStatus === '청구완료' ||
                        currentStatus === '완료') {
                        return '완료';
                    }
                    // 청구등록이 진행중인 경우
                    else if (currentStatus === '위임내역등록') {
                        return '진행중';
                    }
                    // 그 외의 경우
                    else {
                        return '대기중';
                    }

                default:
                    return '대기중';
            }
        },

        // 파일 붙여넣기 핸들러
        handleFilePaste(event) {
            // 이미 처리된 붙여넣기 이벤트인지 확인
            if (event.defaultPrevented) {
                return;
            }

            // 이벤트가 처리되었음을 표시
            event.preventDefault();

            // 클립보드 데이터 가져오기
            const clipboardData = event.clipboardData || window.clipboardData;
            const items = clipboardData.items;

            // 수집된 파일들을 저장할 배열
            const filesToAdd = [];
            const invalidFiles = []; // 유효하지 않은 파일들을 저장할 배열

            // 지원되는 파일 형식 정의
            const validTypes = [
                'application/pdf',
                'image/jpeg',
                'image/jpg',
                'image/png'
            ];

            // 클립보드 아이템 처리
            if (items) {
                for (let i = 0; i < items.length; i++) {
                    // 파일인 경우
                    if (items[i].kind === 'file') {
                        const file = items[i].getAsFile();
                        if (file) {
                            // 파일 형식 검증
                            const isValidType = validTypes.includes(file.type.toLowerCase()) ||
                                file.type.toLowerCase() === 'image/jpg' ||
                                file.type.toLowerCase() === 'image/jpeg';

                            if (isValidType) {
                                filesToAdd.push(file);
                            } else {
                                invalidFiles.push({
                                    name: file.name || '알 수 없는 파일',
                                    type: file.type || '알 수 없는 형식'
                                });
                            }
                        }
                    }
                    // 이미지 데이터인 경우 (스크린샷 등)
                    else if (items[i].type.indexOf('image') !== -1) {
                        const blob = items[i].getAsFile();
                        if (blob) {
                            // 이미지 타입인지 확인 (스크린샷은 일반적으로 PNG 또는 JPEG)
                            const imageType = blob.type.toLowerCase();
                            const isValidImageType = imageType.includes('jpeg') ||
                                imageType.includes('jpg') ||
                                imageType.includes('png');

                            if (isValidImageType) {
                                // 스크린샷은 파일명이 없으므로 생성
                                const timestamp = new Date().getTime();
                                const extension = imageType.includes('png') ? 'png' : 'jpg';
                                const fileName = `clipboard_image_${timestamp}_${i}.${extension}`;

                                // 새 File 객체 생성 (이름 지정)
                                const file = new File([blob], fileName, { type: blob.type });
                                filesToAdd.push(file);
                            } else {
                                invalidFiles.push({
                                    name: `클립보드 이미지 ${i + 1}`,
                                    type: imageType || '알 수 없는 이미지 형식'
                                });
                            }
                        }
                    }
                }
            }

            // 유효하지 않은 파일이 있는 경우 안내 메시지
            if (invalidFiles.length > 0) {

                this.$swal.fire({
                    icon: 'warning',
                    title: '지원되지 않는 파일 형식',
                    text: 'PDF, JPG, JPEG 형식만 지원합니다.',
                    confirmButtonText: '확인',
                    width: 500
                });
            }

            // 수집된 유효한 파일들이 있으면 handleFileSelect 메서드를 활용하여 처리
            if (filesToAdd.length > 0) {
                try {
                    // 파일 객체들을 DataTransfer에 추가하여 handleFileSelect에 전달할 이벤트 객체 생성
                    const dataTransfer = new DataTransfer();
                    filesToAdd.forEach(file => dataTransfer.items.add(file));

                    // handleFileSelect 메서드에 전달할 가상 이벤트 객체 생성
                    const fileInputEvent = {
                        target: {
                            files: dataTransfer.files
                        }
                    };

                    this.handleFileSelect(fileInputEvent);

                } catch (error) {
                    console.error('파일 처리 중 오류:', error);
                    this.$swal.fire({
                        icon: 'error',
                        title: '파일 처리 오류',
                        text: '파일을 처리하는 중 오류가 발생했습니다. 다시 시도해 주세요.',
                        confirmButtonText: '확인'
                    });
                }
            }
        },

        // 포커스 처리 메소드
        handleDocumentSectionFocus() {
            this.isPasteFocused = true;
        },

        // 블러 처리 메소드
        handleDocumentSectionBlur() {
            this.isPasteFocused = false;
        },

        // 주문서 타입 확인 (일반, 대여, 산소, 보장구, 당뇨)
        async fetchOrderType(orderId) {
            try {
                const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/orderType/${orderId}`);

                if (response.data.success) {
                    this.rentalTypes = {
                        hasRentalProduct: response.data.hasRentalProduct,
                        hasOxygenGenerator: response.data.hasOxygenGenerator,
                        hasDiabetesProduct: response.data.hasDiabetesProduct,
                        hasAssistanceProduct: response.data.hasAssistanceProduct
                    };
                }
            } catch (error) {
                console.error('주문서 타입 확인 중 오류:', error);
            }
        },

        // ==========================================
        // 파일 등록정보 관련 메서드
        // ==========================================
        hasProductWithName(name) {
            return this.products_obj.some(product => {
                const productName = product.name || '';
                const productName0 = product.name0 || '';

                // 욕창예방 매트리스의 경우 띄어쓰기 유무와 상관없이 확인
                if (name === '욕창예방매트리스' || name === '욕창예방 매트리스') {
                    return productName.includes('욕창예방') && productName.includes('매트리스') ||
                        productName0.includes('욕창예방') && productName0.includes('매트리스');
                }

                return productName === name || productName0 === name;
            });
        },
        // 파일명 매칭
        hasFileWithName(keyword) {
            if (!this.documents || !Array.isArray(this.documents)) return false;

            const keywordLower = keyword.toLowerCase();
            return this.documents.some(doc => {
                const fileName = doc.fileName ? doc.fileName.toLowerCase() : '';

                switch (keywordLower) {
                    // 공통 관련 파일 키워드
                    case '처방전':
                        return fileName.includes('처방');
                    case '신분증':
                        return fileName.includes('신분증') || fileName.includes('복지') || fileName.includes('카드');
                    case '계산서':
                        return fileName.includes('전자') || fileName.includes('세금') || fileName.includes('계산서');
                    case '영수증':
                        return fileName.includes('영수증');

                    // 산소발생기 관련 파일 키워드
                    case '표준계약서':
                        return fileName.includes('표준') || fileName.includes('계약');
                    case '급여대상자 등록신청서':
                        return fileName.includes('산소치료') || fileName.includes('급여') || fileName.includes('대상자') || fileName.includes('등록') || fileName.includes('신청서');

                    // 보조기기 관련 파일 키워드
                    case '보조기기 급여 지급청구서':
                        return fileName.includes('보조기기') || fileName.includes('급여') || fileName.includes('지급청구서');
                    case '보조기기 급여 지급청구 위임장':
                        return fileName.includes('보조기기') || fileName.includes('급여') || fileName.includes('지급청구') || fileName.includes('위임장');
                    case '바코드':
                        return fileName.includes('바코드') || fileName.includes('부착') || fileName.includes('사진');

                    // 보조기기 (의료용 스쿠터, 수동휠체어, 전동휠체어)
                    case '결정통보서':
                        return fileName.includes('보조기기') || fileName.includes('급여') || fileName.includes('대상') || fileName.includes('여부') || fileName.includes('결정통보서');

                    // 보조기기 (욕창예방 매트리스)
                    case 'mbi':
                        return fileName.includes('mbi') || fileName.includes('검사') || fileName.includes('결과');
                    case '다리맨손근력검사':
                        return fileName.includes('다리') || fileName.includes('맨손') || fileName.includes('근력') || fileName.includes('검사') || fileName.includes('결과');
                    // 보조기기 (보청기)
                    case '검수확인서':
                        return fileName.includes('검수') || fileName.includes('확인');
                    case '견적서':
                        return fileName.includes('거래') || fileName.includes('견적');
                    case '보청기 표준 구매계약서':
                        return fileName.includes('보청기') || fileName.includes('표준') || fileName.includes('구매') || fileName.includes('계약');

                    // 당뇨소모성재료 관련 파일 키워드
                    case '요양비 지급청구 위임장':
                        return fileName.includes('요양비') || fileName.includes('지급') || fileName.includes('청구') || fileName.includes('위임장');
                    case '거래명세서':
                        return fileName.includes('거래') || fileName.includes('명세서');
                    default:
                        return fileName.includes(keywordLower);
                }
            });
        },
        isImageFile(fileName) {
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
            const extension = fileName.split('.').pop().toLowerCase();
            return imageExtensions.includes(extension);
        },
        openPreview(doc) {
            if (doc && doc.fileName) {
                // 파일 타입 확인
                const fileType = this.isPdfFile(doc.fileName) ? 'pdf' :
                    this.isImageFile(doc.fileName) ? 'image' : 'unknown';

                this.selectedPreviewImage = {
                    fileName: doc.fileName,
                    url: doc.url,
                    registeredDate: doc.registeredDate,
                    fileType: fileType
                };
            }
        },
        closePreview() {
            this.selectedPreviewImage = null;
        },
        handlePdfError(event) {
            console.error('PDF 로드 실패:', event);
            // PDF 로드 실패 시 대체 메시지 표시
            const iframe = event.target;
            iframe.style.display = 'none';

            // 에러 메시지 표시
            const errorDiv = document.createElement('div');
            errorDiv.style.cssText = `
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100%;
                text-align: center;
                padding: 40px;
                background: #f5f5f5;
            `;
            errorDiv.innerHTML = `
                <div style="font-size: 48px; color: #f44336; margin-bottom: 20px;">⚠️</div>
                <h3>PDF를 표시할 수 없습니다</h3>
                <p>브라우저에서 PDF를 직접 열어보세요.</p>
                <button onclick="window.open('${this.selectedPreviewImage.url}', '_blank')" 
                style="background: #f44336; color: white; border: none; padding: 10px 20px; border-radius: 5px; cursor: pointer; margin-top: 10px;">
                새 탭에서 열기
                </button>
            `;

            iframe.parentNode.appendChild(errorDiv);
        },
        handleImageError(event) {
            console.error('이미지 로드 실패:', event);
            event.target.src = '/path/to/fallback/image.jpg';
        },
        async handleFileSelect(event) {
            try {
                const files = Array.from(event.target.files || []);
                if (files.length === 0) return;

                const tempDocuments = [];

                // PDF 및 이미지 파일 처리
                for (const file of files) {
                    if (file.type === 'application/pdf') {
                        // PDF를 그대로 등록 (JPG 변환 제거)
                        const fileWithDate = {
                            id: Date.now() + Math.random(),
                            fileName: file.name,
                            registeredDate: new Date().toISOString(),
                            type: file.type,
                            size: file.size,
                            file: file,
                            url: URL.createObjectURL(file),
                            isLocal: true,
                            selected: false
                        };

                        tempDocuments.push(fileWithDate);
                    } else if (file.type.startsWith('image/')) {
                        // 이미지 파일을 JPG로 변환 (PNG, GIF, BMP 등 모든 이미지)
                        const jpgBlob = await this.convertImageToJpg(file);
                        if (jpgBlob) {
                            const jpgFile = new File([jpgBlob], `${file.name.replace(/\.[^/.]+$/, '')}.jpg`, {
                                type: 'image/jpeg'
                            });

                            const fileWithDate = {
                                id: Date.now() + Math.random(),
                                fileName: jpgFile.name,
                                registeredDate: new Date().toISOString(),
                                type: jpgFile.type,
                                size: jpgFile.size,
                                file: jpgFile,
                                url: URL.createObjectURL(jpgFile),
                                isLocal: true,
                                selected: false
                            };

                            tempDocuments.push(fileWithDate);
                        }
                    } else {
                        // 기타 파일 (DOC, DOCX 등)은 그대로 유지
                        const fileWithDate = {
                            id: Date.now() + Math.random(),
                            fileName: file.name,
                            registeredDate: new Date().toISOString(),
                            type: file.type,
                            size: file.size,
                            file: file,
                            url: URL.createObjectURL(file),
                            isLocal: true,
                            selected: false
                        };

                        tempDocuments.push(fileWithDate);
                    }
                }

                this.documents = [...this.documents || [], ...tempDocuments];

                // 개선된 파일 업로드 로직
                const uploadPromises = tempDocuments.map(async (docItem) => {
                    const formData = new FormData();
                    formData.append('images', docItem.file);

                    const response = await this.$axios.post(
                        `${this.$apiUrls.hanqmedi}/orderImageUpload/${this.orderId}`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            timeout: 60000,
                            onUploadProgress: (progressEvent) => {
                                const progress = Math.round(
                                    (progressEvent.loaded / progressEvent.total) * 100
                                );
                            }
                        }
                    );

                    if (!response.data.success) {
                        throw new Error(`${docItem.fileName}: ${response.data.message || '업로드 실패'}`);
                    }

                    console.log(`✅ 파일 업로드 완료: ${docItem.fileName}`);
                    return response.data;
                });

                await Promise.all(uploadPromises);
                await this.fetchImages();

                this.$swal.fire({
                    title: '업로드 완료',
                    text: `${tempDocuments.length}개 파일이 성공적으로 업로드되었습니다.`,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });

            } catch (error) {
                console.error('파일 업로드 중 오류:', error);
                this.documents = this.documents.filter(doc => !doc.isLocal);

                let errorMessage = '파일 업로드 중 오류가 발생했습니다.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                this.$swal.fire({
                    title: '업로드 실패',
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: '확인'
                });
            } finally {
                if (event.target) {
                    event.target.value = '';
                }
            }
        },

        // 이미지를 JPG로 변환하는 메서드 (최고 화질)
        async convertImageToJpg(imageFile, quality = 1.0) {
            return new Promise((resolve) => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const img = new Image();

                img.onload = () => {
                    // 원본 크기 그대로 유지 (크기 조정 최소화)
                    let { width, height } = img;
                    const maxDimension = 8000; // 매우 큰 이미지만 조정

                    if (width > maxDimension || height > maxDimension) {
                        const ratio = Math.min(maxDimension / width, maxDimension / height);
                        width = Math.round(width * ratio);
                        height = Math.round(height * ratio);
                    }

                    // 캔버스 크기 설정
                    canvas.width = width;
                    canvas.height = height;

                    // 최고 품질 렌더링 설정
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = 'high';

                    // 배경을 흰색으로 설정 (투명도 문제 해결)
                    ctx.fillStyle = '#FFFFFF';
                    ctx.fillRect(0, 0, width, height);

                    // 이미지를 캔버스에 그리기 (원본 크기 유지)
                    ctx.drawImage(img, 0, 0, width, height);

                    // 최고 품질 JPG로 변환
                    canvas.toBlob((blob) => {
                        resolve(blob);
                    }, 'image/jpeg', quality);
                };

                img.onerror = () => {
                    console.error('이미지 로드 실패:', imageFile.name);
                    resolve(null);
                };

                img.src = URL.createObjectURL(imageFile);
            });
        },

        // PDF를 이미지로 변환하는 함수 - JPG 형식으로 수정
        async convertPdfToImage(pdfFile) {
            try {
                // PDF 파일을 ArrayBuffer로 변환
                const arrayBuffer = await pdfFile.arrayBuffer();

                // PDF 문서 로드
                const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
                const pdf = await loadingTask.promise;

                // 첫 번째 페이지 가져오기
                const page = await pdf.getPage(1);

                // 캔버스 생성
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');

                // 페이지 크기 설정 (해상도 조정 가능)
                const viewport = page.getViewport({ scale: 1.5 });
                canvas.width = viewport.width;
                canvas.height = viewport.height;

                // 배경을 흰색으로 설정
                context.fillStyle = '#FFFFFF';
                context.fillRect(0, 0, canvas.width, canvas.height);

                // 페이지 렌더링
                await page.render({
                    canvasContext: context,
                    viewport: viewport
                }).promise;

                // 캔버스를 Blob으로 변환 (JPG 형식으로)
                return new Promise((resolve) => {
                    canvas.toBlob((blob) => {
                        resolve(blob);
                    }, 'image/jpeg', 1.0); // 최고 품질의 JPG로 변환
                });
            } catch (error) {
                console.error('PDF 변환 중 오류:', error);
                this.$swal.fire({
                    title: 'PDF 변환 실패',
                    text: 'PDF를 이미지로 변환하는 중 오류가 발생했습니다.',
                    icon: 'error'
                });
                return null;
            }
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        async fetchImages() {
            try {
                this.isLoading = true;
                const response = await this.$axios.get(
                    `${this.$apiUrls.hanqmedi}/getOrderImage/${this.orderId}`
                );

                if (response.data.success) {
                    this.documents = response.data.data.images.map(file => ({
                        id: file.id || file.key,
                        fileName: file.fileName || file.originalname,
                        registeredDate: file.uploadDate || file.createdAt || new Date().toISOString(),
                        url: file.url || file.location, // S3 URL 처리
                        key: file.key,
                        selected: false,
                        type: file.type || this.getFileType(file.fileName || file.originalname)
                    }));
                }
            } catch (error) {
                console.error('파일 조회 중 오류:', error);
                this.documents = [];
            } finally {
                this.isLoading = false;
            }
        },
        getImageUrl(image) {
            if (image.isLocal) {
                return image.url;  // 로컬 파일의 경우 생성된 URL 사용
            }
            return image.url;  // S3 이미지의 경우 signed URL 사용
        },
        async removeDocument(index) {
            try {
                const doc = this.documents[index];
                if (!doc) return;

                const result = await this.$swal.fire({
                    icon: 'warning',
                    title: '삭제 확인',
                    text: '문서를 삭제하시겠습니까?',
                    showCancelButton: true,
                    confirmButtonText: '삭제',
                    cancelButtonText: '취소',
                    confirmButtonColor: '#d33',
                    reverseButtons: true
                });

                if (!result.isConfirmed) return;

                // S3에 저장된 문서 삭제 - POST 메서드 사용
                const response = await this.$axios.post(
                    `${this.$apiUrls.hanqmedi}/orderImageDelete`,
                    {
                        orderId: this.orderId,
                        imageKey: doc.key  // key → imageKey로 변경
                    }
                );

                if (!response.data.success) {
                    throw new Error(response.data.message || '삭제 실패');
                }

                // 성공적으로 삭제되면 로컬 상태 업데이트
                this.documents.splice(index, 1);

                await this.$swal.fire({
                    icon: 'success',
                    title: '성공',
                    text: '문서가 성공적으로 삭제되었습니다.',
                    confirmButtonText: '확인'
                });

                // 문서 목록 새로고침
                await this.fetchImages();

                // 부모 컴포넌트에 문서 개수 업데이트 알림
                this.$emit('imagesUploaded');

            } catch (error) {
                console.error('문서 삭제 중 오류 발생:', error);
                await this.$swal.fire({
                    icon: 'error',
                    title: '오류',
                    text: error.response?.data?.message || '문서 삭제 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
            }
        },
        toggleFileSelectAll() {
            this.fileSelectAll = !this.fileSelectAll;
            this.documents.forEach(doc => {
                doc.selected = this.fileSelectAll;
            });
        },
        getFileType(fileName) {
            if (!fileName) return 'unknown';
            const extension = fileName.split('.').pop().toLowerCase();
            const typeMap = {
                'pdf': 'pdf',
                'doc': 'word',
                'docx': 'word',
                'jpg': 'image',
                'jpeg': 'image',
                'png': 'image',
                'gif': 'image'
            };
            return typeMap[extension] || 'unknown';
        },
        showClaimTypeModal() {
            document.body.style.overflow = 'hidden';
            this.showModal_obj.claim_type = true;
        },
        closeClaimTypeModal() {
            this.showModal_obj.claim_type = false;
        },
        selectClaimType(type) {
            switch (type) {
                case '산소발생기':
                    this.showModal_obj.claim_up = true;
                    break;
                case '보장구':
                    this.showModal_obj.assistance_up = true;
                    break;
                case '당뇨소모성재료':
                    this.showModal_obj.diabetes_up = true;
                    break;
            }
        },
        // 주문서 복사
        copyOrderData() {
            const copyData = [
                `주문일자: ${this.formatDate(this.orderDate) || ''}`,
                `고객명: ${this.client_data_obj.name || ''}`,
                `고객번호: ${this.client_data_obj.number || ''}`,
                `품목명: ${this.products_obj.map(p => p.b_product_id > 999999 ? p.name3 : p.name2).join(', ') || ''}`,
                `수량: ${this.totalQuantity || ''}`,
                `배송주소: ${this.postcode_obj.postcode1 + ' ' + this.postcode_obj.address1 + ' ' + this.postcode_obj.detailAddress1 || ''}`,
                `보호자성함: ${this.client_data_obj.guardname || ''}`,
                `구분: ${this.products_obj.map(p => p.selected_target || p.target).join(', ') || ''}`,
                `연락처: ${this.client_data_obj.phone1 || ''}`,
                `담당자: ${this.client_data_obj.manager || ''}`,
                `메모: ${this.orderComment.map(c => c.text).join(' | ') || ''}`,
                `배송방법: ${this.getDeliveryMethodText(this.deliveryMethod) || ''}`,
                `배송상태: ${this.getDeliveryStatusText(this.deliveryStatus) || ''}`
            ].join('\n');

            // fallback 방식 추가
            const fallbackCopyToClipboard = (text) => {
                const textArea = document.createElement('textarea');
                textArea.value = text;

                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                textArea.style.top = '-999999px';
                document.body.appendChild(textArea);

                textArea.focus();
                textArea.select();

                try {
                    document.execCommand('copy');
                    this.$swal.fire({
                        title: '복사 완료',
                        text: '주문서 정보가 복사되었습니다.',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false
                    });
                } catch (err) {
                    this.$swal.fire({
                        title: '복사 실패',
                        text: '주문서 정보를 복사하는데 실패했습니다.',
                        icon: 'error',
                        confirmButtonText: '확인'
                    });
                }

                document.body.removeChild(textArea);
            };

            // 모던 브라우저의 클립보드 API 시도
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(copyData)
                    .then(() => {
                        this.$swal.fire({
                            title: '복사 완료',
                            text: '주문서 정보가 복사되었습니다.',
                            icon: 'success',
                            timer: 1500,
                            showConfirmButton: false
                        });
                    })
                    .catch(() => {
                        fallbackCopyToClipboard(copyData);
                    });
            } else {
                fallbackCopyToClipboard(copyData);
            }
        },

        // 아이콘 클릭 시 연장 처리
        handleExtendClick(index) {
            // ref를 직접 찾기
            const refKey = `extendInput-${index}`;
            const inputRef = this.$refs[refKey];

            // ref가 없는 경우
            if (!inputRef) {
                console.warn('Input ref를 찾을 수 없습니다:', refKey);
                // ref가 없으면 DOM에서 직접 찾기
                const inputElement = document.querySelector(`input[data-extend-input="${index}"]`);
                if (inputElement) {
                    const inputValue = inputElement.value.trim();
                    if (inputValue && inputValue !== '') {
                        const amount = parseInt(inputValue, 10);
                        if (!isNaN(amount) && amount > 0) {
                            this.extendRentalPeriod(amount);
                            inputElement.value = '';
                            return;
                        }
                    }
                }
                // 찾지 못했으면 기본 30일 연장
                this.extendRentalPeriod(30);
                return;
            }

            // 배열인 경우 첫 번째 요소 가져오기
            const input = Array.isArray(inputRef) ? inputRef[0] : inputRef;

            // input이 없으면 기본 30일 연장
            if (!input) {
                console.warn('Input 요소를 찾을 수 없습니다');
                this.extendRentalPeriod(30);
                return;
            }

            // value를 안전하게 가져오기
            let inputValue = '';
            try {
                // DOM 요소인지 확인
                if (input instanceof HTMLInputElement) {
                    inputValue = input.value.trim();
                } else if (input.$el && input.$el instanceof HTMLInputElement) {
                    // Vue 컴포넌트인 경우
                    inputValue = input.$el.value.trim();
                } else if (input.value !== undefined && input.value !== null) {
                    inputValue = String(input.value).trim();
                }

            } catch (e) {
                console.error('Input value 접근 오류:', e);
            }

            // 입력값이 없거나 빈 문자열이면 1개월(30일) 연장
            if (!inputValue || inputValue === '') {
                this.extendRentalPeriod(30);
            } else {
                // 입력값이 있으면 무조건 해당 일수만큼 연장
                const amount = parseInt(inputValue, 10);

                // 숫자가 아니거나 0 이하인 경우 에러 처리
                if (isNaN(amount) || amount <= 0) {
                    this.$swal.fire({
                        icon: 'warning',
                        title: '입력 오류',
                        text: '1 이상의 숫자를 입력해주세요.',
                        confirmButtonText: '확인',
                        timer: 1500,
                        showConfirmButton: false
                    });
                    if (input instanceof HTMLInputElement) {
                        input.value = '';
                    } else if (input.$el && input.$el instanceof HTMLInputElement) {
                        input.$el.value = '';
                    } else if (input.value !== undefined) {
                        input.value = '';
                    }
                    return;
                }

                // 입력값이 있으면 무조건 일수로 연장
                this.extendRentalPeriod(amount);

                // 연장 후 입력값 초기화
                if (input instanceof HTMLInputElement) {
                    input.value = '';
                } else if (input.$el && input.$el instanceof HTMLInputElement) {
                    input.$el.value = '';
                } else if (input.value !== undefined) {
                    input.value = '';
                }
            }
        },

        // 대여 종료일 연장 (공통 로직) - 결제 모달 먼저 표시
        async extendRentalPeriod(days = 30) {
            try {
                // 대여 종료일이 설정되어 있는지 확인
                if (!this.client_data_obj.rental_end) {
                    this.$swal.fire({
                        icon: 'warning',
                        title: '대여 종료일 없음',
                        text: '대여 종료일이 설정되어 있지 않습니다. 먼저 대여 종료일을 설정해주세요.',
                        confirmButtonText: '확인'
                    });
                    return;
                }

                // 현재 대여 종료일을 Date 객체로 변환
                const currentEndDate = new Date(this.client_data_obj.rental_end);

                // 유효한 날짜인지 확인
                if (isNaN(currentEndDate.getTime())) {
                    this.$swal.fire({
                        icon: 'error',
                        title: '날짜 오류',
                        text: '대여 종료일이 유효하지 않습니다.',
                        confirmButtonText: '확인'
                    });
                    return;
                }

                // 일수만큼 연장 계산 (미리 계산만 함)
                const newEndDate = new Date(currentEndDate);
                newEndDate.setDate(newEndDate.getDate() + days);
                const formattedDate = this.formatDate(newEndDate);
                const dayText = days === 30 ? '1개월(30일)' : `${days}일`;

                // 연장 전에 결제 모달 먼저 표시
                this.showPaymentModal(days, formattedDate, dayText, newEndDate);

            } catch (error) {
                console.error('대여 종료일 연장 중 오류:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: '오류 발생',
                    text: error.response?.data?.message || error.message || '대여 종료일 연장 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
            }
        },

        // 실제 연장 처리 함수 (결제 완료 후 호출)
        async processRentalExtension(days, newEndDate, paymentInfo = null) {
            try {
                // 백엔드 API 호출로 DB 업데이트 - 배송 관련 데이터도 함께 전송하여 초기화 방지
                const orderData = {
                    rental_start: this.client_data_obj.rental_start ? this.format.date(this.client_data_obj.rental_start) : undefined,
                    rental_end: this.format.date(newEndDate),
                    rental_status: this.client_data_obj.rental_status,
                    // 배송 관련 데이터도 함께 전송하여 초기화 방지
                    delivery_method: this.deliveryMethod ? parseInt(this.deliveryMethod) : undefined,
                    delivery_status: this.deliveryStatus ? parseInt(this.deliveryStatus) : undefined,
                    delivery_date: this.delivery_date ? this.format.date(this.delivery_date) : null,
                    delivery_time: this.delivery_time ? parseInt(this.delivery_time) : undefined
                };

                // undefined 값 제거
                Object.keys(orderData).forEach(key =>
                    orderData[key] === undefined && delete orderData[key]
                );

                const response = await this.$axios.post(
                    `${this.$apiUrls.hanqmedi}/updateRental/${this.orderId}`,
                    orderData
                );

                if (response.data.statusCode !== 200) {
                    throw new Error(response.data.message || '대여 연장에 실패했습니다.');
                }

                // 프론트엔드 상태 업데이트
                this.client_data_obj.rental_end = newEndDate;

                // 주문 데이터 새로고침
                await this.fetchOrderData();

                // 대여 이력 저장 - 결제 정보가 있으면 결제 정보와 함께 저장, 없으면 연장 정보만 저장
                const formattedDate = this.formatDate(newEndDate);
                const dayText = days === 30 ? '1개월(30일)' : `${days}일`;

                if (paymentInfo) {
                    // 결제 정보가 있는 경우: 결제 정보와 함께 한 번만 저장
                    await this.saveRentalHistory(
                        '연장',
                        paymentInfo.paymentType,
                        null,
                        paymentInfo.paymentAmount,
                        paymentInfo.paymentStatus || '완료',
                        `대여 종료일이 ${dayText} 연장되어 ${formattedDate}로 변경되었습니다.`
                    );
                } else {
                    // 결제 정보가 없는 경우: 연장 정보만 저장
                    await this.saveRentalHistory(
                        '연장',
                        null,
                        null,
                        null,
                        null,
                        `대여 종료일이 ${dayText} 연장되어 ${formattedDate}로 변경되었습니다.`
                    );
                }
            } catch (error) {
                console.error('대여 연장 처리 중 오류:', error);
                throw error;
            }
        },

        // 결제 모달 표시
        showPaymentModal(days, formattedDate, dayText, newEndDate) {
            let inputValue = ''; // 입력값을 추적하기 위한 변수

            this.$swal.fire({
                title: '대여 연장 결제',
                html: `
                    <div style="text-align: left; margin-top: 20px;">
                        <div style="margin-bottom: 20px; padding: 10px; background: #f8f9fa; border-radius: 5px;">
                            <div style="font-size: 14px; margin-bottom: 5px;"><strong>연장 정보</strong></div>
                            <div style="font-size: 13px; color: #666;">연장 기간: ${dayText}</div>
                            <div style="font-size: 13px; color: #666;">연장 후 종료일: ${formattedDate}</div>
                        </div>
                        <label style="display: block; margin-bottom: 10px; font-weight: bold;">결제 수단 선택</label>
                        <select id="paymentMethod" style="width: 100%; padding: 8px; margin-bottom: 15px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px;">
                            <option value="">선택하세요</option>
                            <option value="현금">현금</option>
                            <option value="카드">카드</option>
                            <option value="가상계좌">가상계좌</option>
                            <option value="CMS">CMS</option>
                        </select>
                        <label style="display: block; margin-bottom: 10px; font-weight: bold;">결제 금액</label>
                        <input type="text" id="paymentAmount" value="" 
                               style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px;" 
                               placeholder="결제할 금액을 입력하세요">
                        <div id="paymentError" style="color: #dc3545; font-size: 12px; margin-top: 5px; display: none;"></div>
                    </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: '결제하기',
                cancelButtonText: '취소',
                width: '500px',
                didOpen: () => {
                    const amountInput = document.getElementById('paymentAmount');
                    const methodSelect = document.getElementById('paymentMethod');
                    const errorDiv = document.getElementById('paymentError');

                    if (amountInput) {
                        // 숫자만 입력 허용
                        amountInput.addEventListener('input', (e) => {
                            // 숫자만 추출
                            let value = e.target.value.replace(/[^0-9]/g, '');

                            // 빈 값이 아닐 때만 포맷팅
                            if (value) {
                                // 숫자로 변환 후 포맷팅
                                const numValue = parseInt(value, 10);
                                if (!isNaN(numValue)) {
                                    e.target.value = numValue.toLocaleString('ko-KR');
                                    inputValue = numValue.toString(); // 원본 숫자 저장
                                }
                            } else {
                                e.target.value = '';
                                inputValue = '';
                            }
                        });

                        // 포커스 시 숫자만 표시 (입력 편의성)
                        amountInput.addEventListener('focus', (e) => {
                            if (inputValue) {
                                e.target.value = inputValue;
                            }
                        });

                        // 포커스 아웃 시 다시 포맷팅
                        amountInput.addEventListener('blur', (e) => {
                            if (inputValue) {
                                const numValue = parseInt(inputValue, 10);
                                if (!isNaN(numValue)) {
                                    e.target.value = numValue.toLocaleString('ko-KR');
                                }
                            }
                        });

                        // Enter 키로 제출 방지
                        amountInput.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                            }
                        });
                    }
                },
                preConfirm: () => {
                    const method = document.getElementById('paymentMethod').value;
                    const amountInput = document.getElementById('paymentAmount');
                    const errorDiv = document.getElementById('paymentError');

                    // 입력값에서 콤마 제거
                    let amount = '';
                    if (amountInput && amountInput.value) {
                        amount = amountInput.value.replace(/[^0-9]/g, '');
                    }

                    // 유효성 검사
                    if (!method) {
                        errorDiv.textContent = '결제 수단을 선택해주세요.';
                        errorDiv.style.display = 'block';
                        return false;
                    }

                    if (!amount || amount === '' || parseInt(amount) <= 0) {
                        errorDiv.textContent = '금액을 입력해주세요. (1원 이상)';
                        errorDiv.style.display = 'block';
                        return false;
                    }

                    const amountNum = parseInt(amount, 10);
                    if (isNaN(amountNum) || amountNum <= 0) {
                        errorDiv.textContent = '올바른 금액을 입력해주세요.';
                        errorDiv.style.display = 'block';
                        return false;
                    }

                    errorDiv.style.display = 'none';
                    return { method, amount: amountNum };
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    // 결제 처리 및 연장 처리
                    this.processPayment(result.value.method, result.value.amount, days, formattedDate, dayText, newEndDate);
                }
            });
        },

        // 결제 처리
        async processPayment(paymentMethod, amount, days, formattedDate, dayText, newEndDate) {
            try {
                // 결제 정보를 processRentalExtension에 전달하여 한 번만 저장되도록 함
                const paymentInfo = {
                    paymentType: paymentMethod,
                    paymentAmount: amount,
                    paymentStatus: '납부'
                };

                // 결제와 연장을 함께 처리 (결제 정보 포함)
                await this.processRentalExtension(days, newEndDate, paymentInfo);

                // 결제 완료 메시지 표시
                this.$swal.fire({
                    icon: 'success',
                    title: '결제 및 연장 완료',
                    html: `
                        <div style="text-align: left; margin-top: 10px;">
                            <div style="margin-bottom: 10px;"><strong>결제 수단:</strong> ${paymentMethod}</div>
                            <div style="margin-bottom: 10px;"><strong>결제 금액:</strong> ${amount.toLocaleString('ko-KR')}원</div>
                            <div style="margin-bottom: 10px;"><strong>연장 기간:</strong> ${dayText}</div>
                            <div><strong>연장 후 종료일:</strong> ${formattedDate}</div>
                        </div>
                    `,
                    confirmButtonText: '확인',
                    showConfirmButton: true
                });

            } catch (error) {
                console.error('결제 처리 중 오류:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: '결제 오류',
                    text: error.response?.data?.message || error.message || '결제 처리 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
            }
        },

        getDeliveryMethodText(method) {
            const methods = {
                '1': '내방',
                '2': '물류 (기관배송)',
                '3': '택배',
                '4': '소독업체',
                '5': '공급업체'
            };
            return methods[method] || '';
        },

        // 배송상태 텍스트 반환 메서드 추가
        getDeliveryStatusText(status) {
            const statuses = {
                '1': '배송완료',
                '2': '배송대기',
                '3': '회수중',
                '4': '회수완료',
                '5': '배송중'
            };
            return statuses[status] || '';
        },

        // 상태 저장 섹션 ================================================================================
        // 상태 저장 메서드 추가
        saveModalState() {
            // 저장할 데이터 객체 생성
            const modalState = {
                // 클라이언트 정보
                client_data_obj: this.client_data_obj,
                // 주소 정보
                postcode_obj: this.postcode_obj,
                // 배송 정보
                delivery_date: this.delivery_date,
                delivery_time: this.delivery_time,
                deliveryMethod: this.deliveryMethod,
                deliveryStatus: this.deliveryStatus,
                // 제품 정보
                products_obj: this.products_obj,
                // 메모 정보
                orderComment: this.orderComment,
                orderCommentAdd: this.orderCommentAdd,
                // 주문 ID
                orderId: this.orderId
            };

            // localStorage에 저장
            localStorage.setItem(`orderRentalModal_${this.orderId}`, JSON.stringify(modalState));
        },

        // 상태 복원 메서드 추가
        restoreModalState() {
            // localStorage에서 저장된 상태 가져오기
            const savedState = localStorage.getItem(`orderRentalModal_${this.orderId}`);
            if (!savedState) return;

            try {
                const modalState = JSON.parse(savedState);

                // 클라이언트 정보 복원
                if (modalState.client_data_obj) {
                    // 날짜 형식 데이터 변환
                    if (modalState.client_data_obj.rental_start) {
                        modalState.client_data_obj.rental_start = new Date(modalState.client_data_obj.rental_start);
                    }
                    if (modalState.client_data_obj.rental_end) {
                        modalState.client_data_obj.rental_end = new Date(modalState.client_data_obj.rental_end);
                    }
                    if (modalState.client_data_obj.oxygen_start) {
                        modalState.client_data_obj.oxygen_start = new Date(modalState.client_data_obj.oxygen_start);
                    }
                    if (modalState.client_data_obj.oxygen_end) {
                        modalState.client_data_obj.oxygen_end = new Date(modalState.client_data_obj.oxygen_end);
                    }
                    if (modalState.client_data_obj.diabetes_start) {
                        modalState.client_data_obj.diabetes_start = new Date(modalState.client_data_obj.diabetes_start);
                    }
                    if (modalState.client_data_obj.diabetes_end) {
                        modalState.client_data_obj.diabetes_end = new Date(modalState.client_data_obj.diabetes_end);
                    }

                    // 객체 복원
                    Object.assign(this.client_data_obj, modalState.client_data_obj);
                }

                // 주소 정보 복원
                if (modalState.postcode_obj) {
                    Object.assign(this.postcode_obj, modalState.postcode_obj);
                }

                // 배송 정보 복원
                if (modalState.delivery_date) {
                    this.delivery_date = new Date(modalState.delivery_date);
                }
                this.delivery_time = modalState.delivery_time || '0';
                this.deliveryMethod = modalState.deliveryMethod || '1';
                this.deliveryStatus = modalState.deliveryStatus || '0';

                // 제품 정보 복원
                if (modalState.products_obj && modalState.products_obj.length > 0) {
                    this.products_obj = modalState.products_obj;
                }

                // 메모 정보 복원
                if (modalState.orderComment) {
                    this.orderComment = modalState.orderComment;
                }
                this.orderCommentAdd = modalState.orderCommentAdd || '';

            } catch (error) {
                console.error('모달 상태 복원 중 오류 발생:', error);
                localStorage.removeItem(`orderRentalModal_${this.orderId}`);
            }
        },

        // 상태 초기화 메서드 추가
        clearModalState() {
            localStorage.removeItem(`orderRentalModal_${this.orderId}`);
        },

        // 모델 닫기 시 상태 초기화
        closeOrderRentalModal() {
            this.showRentalModal = false;
            document.body.style.overflow = 'auto';
            this.clearModalState(); // 모달 닫을 때 상태 초기화
        },

        // 상태 저장 섹션 ================================================================================

        async fetchVirtualAccountHistory() {
            try {
                const companykey = Number(this.$globalState.company_key);

                if (companykey !== 32) {
                    this.virtualAccountCount = 0;
                    return;
                }

                const response = await this.$axios.post(
                    `${this.$apiUrls.virtualaccount}/virtualaccount/getlist`,
                    {
                        search: "",
                        sdate: "1999-01-01",
                        edate: "2099-01-01",
                        status: "",
                        page: 1,
                        rows: 9999
                    }
                );

                if (response.data.code === 200) {
                    // 현재 고객의 가상계좌 발송 건수 계산
                    let accountData = response.data.data.filter(
                        item => item.CUSNM === this.client_data_obj?.name
                    );
                    // 데이터가 10개 이상일 경우 중복 제거
                    if (accountData.length >= 10) {
                        const uniqueKeys = new Map();
                        accountData = accountData.filter(item => {
                            // 고객명, 금액, 항목명을 조합한 고유키 생성
                            const key = `${item.CUSNM}-${item.MOBILENO}-${item.PAYITEMAMT}-${item.PAYITEMNM}`;
                            if (!uniqueKeys.has(key)) {
                                uniqueKeys.set(key, true);
                                return true;
                            }
                            return false;
                        });
                    }

                    this.virtualAccountCount = accountData.length;
                    this.virtualAccountHistory = accountData;
                }
            } catch (error) {
                console.error('가상계좌 내역 조회 중 오류:', error);
                this.virtualAccountCount = 0;
                this.virtualAccountHistory = [];
            }
        },
        getSelectedStoreProducts() {
            return this.products_obj.map(product => ({
                id: product.b_product_id || product.product_id,
                name: product.b_product_id > 999999 ? product.name3 : product.name2,
                quantity: product.quantity || 1,
                price: product.selected_target === '대여' ?
                    (product.rentprice || 0) :
                    (product.buyprice || 0),
                selected_target: product.selected_target || product.target
            }));
        },
        updateVirtualAccountCount(count) {
            const companykey = Number(this.$globalState.company_key);

            if (companykey !== 32) {
                this.virtualAccountCount = 0;
                return;
            }
            this.virtualAccountCount = count;
        },
        openSmsSendModal() {
            this.showModal_obj.sms_up = true;
            const rawPhone = this.client_data_obj.phone1 || this.client_data_obj.phone2 || '';
            const normalized = String(rawPhone).replace(/[^0-9]/g, '');

            this.selectedCustomer = {
                name: this.client_data_obj.name || '',
                phone: normalized,
                phone1: normalized,
                phone2: this.client_data_obj.phone2 || '',
                companykey: this.$globalState?.company_key || ''
            };
        },
        openVirtualAccountModal() {
            if (this.$globalState.company_key !== 32) {
                this.$swal.fire({
                    icon: 'info',
                    title: '가상계좌 관리 불가능',
                    html: '가상계좌 사업소에 등록되지 않았습니다. <br>관리자에게 문의하세요.',
                    confirmButtonText: '확인'
                });
                return;
            }
            this.showModal_obj.virtual_up = true;
        },

        closeUploadModal() {
            this.showUploadModal = false;
        },

        // 업로드 에러 처리
        handleUploadError(message) {
            this.$swal.fire({
                title: '업로드 오류',
                text: message,
                icon: 'error',
                confirmButtonText: '확인'
            });
        },
        // 추출 데이터 확인 모달 콜백 처리
        async handleDataConfirm(confirmedData) {
            this.showExtractedDataModal = false;

            try {
                // 로딩 상태 표시
                this.$swal.fire({
                    title: '청구 처리 중',
                    text: '장기요양 정보마당에 접속하여 청구를 진행 중입니다...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                // 크롤링 서비스에 요청할 데이터 준비
                const claimData = {
                    // 인증서 정보
                    cert_path: this.$globalState.cert_path || "C:\\Users\\user\\Downloads\\certificate.der",
                    cert_password: this.$globalState.cert_password || "!xmrtn7062",

                    // 수급자 정보 (문서에서 추출한 데이터 사용)
                    client_info: {
                        name: confirmedData.client_name,
                        resident_id: confirmedData.resident_id,
                        care_number: confirmedData.care_number
                    },

                    // 대여 정보 (문서에서 추출한 데이터 사용)
                    rental_info: {
                        start_date: confirmedData.start_date,
                        end_date: confirmedData.end_date
                    },

                    // 제품 정보
                    products: this.products_obj.map(product => ({
                        code: product.code,
                        name: product.b_product_id > 999999 ? product.name3 : product.name2,
                        quantity: product.quantity,
                        price: product.selected_target === '대여' ? product.setRentprice : product.setBuyprice
                    })),

                    // 주문 ID 및 문서 ID
                    order_id: this.orderId,
                    document_ids: confirmedData.document_ids,
                    company_key: this.$globalState.company_key
                };

                console.log('청구 요청 데이터:', claimData);

                // 백엔드 크롤링 서비스에 요청 전송
                const response = await this.$axios.post(`${this.$apiUrls.crawling}/api/process-claim`, claimData);

                // 응답 처리
                if (response.data.success) {
                    // 성공 처리
                    this.$swal.fire({
                        title: '청구 성공',
                        text: response.data.message || '장기요양 정보마당 청구가 성공적으로 완료되었습니다.',
                        icon: 'success',
                        confirmButtonText: '확인'
                    });

                    // 결과 데이터 처리 (필요시)
                    if (response.data.results) {
                        console.log('청구 결과:', response.data.results);
                    }
                } else {
                    // 실패 처리
                    throw new Error(response.data.message || '청구 처리 중 오류가 발생했습니다.');
                }
            } catch (error) {
                console.error('청구 처리 오류:', error);
                this.$swal.fire({
                    title: '청구 실패',
                    text: error.message || '청구 처리 중 오류가 발생했습니다.',
                    icon: 'error',
                    confirmButtonText: '확인'
                });
            }
        },

        async handleModifyOrder() {
            try {
                if (!this.client_data_obj.rental_start || !this.client_data_obj.rental_end) {
                    throw new Error('대여 시작일과 종료일을 모두 입력해주세요.');
                }

                const orderData = {
                    rental_start: this.format.date(this.client_data_obj.rental_start),
                    rental_end: this.format.date(this.client_data_obj.rental_end),
                    rental_status: this.client_data_obj.rental_status,
                    delivery_method: parseInt(this.deliveryMethod),
                    delivery_status: parseInt(this.deliveryStatus),
                    delivery_date: this.delivery_date ? this.format.date(this.delivery_date) : null,
                    delivery_time: parseInt(this.delivery_time)
                };

                console.log('Sending order data:', orderData);

                // 배송상태가 회수완료(4)인 경우
                if (parseInt(this.deliveryStatus) === 4) {
                    try {
                        // 먼저 대여 중지 처리
                        await this.$axios.post(`${this.$apiUrls.hanqmedi}/stopRental`, {
                            orderId: this.orderId,
                            companykey: this.$globalState.company_key
                        });

                        // 대여 상태를 중지(2)로 설정
                        orderData.rental_status = 2;
                    } catch (error) {
                        console.error('대여 중지 처리 중 오류:', error);
                        // 이미 중지된 대여인 경우는 무시하고 계속 진행
                        if (!error.response?.data?.message?.includes('이미 중지된 대여')) {
                            throw error;
                        }
                    }
                }

                const response = await this.$axios.post(
                    `${this.$apiUrls.hanqmedi}/updateRental/${this.orderId}`,
                    orderData
                );

                if (response.data.statusCode !== 200) {
                    throw new Error(response.data.message || '업데이트에 실패했습니다.');
                }

                await this.$swal.fire({
                    title: '수정 완료',
                    text: '주문이 성공적으로 수정되었습니다.',
                    icon: 'success',
                    confirmButtonText: '확인'
                });

                await this.fetchOrderData();
                this.$emit('rental-status-updated');
                this.clearModalState();

            } catch (error) {
                console.error('주문 수정 중 오류 발생:', error);

                await this.$swal.fire({
                    title: '수정 실패',
                    text: error.message || '주문 수정 중 오류가 발생했습니다.',
                    icon: 'error',
                    confirmButtonText: '확인'
                });
            }
        },

        // 회수 상태 체크 메서드
        async checkReturnStatus() {
            try {
                const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/checkReturnStatus/${this.orderId}`);
                this.isReturned = response.data.isReturned;
                // 회수 정보 저장
                if (response.data.returnInfo) {
                    this.returnInfo = response.data.returnInfo;
                }
            } catch (error) {
                console.error('회수 상태 확인 중 오류 발생:', error);
            }
        },

        // 회수 등록 취소 메서드
        async handleCancelReturn() {
            try {
                const result = await this.$swal.fire({
                    title: '회수등록을 취소하시겠습니까?',
                    text: "취소 후에는 되돌릴 수 없습니다.",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: '예',
                    cancelButtonText: '아니오'
                });

                if (result.isConfirmed) {
                    const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/cancelReturnRental`, {
                        orderId: this.orderId,
                        companykey: this.$globalState.company_key
                    });

                    if (response.data.success) {
                        await this.$swal.fire({
                            icon: 'success',
                            title: '회수등록이 취소되었습니다',
                            confirmButtonText: '확인'
                        });

                        this.isReturned = false;

                        // 대여 이력 목록 새로고침 (백엔드에서 저장한 이력 반영)
                        await this.fetchRentalHistory();
                    }

                    // 상태 업데이트 이벤트 발생 및 모달 닫기
                    this.$emit('rental-status-updated', {
                        orderId: this.orderId,
                        rental_status: 0,
                        delivery_status: 2
                    });

                }
            } catch (error) {
                console.error('회수등록 취소 중 오류 발생:', error);
                await this.$swal.fire({
                    icon: 'error',
                    title: '오류 발생',
                    text: error.message || '회수등록 취소 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
            }
        },

        async handleReturnRental() {
            try {
                // 현재 선택된 제품이 있는지 확인
                if (!this.products_obj || this.products_obj.length === 0) {
                    await this.$swal.fire({
                        icon: 'error',
                        title: '오류',
                        text: '회수할 물품이 없습니다.',
                        confirmButtonText: '확인'
                    });
                    return;
                }

                const { value: formValues } = await this.$swal.fire({
                    title: '회수등록',
                    width: '55%',
                    customClass: {
                        popup: 'custom-popup-class',
                        container: 'custom-container-class'
                    },
                    html: `
                        <style>
                            .custom-popup-class {
                                max-height: 90vh;
                                overflow-y: auto;
                            }
                            .custom-container-class {
                                max-width: 100%;
                            }
                            .product-table {
                                width: 100%;
                                margin-bottom: 20px;
                            }
                            .product-table th, .product-table td {
                                padding: 12px 8px;
                                font-size: 16px;
                            }
                            .swal2-content {
                                padding: 0 20px;
                            }
                        </style>
                        <div class="mb-3" style="padding: 15px; border-radius: 5px; margin-bottom: 20px;">
                            <table class="product-table" style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
                                <thead>
                                    <tr style="background-color: #e9ecef; border-bottom: 2px solid #dee2e6;">
                                        <th style="padding: 12px; text-align: center; min-width: 60px;">선택</th>
                                        <th style="padding: 12px; text-align: center; min-width: 120px;">바코드</th>
                                        <th style="padding: 12px; text-align: center; min-width: 100px;">품목코드</th>
                                        <th style="padding: 12px; text-align: center; min-width: 150px;">품목분류</th>
                                        <th style="padding: 12px; text-align: center; min-width: 200px;">품목명</th>
                                        <th style="padding: 12px; text-align: center; min-width: 120px;">수량</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${this.products_obj.map((product, index) => `
                                        <tr style="border-bottom: 1px solid #dee2e6;">
                                            <td style="padding: 12px; text-align: center;">
                                                <input type="checkbox" id="product-${index}" 
                                                    style="width: 20px; height: 20px; cursor: pointer;">
                                            </td>
                                            <td style="padding: 12px; text-align: center;">
                                                ${product.options?.bcode[0] || '-'}
                                            </td>
                                            <td style="padding: 12px; text-align: center;">
                                                ${product.code || '-'}
                                            </td>
                                            <td style="padding: 12px; text-align: center;">
                                                ${product.b_product_id > 999999 ? product.name1 : product.name || '-'}
                                            </td>
                                            <td style="padding: 12px; text-align: center;">
                                                ${product.b_product_id > 999999 ? product.name3 : product.name2 || '-'}
                                            </td>
                                            <td style="padding: 12px; text-align: center;">
                                                ${product.quantity || 1}
                                            </td>
                                        </tr>
                                    `).join('')}
                                </tbody>
                            </table>
                        </div>
                        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
                            <div style="flex: 1; margin-right: 15px;">
                                <label class="form-label">회수 날짜&nbsp;&nbsp;</label>
                                <input type="date" id="returnDate" class="swal2-input" style="width: calc(100% - 80px); height: 40px; cursor: pointer;">
                            </div>
                            <div style="flex: 1; margin-right: 15px;">
                                <label class="form-label">회수 담당자&nbsp;&nbsp;</label>
                                <input type="text" id="returnManager" class="swal2-input" style="width: calc(100% - 95px); height: 40px;">
                            </div>
                            <div style="flex: 1;">
                                <label class="form-label">회수 사유&nbsp;&nbsp;</label>
                                <select id="returnReason" class="swal2-input" style="width: calc(100% - 80px); height: 40px; cursor: pointer;">
                                    <option value="">사유 선택</option>
                                    <option value="계약만료">계약만료</option>
                                    <option value="고장">고장</option>
                                    <option value="교체">교체</option>
                                    <option value="기타">기타</option>
                                </select>
                            </div>
                        </div>
                        <div id="otherReasonDiv" style="display: none; margin-bottom: 20px;">
                            <div style="display: flex; flex-direction: column;">
                                <label class="form-label" style="margin-bottom: 8px;">기타 사유</label>
                                <textarea 
                                    id="otherReason" 
                                    class="swal2-textarea" 
                                    style="width: 90%; height: 100px; resize: vertical;"
                                    placeholder="기타 사유를 입력해주세요"
                                ></textarea>
                            </div>
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: '회수등록',
                    cancelButtonText: '취소',
                    focusConfirm: false,
                    didOpen: () => {
                        // 오늘 날짜를 기본값으로 설정
                        const today = new Date().toISOString().split('T')[0];
                        document.getElementById('returnDate').value = today;

                        // 모든 제품 체크박스를 체크 상태로 설정
                        this.products_obj.forEach((_, index) => {
                            const checkbox = document.getElementById(`product-${index}`);
                            if (checkbox) {
                                checkbox.checked = true;
                            }
                        });

                        // 기타 사유 선택 시 텍스트영역 표시
                        document.getElementById('returnReason').addEventListener('change', (e) => {
                            const otherReasonDiv = document.getElementById('otherReasonDiv');
                            otherReasonDiv.style.display = e.target.value === '기타' ? 'block' : 'none';
                        });
                    },
                    preConfirm: () => {
                        const selectedProducts = this.products_obj.filter((_, index) =>
                            document.getElementById(`product-${index}`).checked
                        ).map(product => {
                            const isNonCovered = product.b_product_id > 999999;
                            return {
                                product_id: isNonCovered ? null : product.product_id,
                                b_product_id: isNonCovered ? product.b_product_id : null,
                                return_quantity: product.quantity || 1
                            };
                        });

                        const returnDate = document.getElementById('returnDate').value;
                        const returnManager = document.getElementById('returnManager').value;
                        const returnReason = document.getElementById('returnReason').value;
                        const otherReason = document.getElementById('otherReason').value;

                        if (selectedProducts.length === 0) {
                            this.$swal.showValidationMessage('회수할 물품을 선택해주세요');
                            return false;
                        }
                        if (!returnDate) {
                            this.$swal.showValidationMessage('회수 날짜를 선택해주세요');
                            return false;
                        }
                        if (!returnManager) {
                            this.$swal.showValidationMessage('회수 담당자를 입력해주세요');
                            return false;
                        }
                        if (!returnReason) {
                            this.$swal.showValidationMessage('회수 사유를 선택해주세요');
                            return false;
                        }
                        if (returnReason === '기타' && !otherReason) {
                            this.$swal.showValidationMessage('기타 사유를 입력해주세요');
                            return false;
                        }

                        return {
                            returnDate,
                            returnReason: returnReason === '기타' ? otherReason : returnReason,
                            returnManager,
                            products: selectedProducts
                        };
                    }
                });

                if (!formValues) return;

                // 회수 등록 API 호출
                const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/registerReturn`, {
                    orderId: this.orderId,
                    companykey: this.$globalState.company_key,
                    returnDate: formValues.returnDate,
                    returnReason: formValues.returnReason,
                    returnManager: formValues.returnManager,
                    products: formValues.products
                });

                if (response.data.success) {

                    await this.$swal.fire({
                        icon: 'success',
                        title: '회수등록이 완료되었습니다',
                        text: `회수일자: ${formValues.returnDate}\n담당자: ${formValues.returnManager}\n사유: ${formValues.returnReason}`,
                        confirmButtonText: '확인'
                    });

                    this.isReturned = true;

                    // 상태 업데이트 이벤트 발생 및 모달 닫기
                    this.$emit('rental-status-updated', {
                        orderId: this.orderId,
                        rental_status: 2,
                        delivery_status: 4
                    });

                } else {
                    throw new Error(response.data.message || '회수등록에 실패했습니다.');
                }

            } catch (error) {
                console.error('회수등록 중 오류 발생:', error);
                await this.$swal.fire({
                    icon: 'error',
                    title: '오류 발생',
                    text: error.message || '회수등록 중 오류가 발생했습니다.',
                    confirmButtonText: '확인'
                });
            }
        },

        async handleStopRental() {
            try {
                const result = await this.$swal.fire({
                    title: '대여를 중지하시겠습니까?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: '중지',
                    cancelButtonText: '취소'
                });

                if (!result.isConfirmed) return;

                const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/stopRental`, {
                    orderId: this.orderId,
                    companykey: this.$globalState.company_key
                });

                await this.$swal.fire({
                    title: '대여 중지 성공',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: '확인',
                    allowOutsideClick: false,
                });

                // 프론트엔드 상태 즉시 업데이트 (버튼 즉시 변경)
                this.client_data_obj.rental_status = 2;
                this.deliveryStatus = '3';

                // 대여 이력 목록 새로고침
                await this.fetchRentalHistory();

                // 주문 데이터 새로고침
                await this.fetchOrderData();

                // 상세 정보를 포함하여 이벤트 발생
                this.$emit('rental-status-updated', {
                    orderId: this.orderId,
                    rental_status: 2,
                    delivery_status: 3
                });

            } catch (error) {
                // 모달이 이미 닫혔는지 확인
                if (!this.$el.parentNode) return;

                // 이미 중지된 대여인 경우
                if (error.response?.data?.message === '이미 중지된 대여입니다.') {
                    await this.$swal.fire({
                        icon: 'warning',
                        title: '알림',
                        text: '이미 중지된 대여입니다.',
                        confirmButtonColor: '#3085d6'
                    });
                    return;
                }
            }
        },

        async handleStopRentalCancel() {
            try {
                const result = await this.$swal.fire({
                    title: '대여 중지를 취소하시겠습니까?',
                    text: '대여가 다시 활성화됩니다.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: '활성화',
                    cancelButtonText: '취소'
                });

                if (!result.isConfirmed) return;

                const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/cancelStopRental/${this.orderId}`, {
                    orderId: this.orderId,
                    companykey: this.$globalState.company_key,
                });

                await this.$swal.fire({
                    title: '대여 중지 취소 성공',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: '확인',
                    allowOutsideClick: false,
                });

                // 프론트엔드 상태 즉시 업데이트 (버튼 즉시 변경)
                this.client_data_obj.rental_status = 0;
                this.deliveryStatus = '2';

                // 대여 이력 목록 새로고침 (백엔드에서 저장한 이력 반영)
                await this.fetchRentalHistory();

                // 주문 데이터 새로고침
                await this.fetchOrderData();

                // 상세 정보를 포함하여 이벤트 발생
                this.$emit('rental-status-updated', {
                    orderId: this.orderId,
                    rental_status: 0,
                    delivery_status: 2
                });

            } catch (error) {
                // 모달이 이미 닫혔는지 확인
                if (!this.$el.parentNode) return;

                // 중지된 대여가 아닌 경우
                if (error.response?.data?.message?.includes('중지된 대여가 아닙니다')) {
                    await this.$swal.fire({
                        icon: 'warning',
                        title: '알림',
                        text: '중지된 대여가 아닙니다.',
                        confirmButtonColor: '#3085d6'
                    });
                    return;
                }
            }
        },

        convertToUpperCase(productIndex, sizeIndex) {
            if (this.products_obj[productIndex].sizes[sizeIndex]) {
                this.products_obj[productIndex].sizes[sizeIndex] =
                    this.products_obj[productIndex].sizes[sizeIndex].toUpperCase();
            }
        },
        async getManager() {
            try {
                const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/companyMember/${this.$globalState.company_key}`, {
                });
                const data = response.data;
                if (data.code === 200) {
                    this.manager = data.data;
                } else {
                    this.manager = [];
                }
            } catch (error) {
                console.error('매니저 정보 가져오기 실패:', error);
                this.manager = [];
            }
        },
        async deleteComment(num) {
            await this.$axios.delete(`${this.$apiUrls.hanqmedi}/comment/${this.orderId}/${num}`);
            this.commmentGet();
            this.saveModalState();
        },
        async commentAdd() {
            const formData = new FormData();
            formData.append('manager', this.$globalState.manager_name);
            formData.append('text', this.orderCommentAdd);

            // 이미지 파일들을 개별적으로 FormData에 추가
            if (this.imageFiles && this.imageFiles.length > 0) {
                this.imageFiles.forEach((file) => {
                    formData.append('files', file, file.name);
                });
            }

            if (formData.entries().next().done) {
                console.error('FormData가 비어있습니다!');
                return; // FormData가 비어있으면 요청을 보내지 않음
            }
            await this.$axios.post(`${this.$apiUrls.hanqmedi}/comment/${this.orderId}`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            this.orderCommentAdd = '';
            this.imageFiles = [];
            this.commmentGet();
            this.saveModalState();
        },
        async commmentGet() {
            this.isLoading = true;
            try {
                const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/comment/${this.orderId}`);
                this.orderComment = response.data.comment;
            } catch (error) {
                console.error('댓글을 불러오는 데 실패했습니다:', error);
                this.orderComment = [];
            }
        },
        async releaseStock() {
            await this.$axios.post(`${this.$apiUrls.hanqmedi}/releaseStock`, {
                orderkey: this.orderId,
                companykey: this.$globalState.company_key
            }).then((res) => {
                console.log(res.data)
            })
        },
        async returnRental() {
            await this.$axios.post(`${this.$apiUrls.hanqmedi}/returnRental`, {
                orderkey: this.orderId,
                companykey: this.$globalState.company_key
            }).then((res) => {
                console.log(res.data)
            })
        },
        async releaseRental() {
            await this.$axios.post(`${this.$apiUrls.hanqmedi}/releaseRental`, {
                orderkey: this.orderId,
                companykey: this.$globalState.company_key
            }).then((res) => {
                console.log(res.data)
            })
        },
        async releaseStockCancel() {
            await this.$axios.post(`${this.$apiUrls.hanqmedi}/releaseStockCancel`, {
                orderkey: this.orderId,
                companykey: this.$globalState.company_key
            }).then((res) => {
                console.log(res.data)
                //this.returnRental();
            })
        },
        changeOrderStatus(status) {
            console.log(status, this.orderId)
            this.$axios.put(`${this.$apiUrls.hanqmedi}/orderStatus`, {
                status: status == 4 ? 2 : status,
                orderId: this.orderId,
                companykey: this.$globalState.company_key
            }).then(res => {
                console.log(res)
                if (status == 3) {
                    this.releaseStock();
                    //this.releaseRental();
                } else if (status == 4) {
                    this.releaseStockCancel();
                }
                this.fetchOrderData();
            });
        },
        toggleProductSelection(index) {
            // products_obj가 존재하고 해당 인덱스의 제품이 존재하는지 확인
            if (this.products_obj && this.products_obj[index]) {
                // selected 속성이 없으면 초기화
                if (typeof this.products_obj[index].selected === 'undefined') {
                    this.$set(this.products_obj[index], 'selected', false);
                }
                // selected 값 토글
                this.products_obj[index].selected = !this.products_obj[index].selected;
            }
        },
        deleteSelectedProducts() {
            this.products_obj = this.products_obj.filter(product => !product.selected);
        },

        async fetchOrderData() {
            try {
                const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/orderDetail/${this.orderId}`);
                const orderData = response.data;

                // orderDate를 DB에서 가져온 데이터로 설정
                this.orderDate = orderData.order.orderdate ? new Date(orderData.order.orderdate) : null;

                this.initializeClientData(orderData);
                this.fetchVirtualAccountHistory();

                this.saveModalState();
            } catch (error) {
                console.error('주문 데이터를 가져오는 중 오류가 발생했습니다:', error);
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        openDaumPostcode(type) {
            const width = 500;  // 팝업 창 너비
            const height = 600; // 팝업 창 높이
            const left = Math.ceil((window.innerWidth - width) / 2);  // 화면 가로 중앙 위치
            const top = Math.ceil((window.innerHeight - height) / 2); // 화면 세로 중앙 위치
            new window.daum.Postcode({
                oncomplete: (data) => {
                    if (type == 1) {
                        this.postcode_obj.postcode1 = data.zonecode;
                        this.postcode_obj.address1 = data.address;
                        this.postcode_obj.detailAddress1 = data.buildingName;
                    } else {
                        this.postcode_obj.postcode2 = data.zonecode;
                        this.postcode_obj.address2 = data.address;
                        this.postcode_obj.detailAddress2 = data.buildingName;
                    }
                },
                width: width,
                height: height,
                left: left,
                top: top
            }).open();
        },
        handleClientDetail(client) {
            console.log('선택된 클라이언트:', client);
            this.postcode_obj.postcode1 = client.addressnum;
            this.postcode_obj.address1 = client.address;
            this.postcode_obj.detailAddress1 = client.addressdetail;
            this.postcode_obj.postcode2 = client.addressnum2;
            this.postcode_obj.address2 = client.address2;
            this.postcode_obj.detailAddress2 = client.address2detail;
            for (const key in client) {
                if (Object.hasOwnProperty.call(client, key)) {
                    const data = client[key];
                    this.client_data_obj[key] = data;
                }
            }
        },
        increaseQuantity(index) {
            const product = this.products_obj[index];
            if (!product.quantity) {
                product.quantity = 1;
            }
            if (!product.barcodes) {
                product.barcodes = [''];
            }
            if (!product.sizes) {
                product.sizes = [''];
            }
            if (!product.colors) {
                product.colors = [''];
            }
            if (!product.notes) {
                product.notes = [''];
            }
            product.quantity++;
            product.barcodes.push('');
            if (product.sizeOptions.length > 0) {
                const lastSelectedSize = product.sizes[product.sizes.length - 1] || product.sizeOptions[0];
                product.sizes.push(lastSelectedSize);
            }
            if (product.colorOptions.length > 0) {
                const lastSelectedColor = product.colors[product.colors.length - 1] || product.colorOptions[0];
                product.colors.push(lastSelectedColor);
            }
            product.notes.push('');
            this.updatePrice(index);

        },

        decreaseQuantity(index) {
            const product = this.products_obj[index];
            product.quantity--;
            this.updatePrice(index);

            if (product.quantity <= 0) {
                // 수량이 0 이하가 되면 제품을 배열에서 제거
                this.products_obj.splice(index, 1);
            } else {
                // 수량이 1 이상이면 마지막 바코드와 노트 제거
                product.barcodes.pop();
                product.sizes.pop();
                product.colors.pop();
                product.notes.pop();
            }
        },

        removeBarcodeField(productIndex, barcodeIndex) {
            const product = this.products_obj[productIndex];
            product.barcodes.splice(barcodeIndex, 1);
            product.notes.splice(barcodeIndex, 1);
            product.quantity--;
            if (product.quantity <= 0) {
                // 수량이 0 이하가 되면 제품을 배열에서 제거
                this.products_obj.splice(productIndex, 1);
            }
        },

        updatePrice(index) {
            const product = this.products_obj[index];
            if (product.target === '대여') {
                if (!product.baseRentPrice) {
                    product.baseRentPrice = product.rentprice;
                }
                product.setRentprice = product.baseRentPrice * product.quantity;
            } else {
                if (!product.baseBuyPrice) {
                    product.baseBuyPrice = product.buyprice;
                }
                product.setBuyprice = product.baseBuyPrice * product.quantity;
            }
        },

        handleProductDetail(product) {
            console.log('선택된 제품:', product);
            const newProduct = JSON.parse(JSON.stringify(toRaw(product)));

            // 색상과 사이즈 옵션 미리 처리
            let colorOptions = [];
            let sizeOptions = [];

            if (product.color) {
                colorOptions = product.color.split(',');
            }
            if (product.size) {
                sizeOptions = product.size.split(',');
            }

            // 동일 제품 확인
            const existingProductIndex = this.products_obj.findIndex(p =>
                p.code === product.code &&
                JSON.stringify(p.colorOptions) === JSON.stringify(colorOptions) &&
                JSON.stringify(p.sizeOptions) === JSON.stringify(sizeOptions)
            );

            if (existingProductIndex !== -1) {
                // 동일한 제품이 존재하는 경우 수량만 증가
                this.increaseQuantity(existingProductIndex);
                this.updatePrice(existingProductIndex);
            } else {
                // 새로운 제품 추가
                // 1. 기본 가격 설정
                if (product.b_product_id > 999999) {
                    newProduct.baseBuyPrice = product.buyprice || 0;
                    newProduct.baseRentPrice = product.rentprice || 0;
                    newProduct.setBuyprice = product.buyprice || 0;
                    newProduct.setRentprice = product.rentprice || 0;
                    newProduct.name = product.b_product_id > 999999 ? product.name3 : product.name;
                    newProduct.name1 = product.name;
                    newProduct.name2 = product.name2;
                    newProduct.name3 = product.name3;
                    newProduct.name4 = product.name4;
                } else {
                    newProduct.baseBuyPrice = product.buyprice || 0;
                    newProduct.baseRentPrice = product.rentprice || 0;
                    newProduct.setBuyprice = product.target === '대여' ? 0 : (product.buyprice || 0);
                    newProduct.setRentprice = product.target === '대여' ? (product.rentprice || 0) : 0;
                }

                // 2. 기본 정보 설정
                newProduct.quantity = 1;
                newProduct.selected = false;

                // 4. 제품 추가 및 가격 업데이트
                this.products_obj.push(newProduct);
                this.updatePrice(this.products_obj.length - 1);
            }
        },

        getTodayDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        submitOrder() {
            const orderData = {
                orderdate: this.orderDate,
                name: this.client_data_obj.name,
                number: this.client_data_obj.number,
                resident: this.client_data_obj.regident,
                addressnum: this.postcode_obj.postcode1,
                address: this.postcode_obj.address1,
                addressdetail: this.postcode_obj.detailAddress1,
                addressnum2: this.postcode_obj.postcode2,
                address2: this.postcode_obj.address2,
                address2detail: this.postcode_obj.detailAddress2,
                guardname: this.client_data_obj.guardname,
                guardtarget: this.client_data_obj.guardtarget,
                phone1: this.client_data_obj.phone1,
                phone2: this.client_data_obj.phone2,
                centername: this.client_data_obj.centername,
                manager: this.client_data_obj.manager,
                rental_start: this.format.date(this.client_data_obj.rental_start),
                rental_end: this.format.date(this.client_data_obj.rental_end),
                rental_status: this.client_data_obj.rental_status,
                oxygen_start: this.format.date(this.client_data_obj.oxygen_start),
                oxygen_end: this.format.date(this.client_data_obj.oxygen_end),
                diabetes_start: this.format.date(this.client_data_obj.diabetes_start),
                diabetes_end: this.format.date(this.client_data_obj.diabetes_end),
                business: "",
                delivery_method: parseInt(this.deliveryMethod),
                delivery_status: parseInt(this.deliveryStatus),
                delivery_date: this.delivery_date ? this.format.date(this.delivery_date) : null,
                delivery_time: parseInt(this.delivery_time),
                comment: this.orderComment,
                products: this.products_obj.map(product => ({
                    id: product.product_id || product.b_product_id || product.num,
                    quantity: product.quantity,
                    options: {
                        size: product.sizes,
                        color: product.colors,
                        note: product.notes,
                        bcode: product.barcodes
                    }
                })),
                member_id: this.$globalState.id // 실제 사용자 ID로 변경 필요
            };

            this.$axios.put(`${this.$apiUrls.hanqmedi}/order/${this.orderId}`, orderData)
                .then(response => {
                    this.$swal.fire({
                        title: '주문 수정 성공',
                        text: '주문 수정이 성공적으로 제출되었습니다.',
                        icon: 'success',
                        confirmButtonText: '확인',
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.fetchOrderData();
                        }
                    });

                })
                .catch(error => {
                    console.error('주문 제출 중 오류가 발생했습니다:', error);
                    // 오류 메시지 표시
                });
        },
        // 주문 데이터 초기화
        async initializeClientData(orderData) {
            if (!orderData) return;

            // 클라이언트 기본 정보 설정
            this.client_data_obj.name = orderData.order.name || '';
            this.client_data_obj.number = orderData.order.number || '';
            this.client_data_obj.regident = orderData.order.resident || '';
            // 주소 정보 설정
            this.postcode_obj.postcode1 = orderData.order.addressnum || '';
            this.postcode_obj.address1 = orderData.order.address || '';
            this.postcode_obj.detailAddress1 = orderData.order.addressdetail || '';
            this.postcode_obj.postcode2 = orderData.order.addressnum2 || '';
            this.postcode_obj.address2 = orderData.order.address2 || '';
            this.postcode_obj.detailAddress2 = orderData.order.address2detail || '';
            // 보호자 및 연락처 정보 설정
            this.client_data_obj.guardname = orderData.order.guardname || '';
            this.client_data_obj.guardtarget = orderData.order.guardtarget || '';
            this.client_data_obj.phone1 = orderData.order.phone1 || '';
            this.client_data_obj.phone2 = orderData.order.phone2 || '';
            // 센터 및 담당자 정보 설정
            this.client_data_obj.centername = orderData.order.centername || '';
            // this.client_data_obj.manager = orderData.order.manager || '';
            if (orderData.order.manager) {
                this.client_data_obj.manager = orderData.order.manager;
            }
            // 대여 기간 설정
            if (orderData.order.rental_start) {
                this.client_data_obj.rental_start = new Date(orderData.order.rental_start);
            }
            if (orderData.order.rental_end) {
                this.client_data_obj.rental_end = new Date(orderData.order.rental_end);
            }
            this.client_data_obj.rental_status = orderData.order.rental_status;
            // 산소치료 처방기간 설정
            this.client_data_obj.oxygen_start = orderData.order.oxygen_start ? new Date(orderData.order.oxygen_start) : null;
            this.client_data_obj.oxygen_end = orderData.order.oxygen_end ? new Date(orderData.order.oxygen_end) : null;
            // 당뇨소모성재료 처방기간 설정
            this.client_data_obj.diabetes_start = orderData.order.diabetes_start ? new Date(orderData.order.diabetes_start) : null;
            this.client_data_obj.diabetes_end = orderData.order.diabetes_end ? new Date(orderData.order.diabetes_end) : null;
            // 기타 주문 정보 설정
            this.salesPerson = orderData.order.business || '없음';
            this.deliveryMethod = orderData.order.delivery_method;
            this.deliveryStatus = orderData.order.delivery_status;
            // 배송 날짜 및 시간 설정
            if (orderData.order.delivery_date) {
                this.delivery_date = new Date(orderData.order.delivery_date);
            }
            // delivery_time 설정
            this.delivery_time = orderData.order.delivery_time?.toString() || "0";
            this.orderStatus = orderData.order.status;

            // 제품 정보 초기화
            this.products_obj = [];

            const products = Array.isArray(orderData.products) ? orderData.products : [];

            if (products.length > 0) {
                this.products_obj = await Promise.all(products.map(async product => {

                    // 기본 옵션 배열 초기화
                    const quantity = product.quantity || 1;

                    // 수량 값 검증 추가
                    const validQuantity = Math.max(1, Math.min(10000, parseInt(quantity) || 1));

                    const defaultOptions = {
                        bcode: Array(validQuantity).fill(''),
                        color: Array(validQuantity).fill(''),
                        note: Array(validQuantity).fill(''),
                        size: Array(validQuantity).fill('')
                    };

                    // options 객체가 있는 경우 기존 값을 유지하면서 빈 값은 기본값으로 설정
                    const options = {
                        bcode: (product.options?.bcode || defaultOptions.bcode).slice(0, validQuantity),
                        color: (product.options?.color || defaultOptions.color).slice(0, validQuantity),
                        note: (product.options?.note || defaultOptions.note).slice(0, validQuantity),
                        size: (product.options?.size || defaultOptions.size).slice(0, validQuantity)
                    };

                    const baseProduct = {
                        rental_start: orderData.order.rental_start ? new Date(orderData.order.rental_start) : null,
                        rental_end: orderData.order.rental_end ? new Date(orderData.order.rental_end) : null,
                        quantity: validQuantity,
                        options,
                        selected: false
                    };

                    // 비급여 제품인 경우
                    if (product.b_product_id > 999999) {
                        return {
                            ...product,
                            ...baseProduct,
                            name: product.name,
                            name1: product.name1,
                            name2: product.name2,
                            name3: product.name3,
                            name4: product.name4,
                            setBuyprice: product.buyprice * quantity,
                            setRentprice: product.rentprice * quantity,
                        };
                    } else {
                        // 급여 제품인 경우
                        const productResponse = await this.$axios.post(`${this.$apiUrls.hanq}/orderupproductload`, {
                            target: product.target,
                            number: product.code
                        });

                        const productResult = productResponse.data.result[0];
                        return {
                            ...product,
                            ...baseProduct,
                            name: product.name,
                            name2: product.name2,
                            name1: '',
                            name3: '',
                            name4: '',
                            setBuyprice: productResult.buyprice * quantity,
                            setRentprice: productResult.rentprice * quantity,
                        };
                    }
                }));
            }

            this.$swalClose();
        },

        // 연장 기간 포맷팅
        formatPeriodRange(startDate, endDate) {
            if (!startDate || !endDate) return '';

            const start = new Date(startDate);
            const end = new Date(endDate);

            const startMonth = start.getMonth() + 1;
            const startDay = start.getDate();
            const endMonth = end.getMonth() + 1;
            const endDay = end.getDate();

            // 일수 계산
            const diffTime = Math.abs(end - start);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            const months = Math.floor(diffDays / 30);
            const days = diffDays % 30;

            return `${startMonth}월 ${startDay}일 ~ ${endMonth}월 ${endDay}일 (${months}개월 ${days}일)`;
        },

        showDevelopmentMessage() {
            this.$swal.fire({
                title: '개발 중',
                text: '현재 개발 중인 기능입니다.',
                icon: 'info',
                confirmButtonColor: '#3085d6',
                confirmButtonText: '확인'
            });
        }
    },

    async mounted() {
        this.isLoadingClaimInfo = true;

        this.restoreModalState();

        this.fetchOrderData()

        // 그 다음 주문 타입을 확인 (orderId가 설정된 후)
        if (this.orderId || this.$route.params.id) {
            const orderIdToUse = this.orderId || this.$route.params.id;
            await this.fetchOrderType(orderIdToUse);
        }

        try {
            // 모든 데이터 요청을 병렬로 실행
            await Promise.all([
                this.commmentGet(),
                this.getManager(),
                this.fetchImages(),
                this.checkReturnStatus(),
                this.loadClaimStatus(),
                this.fetchRentalHistory()
            ]);

            this.isLoadingClaimInfo = false;

            // 데이터 로드 후 상태 저장
            this.saveModalState();

        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
            this.$swal.fire({
                title: '오류',
                text: '데이터를 불러오는데 실패했습니다.',
                icon: 'error'
            });

            this.isLoadingClaimInfo = false;
        }

        this.$watch(
            () => [
                this.client_data_obj,
                this.postcode_obj,
                this.delivery_date,
                this.delivery_time,
                this.deliveryMethod,
                this.deliveryStatus,
                this.products_obj,
                this.orderComment,
                this.orderCommentAdd,
                this.showModal_obj
            ],
            () => {
                this.saveModalState();
            },
            { deep: true }
        );
    },

    deactivated() {
        this.saveModalState();
    },

    beforeUnmount() {
        document.body.style.overflow = 'auto';
        this.saveModalState();
    },

    watch: {
        paymentMethod(newVal, oldVal) {
            // 초기화 중에는 처리하지 않음
            if (this.isInitializingPaymentMethod) {
                return;
            }
        },

        virtualAccountHistory: {
            handler() {
                // groupedRentalHistory computed가 자동으로 재계산됨
            },
            deep: true
        },
    },
};
</script>

<style>
/* 기본 블러 효과 */
.blurred {
    filter: blur(4px) !important;
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}

/* 메모 내용에만 블러 효과 적용하는 방법 4: 직접 타겟팅 */
.memo-text-blur {
    filter: blur(4px) !important;
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}
</style>